webpackJsonp([3],{

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_vue__ = __webpack_require__(698);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ec106b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__ = __webpack_require__(761);
function injectStyle (ssrContext) {
  __webpack_require__(740)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ec106b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config_api__ = __webpack_require__(246);
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VisibleFor',

  props: __WEBPACK_IMPORTED_MODULE_0_config_api__["a" /* default */].roles,

  data: function data() {
    return {
      visible: false,
      userRol: null
    };
  },

  created: function created() {
    this.userRol = this.$store.getters['api/getUserRol'];
    this.checkUserPrivileges();
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkUserPrivileges: function checkUserPrivileges() {
      this.visible = typeof this.$props[this.userRol] !== 'undefined';
    }
  }
});

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(557);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isTrue: function isTrue(message) {
        return function (v) {
          return v === true || message || 'Campo requerido';
        };
      },
      isRequired: function isRequired(message) {
        return function (v) {
          if (v && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(v).length > 0) {
            return true;
          }
          return !!v && v.length > 0 || message || 'Campo requerido';
        };
      },
      isEmail: function isEmail(v) {
        if (!v.length > 0) return true;
        var regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        return regex.test(v) || 'Correo electrónico no válido';
      },
      isComposedBy: function isComposedBy(option, value) {
        var regex = {
          'letters|numbers': /^[A-zÀ-ÖØ-öø-ÿ0-9]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9]*$/,
          'letters|numbers|spaces': /^[A-zÀ-ÖØ-öø-ÿ0-9 ]*[A-zÀ-ÖØ-öø-ÿ0-9][A-zÀ-ÖØ-öø-ÿ0-9 ]*$/,
          'numbers': /^[0-9]*[0-9][0-9]*$/
        };
        var msg = {
          'letters|numbers': 'Solo números y letras están permitidos',
          'letters|numbers|spaces': 'Solo números, letras y espacios están permitidos',
          'numbers': 'Solo números están permitidos'
        };
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return regex[option].test(v[value]) || msg[option];
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return regex[option].test(value);
            }) || msg[option];
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return regex[option].test(v) || msg[option];
          };
        }
        return true;
      },
      hasLength: function hasLength(chars, value) {
        var msg = 'Debe contener ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length === chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length === chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return !!v && v.length === chars || msg;
          };
        }
        return true;
      },
      hasMaxLength: function hasMaxLength(chars, value) {
        var msg = 'No debe exceder de ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length <= chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length <= chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return v.length <= chars || msg;
          };
        }
        return true;
      },
      hasMinLength: function hasMinLength(chars, value) {
        var msg = 'Debe contener un mínimo de ' + chars + ' caracteres';
        if (typeof value !== 'undefined' && typeof value === 'string') {
          return function (v) {
            return v[value].length >= chars || msg;
          };
        } else if (typeof value !== 'undefined') {
          return function (v) {
            return v.every(function (value) {
              return value.length >= chars;
            }) || msg;
          };
        } else if (typeof value === 'undefined') {
          return function (v) {
            return v.length >= chars || msg;
          };
        }
        return true;
      }
    };
  },


  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setRules: function setRules(rules, value) {
      var items = [];
      for (var rule in rules) {
        rule = rules[rule].split(':');
        switch (rule[0]) {
          case 'required':
            items.push(this.isRequired(rule[1] || null));
            break;
          case 'is_true':
            items.push(this.isTrue(rule[1] || null));
            break;
          case 'has_length':
            items.push(this.hasLength(parseInt(rule[1]), value));
            break;
          case 'has_min_length':
            items.push(this.hasMinLength(parseInt(rule[1]), value));
            break;
          case 'has_max_length':
            items.push(this.hasMaxLength(parseInt(rule[1]), value));
            break;
          case 'is_composed_by':
            items.push(this.isComposedBy(rule[1]));
            break;
          case 'is_email':
            items.push(this.isEmail);
            break;
        }
      }
      return items;
    }
  }
});

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(523), __esModule: true };

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(524);
module.exports = __webpack_require__(12).Object.assign;


/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(20);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(525) });


/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(63);
var gOPS = __webpack_require__(526);
var pIE = __webpack_require__(527);
var toObject = __webpack_require__(62);
var IObject = __webpack_require__(245);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(41)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ 526:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 527:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 528:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_form_creator_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458ae02a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_form_creator_vue__ = __webpack_require__(604);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_form_creator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_458ae02a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_form_creator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_select_vue__ = __webpack_require__(539);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4baeca00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_select_vue__ = __webpack_require__(576);
function injectStyle (ssrContext) {
  __webpack_require__(574)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4baeca00_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(531);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(532), __esModule: true };

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(533);
var $Object = __webpack_require__(12).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(20);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(21), 'Object', { defineProperty: __webpack_require__(28).f });


/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyDatePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: '',
      menu: false,
      dateFormatted: null
    };
  },

  created: function created() {
    this.itemValue = this.item.value;
  },


  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.itemValue);
    }
  },

  watch: {
    itemValue: {
      handler: function handler(val, oldVal) {
        console.log(val);
        this.dateFormatted = this.formatDate(this.itemValue);
        this.$emit('on-change', this.itemValue, oldVal, this.item, true);
      },
      deep: true
    },
    value: {
      handler: function handler(val, oldVal) {
        this.itemValue = val;
        this.$emit('on-change', val, oldVal, this.item, true);
      },
      deep: true
    }
  },

  methods: {
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '-' + month + '-' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      // const [month, day, year] = date.split('-')
      // return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`

      var _date$split3 = date.split('-'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return day + '-' + month + '-' + year;
    }
  }
});

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visible_for_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320c9e8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visible_for_vue__ = __webpack_require__(536);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visible_for_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_320c9e8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visible_for_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',[_vm._t("content")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fields_vuetify_text_field__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_vuetify_select__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_vuetify_date_picker__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_vuetify_time_picker__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_vuetify_radio_card_vuetify_radio_card__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_vuetify_select_file__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fields_vuetify_places_autocomplete__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fields_vuetify_switch__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fields_vuetify_radio_group__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fields_vuetify_checkbox__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fields_vuetify_link__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fields_vuetify_slider__ = __webpack_require__(600);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyFormCreator',

  components: {
    VuetifyTextField: __WEBPACK_IMPORTED_MODULE_1__fields_vuetify_text_field__["a" /* default */],
    VuetifySelect: __WEBPACK_IMPORTED_MODULE_2__fields_vuetify_select__["a" /* default */],
    VuetifyDatePicker: __WEBPACK_IMPORTED_MODULE_3__fields_vuetify_date_picker__["a" /* default */],
    VuetifyTimePicker: __WEBPACK_IMPORTED_MODULE_4__fields_vuetify_time_picker__["a" /* default */],
    VuetifyRadioCard: __WEBPACK_IMPORTED_MODULE_5__fields_vuetify_radio_card_vuetify_radio_card__["a" /* default */],
    VuetifySelectFile: __WEBPACK_IMPORTED_MODULE_6__fields_vuetify_select_file__["a" /* default */],
    VuetifyPlacesAutocomplete: __WEBPACK_IMPORTED_MODULE_7__fields_vuetify_places_autocomplete__["default"],
    VuetifySwitch: __WEBPACK_IMPORTED_MODULE_8__fields_vuetify_switch__["a" /* default */],
    VuetifyRadioGroup: __WEBPACK_IMPORTED_MODULE_9__fields_vuetify_radio_group__["a" /* default */],
    VuetifyCheckbox: __WEBPACK_IMPORTED_MODULE_10__fields_vuetify_checkbox__["a" /* default */],
    VuetifyLink: __WEBPACK_IMPORTED_MODULE_11__fields_vuetify_link__["a" /* default */],
    VuetifySlider: __WEBPACK_IMPORTED_MODULE_12__fields_vuetify_slider__["a" /* default */]
  },

  data: function data() {
    return {
      fields: [],
      isValid: false,
      loader: null,
      newWindowContent: null
    };
  },

  props: {
    columns: {
      type: String,
      default: 'xs12 sm10 md8 lg6'
    },
    items: {
      type: Array,
      default: null,
      required: true
    },
    validate: {
      type: Boolean,
      default: false,
      required: false
    },
    fluid: {
      type: Boolean,
      default: true,
      required: false
    },
    validateOnChanged: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  created: function created() {
    this.normalizeParams(this.items);
  },


  methods: {
    /**
     * Normalize parameters by adding optional parameters.
     *
     * @param {Object} self
     */
    normalizeParams: function normalizeParams(items) {
      this.fields = [];
      var self = this;
      items.map(function (obj, index) {
        obj.index = obj.index || index;
        obj.valid = obj.valid || false;
        self.fields.push(obj);
        return obj;
      });
      if (this.validateOnChanged) {
        this.validateForm();
      }
    },
    validateForm: function validateForm() {
      if (this.$refs.form_creator) {
        this.isValid = this.$refs.form_creator.validate();
        return this.isValid;
      }
      return false;
    },
    reset: function reset() {
      this.$refs.form_creator.reset();
    },
    openNewWindow: function openNewWindow(item) {
      if (item.open_new_window) {
        if (this.newWindowContent === null || this.newWindowContent && this.newWindowContent.closed) {
          this.newWindowContent = window.open('', '_blank');
        }
      }
    },
    onAddItem: function onAddItem() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['on-add-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
    },

    /*
    onKeyup (...params) {
      this.$emit('update:validate', this.isValid)
    },
    */
    onClickButton: function onClickButton(item) {
      // console.log('-------------', item)
      item.newWindowContent = this.newWindowContent;
      if (item.loading === false) {
        item.loading = true;
      }
      if (item.validate_on_click) {
        this.validateForm();
      }
      this.$emit('on-click-button', item, this.isValid);
    },
    onChange: function onChange() {
      for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['on-change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
    },
    onBlur: function onBlur() {
      for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['on-blur'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(params)));
    },
    setClassButton: function setClassButton(item) {
      var align = '';
      switch (item.align || '') {
        case 'left':
          align = 'align-btn-left';
          break;
        case 'right':
          align = 'align-btn-right';
          break;
        case 'center':
          align = 'align-btn-center';
          break;
      }
      return align;
    }
  },

  watch: {
    items: {
      handler: function handler(newVal, oldVal) {
        this.normalizeParams(newVal);
      },
      deep: true
    },
    isValid: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:validate', newVal);
      },
      deep: true
    }
  }
});

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyTextField',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: '',
      visibility: false,
      editable: false,
      oldVal: ''
    };
  },

  created: function created() {
    this.itemValue = this.value || this.itemValue;
    this.oldVal = this.itemValue;
    this.isEditable();
  },


  watch: {
    itemValue: {
      handler: function handler(val, oldVal) {
        this.oldVal = this.oldVal !== this.itemValue ? this.itemValue : this.oldVal;
        this.$emit('on-keyup', val, this.oldVal, this.item, this.isValid());
      },
      deep: true
    },
    value: {
      handler: function handler(val, oldVal) {
        this.itemValue = val;
        this.$emit('on-change', val, oldVal, this.item, this.isValid());
        this.oldVal = this.oldVal !== this.itemValue ? this.itemValue : this.oldVal;
        this.isEditable();
      },
      deep: true
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      this.isEditable();
      if (this.editable && this.item.focusNextOnEnter) {
        if (event.target.form && event.target.form[this.item.index + 1]) {
          event.target.form[this.item.index + 1].focus();
        }
      }
    },
    isValid: function isValid() {
      var _this = this;

      var isValid = true;
      if (this.item.rules) {
        this.item.rules.forEach(function (rule) {
          if (rule(_this.itemValue) !== true) {
            isValid = false;
          }
        });
      }
      this.item.valid = isValid;
      return isValid;
    },
    isEditable: function isEditable() {
      this.editable = (this.item.editable || false) && this.isValid() && this.itemValue !== '';
    },
    onBlur: function onBlur(event) {
      this.$emit('on-blur', this.itemValue, this.val, this.item, this.isValid());
      this.isEditable();
    }
  }
});

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifySelect',

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: '',
      editable: false,
      oldVal: '',
      search: null,
      currentValue: '',
      filteredItems: false
    };
  },

  created: function created() {
    this.itemValue = this.value || this.itemValue;
    this.oldVal = this.itemValue;
    this.isEditable();
  },


  watch: {
    itemValue: {
      handler: function handler(val, oldVal) {
        if (val) {
          this.$emit('on-change', val, oldVal, this.item, this.isValid());
          this.oldVal = this.itemValue;
          if (this.$refs.dialog) {
            this.$refs.dialog.isActive = false;
          }
        }
      },
      deep: true
    },
    value: {
      handler: function handler(newVal, oldVal) {
        this.itemValue = newVal;
        this.oldVal = oldVal;
        this.isEditable();
      },
      deep: true
    },
    search: function search(newVal) {
      if (this.$refs.select) {
        this.filteredItems = this.$refs.select.filteredItems.length > 0;
      }
      if (newVal) {
        this.currentValue = newVal;
      }
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      this.isEditable();
      if (this.editable && this.item.focusNextOnEnter) {
        if (event.target.form && event.target.form[this.item.index + 1]) {
          event.target.form[this.item.index + 1].focus();
        }
      }
    },
    isValid: function isValid() {
      var _this = this;

      var isValid = true;
      if (this.item.rules) {
        this.item.rules.forEach(function (rule) {
          var key = _this.item.item_value || 'item_value';
          var value = _this.itemValue[key] || _this.itemValue;
          if (rule(value) !== true) {
            isValid = 22222;
          }
        });
      }
      this.item.valid = isValid;
      return isValid;
    },
    isEditable: function isEditable() {
      this.editable = (this.item.editable || false) && this.isValid() && this.itemValue !== '';
    },
    getItemText: function getItemText(item) {
      if (item.return_object) {
        var prependText = item.prepend_text || '';
        var key = item.item_text || 'item_text';
        var value = typeof this.itemValue[key] !== 'undefined' ? this.itemValue[key] : this.itemValue;
        return prependText + value;
      }
      this.itemValue = item.value;
      return this.itemValue;
    },
    onAddItem: function onAddItem(event) {
      if (this.item.add_on_enter) {
        this.itemValue = this.currentValue;
        this.$emit('on-add-item', this.currentValue, this.oldVal, this.item, this.isValid());
      }
    }
  }
});

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyTimePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: '',
      menu: false,
      dateFormatted: null
    };
  },

  created: function created() {
    this.itemValue = this.item.value;
  },


  watch: {
    itemValue: {
      handler: function handler(val, oldVal) {
        this.$emit('on-change', val, '', this.item, true);
      },
      deep: true
    },
    value: {
      handler: function handler(val, oldVal) {
        this.itemValue = val;
        this.$emit('on-change', val, '', this.item, true);
      },
      deep: true
    }
  }
});

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuetify_select_file__ = __webpack_require__(542);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyRadioCard',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      default: null,
      required: true
    },
    rules: {
      type: Array,
      default: null
    },
    avatars: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    selected: {
      type: Object,
      default: null
    },
    valid: {
      type: Boolean,
      default: false
    },
    aggregator: {
      type: Object,
      default: null
    }
  },
  components: {
    VuetifySelectFile: __WEBPACK_IMPORTED_MODULE_0__vuetify_select_file__["a" /* default */]
  },
  data: function data() {
    return {
      items: null,
      itemSelected: null,
      itemValue: '',
      itemRules: [function (v) {
        return !!v || '';
      }],
      isValid: false,
      dialog: false,
      avatar: 0,
      gender: null,
      name: '',
      defaultAvatars: [{
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/1.png'
      }, {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/2.png'
      }, {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/3.jpg'
      }, {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/4.png'
      }, {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/5.jpg'
      }]
    };
  },

  mounted: function mounted() {
    this.defaultAvatars = this.avatars || this.defaultAvatars;
    this.items = this.options || this.items;
    this.itemSelected = this.selected || this.itemSelected;
    this.itemValue = this.value || this.itemValue;
    this.itemRules = this.rules || this.itemRules;
  },


  watch: {
    gender: function gender() {
      this.validateForm();
    },
    name: function name() {
      this.validateForm();
    }
  },
  methods: {
    getFirstWord: function getFirstWord(text) {
      return text.split(' ')[0];
    },
    selectItem: function selectItem(item) {
      this.$refs.radio_group.reset();
      this.itemValue = item.value;
      this.itemSelected = item;
      this.$emit('change', item);
    },
    reset: function reset() {
      this.name = '';
      this.avatar = 0;
      this.gender = null;
      this.$refs.name.reset();
    },
    addItem: function addItem(item) {
      var _this = this;

      this.dialog = false;
      var newItem = {
        text: this.name,
        value: '0',
        gender: this.gender,
        avatar: this.defaultAvatars[this.avatar].src
      };
      var index = this.items.push(newItem) - 1;
      this.items[index].value = (index + 1).toString();
      this.$emit('on-add-item', this.items[index]);
      this.selectItem(this.items[index]);
      setTimeout(function () {
        _this.reset();
      }, 1000);
    },
    validateForm: function validateForm() {
      if (this.$refs.name.validate() && this.gender) {
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    }
  }
});

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_select_file_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5baf16e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_select_file_vue__ = __webpack_require__(584);
function injectStyle (ssrContext) {
  __webpack_require__(582)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5baf16e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_select_file_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5baf16e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_select_file_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vuetify_select__ = __webpack_require__(529);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// https://gist.githubusercontent.com/ecmel/3d3d918f403140ff563d274c773508bf/raw/00ee8a3db7751e1fc2e4676e3d666246a10bf554/select-file.vue


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VuetifySelectFile',
  components: {
    VuetifySelect: __WEBPACK_IMPORTED_MODULE_0__vuetify_select__["a" /* default */]
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: null
    },
    accept: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    item: {
      type: 'select',
      label: '¿Quién eres?',
      columns: 'xs12 sm12 md12 lg12',
      value: '',
      itemText: 'name',
      itemValue: 'name',
      avatars: false,
      options: [{
        seller_id: '1',
        name: 'Diego',
        icon: 'account_box',
        label: true,
        chipColor: 'primary',
        iconColor: 'white',
        textColor: 'white'
      }, {
        seller_id: '1',
        name: 'Ana',
        icon: 'account_box',
        label: true,
        chipColor: 'primary',
        iconColor: 'white',
        textColor: 'white'
      }],
      default: {
        parent: 'sellerName',
        seller_id: '',
        seller_name: '',
        icon: 'account_box',
        label: true,
        chipColor: 'primary',
        iconColor: 'white',
        textColor: 'white'
      },
      rules: [],
      required: true,
      autocomplete: true,
      disabled: false,
      chips: true,
      addOnEnter: true,
      hideSelected: true,
      noDataText: 'Pulsa enter para agregar vendedor'
    },
    fetch: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      items: this.value ? this.value.slice() : [],
      dialog: false,
      data: null,
      type: null,
      selected_: null
    };
  },

  computed: {
    selected: {
      get: function get() {
        return this.selected_;
      },
      set: function set(value) {
        if (this.data) {
          URL.revokeObjectURL(this.data);
        }

        if (value) {
          this.data = URL.createObjectURL(value.file || value.blob);
          this.type = value.type;
          this.dialog = true;
        } else {
          this.dialog = false;
          this.type = null;
          this.data = null;
        }

        this.selected_ = value;
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.selected = null;
  },

  methods: {
    clicked: function clicked() {
      this.$refs.input.click();
    },
    changed: function changed(files) {
      if (files.length === 0) {
        return;
      }

      var types = this.accept ? this.accept.split(',') : [];

      var update = false;

      for (var i = 0, file, push; i < files.length; i++) {
        file = files[i];

        push = this.accept === null;

        for (var j = 0, type; j < types.length; j++) {
          type = types[j].trim();

          if (type === file.type || type.endsWith('*') && file.type.startsWith(type.substring(0, type.length - 1))) {
            push = true;
            break;
          }
        }

        for (var _j = 0, item; _j < this.item.value.length; _j++) {
          item = this.item.value[_j];

          if (item.name === file.name) {
            push = false;
            break;
          }
        }

        if (push) {
          this.item.value.push({
            name: file.name,
            type: file.type,
            size: file.size,
            file: file
          });
          update = true;
        }
      }

      this.$refs.input.value = '';

      if (update) {
        this.update();
      }
    },
    remove: function remove(index) {
      this.item.value.splice(index, 1);
      this.update();
    },
    update: function update() {
      this.$emit('change', this.item.value.slice());
    },
    preview: function preview(item) {
      var _this = this;

      if (item.file || item.blob) {
        this.selected = item;
      } else if (this.fetch) {
        this.fetch(item).then(function () {
          _this.selected = item;
        });
      }
    }
  }
});

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
'use strict'

export default {

  name: 'VuetifyPlacesAutocomplete',

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    mapConfig: {
      type: Object,
      default: v => {
        return {
          center: {lat: 41.390205, lng: 2.170190},
          zoom: 14,
          mapTypeId: 'roadmap',
          disableDefaultUI: true,
          fullscreenControl: true,
          zoomControl: false,
          streetViewControl: false
        }
      }
    },
    value: {
      default: null
    },
    rules: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    searchBox: null,
    searchValue: '',
    fullAddress: '',
    map: null,
    markers: [],
    itemValue: null,
    isSearch: false,
    address: null,
    errorMessages: [],
    isValid: false,
    all: [],
    showInput: false
  }),

  mounted () {
    this.normalizeParams()
    this.createMap()
    this.searchBoxRegister(this)
  },

  created () {
    setTimeout(() => {
      this.showInput = true
    }, 1500)
  },

  watch: {
    itemValue: function (newVal, oldVal) {
      this.$emit('change', newVal)
      this.$emit('on-change', newVal, oldVal, this.item)
    }
  },

  methods: {
    normalizeParams () {
      this.address = this.item.options
      this.itemValue = this.value || this.itemValue
    },
    getTypeByName (name) {
      let type = false
      this.address.forEach((section, sectionIndex) => {
        let itemIndex = section.fields.findIndex(item => item.name === name)
        if (itemIndex > -1) {
          type = this.address[sectionIndex].fields[itemIndex].type
        }
      })
      return type
    },
    setValueByName (name, value) {
      this.address.forEach((section, sectionIndex) => {
        let itemIndex = section.fields.findIndex(item => item.name === name)
        if (itemIndex > -1) {
          this.address[sectionIndex].fields[itemIndex].value = value
        }
      })
    },
    resetValues () {
      this.address.forEach((section, sectionIndex) => {
        section.fields.forEach((item, itemIndex) => {
          if (item.required && item.value.length > 0) {
            item.value = ''
          }
        })
      })
    },
    getFullAddress (self) {
      this.fullAddress = ''
      this.address.forEach((section, sectionIndex) => {
        section.fields.forEach((item, itemIndex) => {
          if (item.required && item.value.length > 0) {
            self.fullAddress += item.value + ' '
          }
        })
      })
    },
    validateForm () {
      let value = {}
      let state = true
      this.errorMessages = []
      this.address.forEach((section, sectionIndex) => {
        section.fields.forEach((item, itemIndex) => {
          value[item.name] = item.value
          if (item.rules) {
            item.rules.forEach((rule) => {
              let valid = rule(item.value)
              if (valid !== true) {
                this.errorMessages.push(valid)
                item.isValid = false
                state = false
              } else {
                item.isValid = true
              }
            })
          }
        })
      })
      this.itemValue = state ? value : false
      this.isValid = state
      return state
    },
    createMap () {
      this.map = new google.maps.Map(
        document.getElementById(this.mapConfig.id),
        this.mapConfig
      )
    },
    aaa (item) {
      if (item && item.required && item.value.length > 0) {
        this.getFullAddress(this)
        let input = document.getElementById(this.mapConfig.id + '-input')
        input.value = this.fullAddress
        input.focus()
        google.maps.event.trigger(input, 'keydown', {keyCode: 32})
        setTimeout(() => {
          google.maps.event.trigger(input, 'keydown', {keyCode: 40})
          google.maps.event.trigger(input, 'keydown', {keyCode: 13})
        }, 500)
      }
      this.validateForm()
    },
    searchBoxRegister (self) {
      let input = document.getElementById(this.mapConfig.id + '-input')
      this.searchBox = new google.maps.places.SearchBox(input)
      this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input)
      this.map.addListener('bounds_changed', () => {
        self.searchBox.setBounds(self.map.getBounds())
      })
      this.searchBox.addListener('places_changed', () => {
        self.initAutocomplete(self.searchBox.getPlaces(), self)
        input.blur()
      })
    },
    getPlaceValues (places, bounds, self) {
      places.forEach(function (place) {
        console.log(place)
        if (place.address_components) {
          for (let i = 0; i < place.address_components.length; i++) {
            let addressName = place.address_components[i].types[0]
            let addressType = self.getTypeByName(addressName)
            if (place.address_components[i][addressType]) {
              let value = place.address_components[i][addressType]
              self.setValueByName(addressName, value)
            }
          }
        }
        if (place.name) {
          self.setValueByName('name', place.name)
        }
        if (place.geometry.viewport) {
          self.setValueByName('viewport', place.geometry.viewport)
        }
        if (place.geometry.location) {
          self.setValueByName('location', place.geometry.location)
        }
        self.validateForm()

        self.addMarker(place)

        self.setBounds(bounds, place)
      })
    },
    addMarker (place) {
      let icon = {
        url: place.icon,
        size: new google.maps.Size(71, 71),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(17, 34),
        scaledSize: new google.maps.Size(25, 25)
      }

      this.markers.push(new google.maps.Marker({
        map: this.map,
        icon: icon,
        title: place.name,
        position: place.geometry.location
      }))
    },

    setBounds (bounds, place) {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport)
      } else {
        bounds.extend(place.geometry.location)
      }
    },
    initAutocomplete (places) {
      this.resetValues()
      this.isSearch = true
      this.isValid = null
      if (!places) return

      this.markers.forEach(function (marker) {
        marker.setMap(null)
      })

      let bounds = new google.maps.LatLngBounds()

      this.getPlaceValues(places, bounds, this)

      this.map.fitBounds(bounds)
    }
  }
}
*/

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifySwitch',

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },

  watch: {
    'item.value': function itemValue(newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item);
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus();
      }
    }
  }
});

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyRadioGroup',

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }
  },

  watch: {
    'item.value': function itemValue(newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item, true);
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus();
      }
    }
  }
});

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyCheckbox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: false
    };
  },

  mounted: function mounted() {
    this.itemValue = this.item.value || this.itemValue;
  },


  watch: {
    itemValue: function itemValue(newVal, oldVal) {
      this.$emit('change', newVal);
      this.$emit('on-change', this.itemValue, oldVal, this.item, true);
    },
    value: function value(newVal, oldVal) {
      this.itemValue = newVal;
    },
    'item.value': {
      handler: function handler(newVal, oldVal) {
        this.itemValue = newVal;
      },
      deep: true
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus();
      }
    }
  }
});

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyLink',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },

  data: function data() {
    return {
      itemValue: ''
    };
  },

  mounted: function mounted() {
    this.itemValue = this.value || this.itemValue;
  },


  watch: {
    itemValue: function itemValue(newVal, oldVal) {
      this.$emit('change', newVal);
      this.$emit('on-change', newVal, oldVal, this.item);
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {
      if (this.item.focusNextOnEnter) {
        event.target.form[this.item.index + 1].focus();
      }
    }
  }
});

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifySlider',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },

  watch: {
    'item.value': function itemValue(newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item);
    }
  },

  methods: {
    focusNextField: function focusNextField(event) {}
  }
});

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(566), __esModule: true };

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_aggregator_card_vue__ = __webpack_require__(620);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275a59b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_aggregator_card_vue__ = __webpack_require__(658);
function injectStyle (ssrContext) {
  __webpack_require__(656)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_aggregator_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_275a59b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_aggregator_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_dialog_confirm_vue__ = __webpack_require__(621);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffc0f02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_dialog_confirm_vue__ = __webpack_require__(661);
function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ffc0f02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_dialog_confirm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ffc0f02_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_dialog_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_text_field_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_429959a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_text_field_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_text_field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_429959a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_text_field_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(556), __esModule: true };

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(12);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(558), __esModule: true };

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(242);
__webpack_require__(559);
module.exports = __webpack_require__(12).Array.from;


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(29);
var $export = __webpack_require__(20);
var toObject = __webpack_require__(62);
var call = __webpack_require__(248);
var isArrayIter = __webpack_require__(249);
var toLength = __webpack_require__(65);
var createProperty = __webpack_require__(560);
var getIterFn = __webpack_require__(243);

$export($export.S + $export.F * !__webpack_require__(250)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(28);
var createDesc = __webpack_require__(64);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_date_picker_vue__ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5430b32f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_date_picker_vue__ = __webpack_require__(568);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_date_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5430b32f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_date_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(563);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(551);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(564), __esModule: true };

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(244);
__webpack_require__(242);
module.exports = __webpack_require__(565);


/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(66);
var ITERATOR = __webpack_require__(9)('iterator');
var Iterators = __webpack_require__(22);
module.exports = __webpack_require__(12).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(244);
__webpack_require__(242);
module.exports = __webpack_require__(567);


/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(13);
var get = __webpack_require__(243);
module.exports = __webpack_require__(12).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{ref:"menu",attrs:{"nudge-right":40,"return-value":_vm.itemValue,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.itemValue=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.item.label,"disabled":_vm.item.disabled || false,"rules":_vm.item.rules || [],"required":_vm.item.required || false,"placeholder":_vm.item.placeholder || undefined,"prepend-icon":"","readonly":""},on:{"blur":function($event){_vm.dateFormatted = _vm.parseDate(_vm.dateFormatted)}},slot:"activator",model:{value:(_vm.dateFormatted),callback:function ($$v) {_vm.dateFormatted=$$v},expression:"dateFormatted"}}),_vm._v(" "),_c('v-date-picker',{directives:[{name:"show",rawName:"v-show",value:(!_vm.item.disabled),expression:"!item.disabled"}],attrs:{"color":_vm.item.color || 'primary',"locale":"es"},on:{"input":function($event){_vm.$refs.menu.save(_vm.itemValue)}},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(570);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("2b454212", content, true, {});

/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".align-btn-left{float:left}.align-btn-right{float:right}.align-btn-center{margin:auto;display:block}.hidden{display:none}.section-icon{margin-top:-4px}.input-group__error{color:#f44336!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/vuetify-form-creator.vue"],"names":[],"mappings":"AACA,gBACE,UAAY,CACb,AACD,iBACE,WAAa,CACd,AACD,kBACE,YAAa,AACb,aAAe,CAChB,AACD,QACE,YAAc,CACf,AACD,cACE,eAAiB,CAClB,AACD,oBACE,uBAA0B,CAC3B","file":"vuetify-form-creator.vue","sourcesContent":["\n.align-btn-left {\n  float: left;\n}\n.align-btn-right {\n  float: right;\n}\n.align-btn-center {\n  margin: auto;\n  display: block;\n}\n.hidden {\n  display: none;\n}\n.section-icon {\n  margin-top: -4px;\n}\n.input-group__error {\n  color: #f44336 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(572);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("4b7e5938", content, true, {});

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".edit-dialog{display:block!important;text-align:left;height:31px;margin:0;font-size:16px;padding-bottom:8px;margin-top:3px;color:rgba(0,0,0,.87)}.text-field{margin-bottom:-22px}.editable:after{content:\"\"!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-text-field.vue"],"names":[],"mappings":"AACA,aACE,wBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,SAAU,AACV,eAAgB,AAChB,mBAAoB,AACpB,eAAgB,AAChB,qBAA2B,CAC5B,AACD,YACE,mBAAqB,CACtB,AACD,gBACE,oBAAuB,CACxB","file":"vuetify-text-field.vue","sourcesContent":["\n.edit-dialog {\n  display: block !important;\n  text-align: left;\n  height: 31px;\n  margin: 0;\n  font-size: 16px;\n  padding-bottom: 8px;\n  margin-top: 3px;\n  color: rgba(0, 0, 0, 0.87);\n}\n.text-field {\n  margin-bottom: -22px;\n}\n.editable:after {\n  content: '' !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.editable)?_c('v-text-field',{class:_vm.item.editable ? 'text-field' : '',attrs:{"label":_vm.item.label || undefined,"placeholder":_vm.item.placeholder || undefined,"mask":_vm.item.mask || undefined,"rules":_vm.item.rules || [],"counter":_vm.item.counter || undefined,"required":_vm.item.required || false,"dark":_vm.item.dark || false,"hint":_vm.item.hint || undefined,"autofocus":_vm.item.autofocus || false,"multi-line":_vm.item.multi_line || false,"disabled":_vm.item.disabled || false,"autocomplete":_vm.item.autocomplete || 'name',"prepend-icon":_vm.item.prepend_icon || undefined,"append-icon-cb":function () {_vm.visibility = !_vm.visibility},"append-icon":_vm.item.hidden_append_icon === true ? undefined : (_vm.item.append_icon || _vm.item.type === 'password' ? (_vm.visibility ? 'visibility' : 'visibility_off') : undefined),"color":_vm.item.color || undefined,"type":_vm.item.type === 'password' ? (_vm.visibility ? 'text' : 'password') : 'text'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.focusNextField($event)},"blur":function($event){_vm.onBlur($event)}},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}}):_vm._e(),_vm._v(" "),(_vm.editable)?_c('div',{staticClass:"input-group input-group--dirty input-group--text-field primary--text",class:(_vm.item.required && !_vm.itemValue) ? 'input-group--required' : ''},[(_vm.item.hidden_label === true ? false : true)?_c('label',{staticClass:"editable"},[_vm._v(_vm._s(_vm.item.label))]):_vm._e(),_vm._v(" "),(!_vm.item.disabled)?_c('v-edit-dialog',{staticClass:"edit-dialog",attrs:{"lazy":""}},[(_vm.item.tooltip || false)?_c('v-tooltip',{attrs:{"open-delay":"500","right":""}},[_c('span',{class:_vm.item.value_class || '',attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s((_vm.item.prepend_text || '') + _vm.itemValue + (_vm.item.append_text || '')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.tooltip))])]):_c('span',[_vm._v("\n        "+_vm._s((_vm.item.prepend_text || '') + _vm.itemValue + (_vm.item.append_text || ''))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.item.label))]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","label":_vm.item.label || undefined,"placeholder":_vm.item.placeholder || undefined,"mask":_vm.item.mask || undefined,"rules":_vm.item.rules || [],"single-line":"","counter":_vm.item.counter || undefined,"required":_vm.item.required || false,"dark":_vm.item.dark || false,"autofocus":true,"multi-line":_vm.item.multi_line || false,"hint":_vm.item.hint || undefined,"disabled":_vm.item.disabled || false,"autocomplete":_vm.item.autocomplete || 'name',"prepend-icon":_vm.item.prepend_icon || undefined,"append-icon-cb":function () {_vm.visibility = !_vm.visibility},"append-icon":_vm.item.hidden_append_icon === true ? undefined : (_vm.item.append_icon || _vm.item.type === 'password' ? (_vm.visibility ? 'visibility' : 'visibility_off') : undefined),"color":_vm.item.color || undefined,"type":_vm.item.type === 'password' ? (_vm.visibility ? 'text' : 'password') : 'text'},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.focusNextField($event)},"blur":function($event){_vm.onBlur($event)}},slot:"input",model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1):_c('span',{staticClass:"edit-dialog",class:_vm.item.value_class || ''},[_vm._v("\n      "+_vm._s((_vm.item.prepend_text || '') + _vm.itemValue + (_vm.item.append_text || ''))+"\n    ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(575);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("5216a125", content, true, {});

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".edit-dialog{display:block!important;text-align:left;height:31px;margin:0;font-size:16px;padding-bottom:8px;margin-top:3px;color:rgba(0,0,0,.87)}.select-field{margin-bottom:-22px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-select.vue"],"names":[],"mappings":"AACA,aACE,wBAA0B,AAC1B,gBAAiB,AACjB,YAAa,AACb,SAAU,AACV,eAAgB,AAChB,mBAAoB,AACpB,eAAgB,AAChB,qBAA2B,CAC5B,AACD,cACE,mBAAqB,CACtB","file":"vuetify-select.vue","sourcesContent":["\n.edit-dialog {\n  display: block !important;\n  text-align: left;\n  height: 31px;\n  margin: 0;\n  font-size: 16px;\n  padding-bottom: 8px;\n  margin-top: 3px;\n  color: rgba(0, 0, 0, 0.87);\n}\n.select-field {\n  margin-bottom: -22px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.editable)?_c('v-select',{ref:"select",class:_vm.item.editable ? 'select-field' : '',attrs:{"label":_vm.item.label || undefined,"placeholder":_vm.item.placeholder || undefined,"rules":_vm.item.rules || [],"items":_vm.item.items || [],"required":_vm.item.required || false,"disabled":_vm.item.disabled || false,"autocomplete":_vm.item.autocomplete || false,"combobox":_vm.item.combobox || false,"search-input":_vm.search,"item-text":_vm.item.item_text || 'text',"item-value":_vm.item.item_value || 'value',"prepend-icon":_vm.item.prepend_icon || undefined,"append-icon":_vm.item.append_icon || 'arrow_drop_down',"append-icon-cb":_vm.item.append_icon_cb,"color":_vm.item.color || undefined,"cache-items":_vm.item.cache_items || false,"hide-selected":_vm.item.hide_selected || false,"no-data-text":(_vm.item.add_on_enter && _vm.item.no_data_text) ? _vm.item.no_data_text : 'No data available',"readonly":_vm.item.readonly || false,"multiple":_vm.item.multiple || false,"tags":_vm.item.tags || false,"mask":_vm.item.mask || undefined,"dark":_vm.item.dark || false,"hint":_vm.item.hint || undefined,"chips":_vm.item.chips || false,"return-object":_vm.item.return_object || false},on:{"update:searchInput":function($event){_vm.search=$event},"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }_vm.focusNextField($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onAddItem($event)},function($event){_vm.$emit('on-keyup')}]},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}}):_vm._e(),_vm._v(" "),(_vm.editable)?_c('div',{staticClass:"input-group input-group--dirty input-group--text-field primary--text",class:_vm.item.required ? 'input-group--required' : ''},[(_vm.item.hidden_label === true ? false : true)?_c('label',{staticClass:"editable"},[_vm._v(_vm._s(_vm.item.label))]):_vm._e(),_vm._v(" "),(!_vm.item.disabled)?_c('v-edit-dialog',{ref:"dialog",staticClass:"edit-dialog",attrs:{"lazy":""}},[(_vm.item.tooltip || false)?_c('v-tooltip',{attrs:{"open-delay":"500","right":""}},[_c('span',{class:_vm.item.value_class || '',attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.getItemText(_vm.item)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.tooltip))])]):_c('span',[_vm._v("\n        "+_vm._s(_vm.getItemText(_vm.item))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.item.label))]),_vm._v(" "),_c('v-select',{ref:"select",attrs:{"slot":"input","label":_vm.item.label || undefined,"placeholder":_vm.item.placeholder || undefined,"rules":_vm.item.rules || [],"items":_vm.item.items || [],"required":_vm.item.required || false,"disabled":_vm.item.disabled || false,"autocomplete":_vm.item.autocomplete || false,"combobox":_vm.item.combobox || false,"search-input":_vm.search,"item-text":_vm.item.item_text || 'text',"item-value":_vm.item.item_value || 'value',"prepend-icon":_vm.item.prepend_icon || undefined,"append-icon":_vm.item.append_icon || 'arrow_drop_down',"append-icon-cb":_vm.item.append_icon_cb,"single-line":"","color":_vm.item.color || undefined,"cache-items":_vm.item.cache_items || false,"hide-selected":_vm.item.hide_selected || false,"no-data-text":(_vm.item.add_on_enter && _vm.item.no_data_text) ? _vm.item.no_data_text : 'No data available',"readonly":_vm.item.readonly || false,"multiple":_vm.item.multiple || false,"tags":_vm.item.tags || false,"mask":_vm.item.mask || undefined,"dark":_vm.item.dark || false,"hint":_vm.item.hint || undefined,"chips":_vm.item.chips || false,"return-object":_vm.item.return_object || false},on:{"update:searchInput":function($event){_vm.search=$event},"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){ return null; }_vm.focusNextField($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onAddItem($event)},function($event){_vm.$emit('on-keyup')}]},slot:"input",model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1):_c('span',{staticClass:"edit-dialog"},[_vm._v("\n      "+_vm._s(_vm.getItemText(_vm.item))+"\n    ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_time_picker_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028e726a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_time_picker_vue__ = __webpack_require__(578);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_time_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028e726a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_time_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.itemValue,"transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){_vm.itemValue=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.item.label,"placeholder":_vm.item.placeholder || undefined,"disabled":_vm.item.disabled || false,"rules":_vm.item.rules || [],"required":_vm.item.required || false,"prepend-icon":"","readonly":""},slot:"activator",model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}}),_vm._v(" "),_c('v-time-picker',{directives:[{name:"show",rawName:"v-show",value:(!_vm.item.disabled),expression:"!item.disabled"}],attrs:{"format":"24hr","color":_vm.item.color || 'primary',"locale":"es"},on:{"change":function($event){_vm.$refs.menu.save(_vm.itemValue)}},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_radio_card_vue__ = __webpack_require__(541);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bcb034_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_radio_card_vue__ = __webpack_require__(585);
function injectStyle (ssrContext) {
  __webpack_require__(580)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26bcb034"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_radio_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26bcb034_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_radio_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(581);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("7cea7bd2", content, true, {});

/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-radio-card .vrc-card[data-v-26bcb034]{margin-bottom:30px}.vuetify-radio-card .vrc-card .title[data-v-26bcb034]{width:-webkit-fill-available;margin-top:-8px}.vuetify-radio-card .vrc-card .media[data-v-26bcb034]{background:#f6f7f9}.vuetify-radio-card .vrc-card .title-container[data-v-26bcb034]{height:46px}.vuetify-radio-card .vrc-card .icon[data-v-26bcb034]{font-size:46px;border-radius:32px;color:#fff;padding:4px;background:#3f51b5}.vuetify-radio-card .vrc-card .icon-container[data-v-26bcb034]{margin:auto}.vuetify-radio-card .radio[data-v-26bcb034]{visibility:hidden;position:absolute}.vuetify-radio-card .avatar-card[data-v-26bcb034]{-webkit-box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px #212121;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px #212121}.vrc-dialog[data-v-26bcb034]{margin-top:-75px;margin-bottom:-45px}.vrc-gender[data-v-26bcb034]{margin:auto;display:table}.vrc-gender-icon[data-v-26bcb034]{margin-left:5px}.vrc-gender-title[data-v-26bcb034]{margin-top:3px}.vrc-carousel .fade-enter-active[data-v-26bcb034],.vrc-carousel .fade-leave-active[data-v-26bcb034],.vrc-carousel .fade-leave-to[data-v-26bcb034]{-webkit-transition:.3s ease-out;transition:.3s ease-out;position:absolute;top:0;left:0}.vrc-carousel .fade-enter[data-v-26bcb034],.vrc-carousel .fade-leave-to[data-v-26bcb034],.vrc-carousel .fade-leave[data-v-26bcb034]{opacity:0}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-radio-card/vuetify-radio-card.vue"],"names":[],"mappings":"AACA,+CACE,kBAAoB,CACrB,AACD,sDACI,6BAA8B,AAC9B,eAAiB,CACpB,AACD,sDACI,kBAAoB,CACvB,AACD,gEACI,WAAa,CAChB,AACD,qDACI,eAAgB,AAChB,mBAAoB,AACpB,WAAa,AACb,YAAa,AACb,kBAAoB,CACvB,AACD,+DACI,WAAa,CAChB,AACD,4CACE,kBAAmB,AACnB,iBAAmB,CACpB,AACD,kDACE,uGAAwH,AAChH,8FAAgH,CACzH,AACD,6BACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,6BACE,YAAa,AACb,aAAe,CAChB,AACD,kCACE,eAAiB,CAClB,AACD,mCACE,cAAgB,CACjB,AACD,kJACE,gCAAiC,AACjC,wBAAyB,AACzB,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACT,AACD,oIACE,SAAW,CACZ","file":"vuetify-radio-card.vue","sourcesContent":["\n.vuetify-radio-card .vrc-card[data-v-26bcb034] {\n  margin-bottom: 30px;\n}\n.vuetify-radio-card .vrc-card .title[data-v-26bcb034] {\n    width: -webkit-fill-available;\n    margin-top: -8px;\n}\n.vuetify-radio-card .vrc-card .media[data-v-26bcb034] {\n    background: #f6f7f9;\n}\n.vuetify-radio-card .vrc-card .title-container[data-v-26bcb034] {\n    height: 46px;\n}\n.vuetify-radio-card .vrc-card .icon[data-v-26bcb034] {\n    font-size: 46px;\n    border-radius: 32px;\n    color: white;\n    padding: 4px;\n    background: #3F51B5;\n}\n.vuetify-radio-card .vrc-card .icon-container[data-v-26bcb034] {\n    margin: auto;\n}\n.vuetify-radio-card .radio[data-v-26bcb034] {\n  visibility: hidden;\n  position: absolute;\n}\n.vuetify-radio-card .avatar-card[data-v-26bcb034] {\n  -webkit-box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px #212121;\n          box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px #212121;\n}\n.vrc-dialog[data-v-26bcb034] {\n  margin-top: -75px;\n  margin-bottom: -45px;\n}\n.vrc-gender[data-v-26bcb034] {\n  margin: auto;\n  display: table;\n}\n.vrc-gender-icon[data-v-26bcb034] {\n  margin-left: 5px;\n}\n.vrc-gender-title[data-v-26bcb034] {\n  margin-top: 3px;\n}\n.vrc-carousel .fade-enter-active[data-v-26bcb034], .vrc-carousel .fade-leave-active[data-v-26bcb034], .vrc-carousel .fade-leave-to[data-v-26bcb034] {\n  -webkit-transition: .3s ease-out;\n  transition: .3s ease-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.vrc-carousel .fade-enter[data-v-26bcb034], .vrc-carousel .fade-leave[data-v-26bcb034], .vrc-carousel .fade-leave-to[data-v-26bcb034] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(583);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("64f3bbf5", content, true, {});

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".view-pdf[data-v-b5baf16e]{width:100%;height:100%}.vuetify-select-file input[type=file][data-v-b5baf16e]{position:absolute;filter:alpha(opacity=0);opacity:0}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-select-file.vue"],"names":[],"mappings":"AACA,2BACE,WAAY,AACZ,WAAa,CACd,AACD,uDACE,kBAAmB,AACnB,wBAAyB,AACzB,SAAW,CACZ","file":"vuetify-select-file.vue","sourcesContent":["\n.view-pdf[data-v-b5baf16e] {\n  width: 100%;\n  height: 100%;\n}\n.vuetify-select-file input[type=file][data-v-b5baf16e] {\n  position: absolute;\n  filter: alpha(opacity=0);\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuetify-select-file"},[_c('input',{ref:"input",attrs:{"type":"file","multiple":"","accept":_vm.accept,"disabled":_vm.disabled},on:{"change":function($event){_vm.changed($event.target.files)}}}),_vm._v(" "),_c('button',{on:{"click":_vm.clicked}},[_vm._v("dddddd")]),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition","fullscreen":"","scrollable":"","hide-overlay":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.selected = null}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.label))])],1),_vm._v(" "),(_vm.data !== null && _vm.type !== null)?[(_vm.type === 'application/pdf')?_c('embed',{key:_vm.data,staticClass:"view-pdf",attrs:{"type":_vm.type,"src":_vm.data}}):(_vm.type.substring(0, 6) === 'image/')?_c('v-card-text',[_c('img',{key:_vm.data,attrs:{"src":_vm.data}})]):_c('v-card-text',[_c('v-alert',{attrs:{"type":"error","value":true}},[_vm._v(_vm._s(_vm.type)+" not supported.")])],1)]:_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{ref:"radio_group",staticClass:"vuetify-radio-card",attrs:{"rules":_vm.itemRules},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_vm._l((_vm.items),function(item,i){return _c('v-flex',{key:i,attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-radio',{attrs:{"value":item.value}}),_vm._v(" "),_c('v-card',{class:[
            'vrc-card',
            (_vm.itemSelected && _vm.itemSelected.value === item.value) ? 'avatar-card' : '',
            'theme--light'
          ],attrs:{"title":item.text,"hover":"","ripple":"","width":"160px"},nativeOn:{"click":function($event){_vm.selectItem(item)}}},[_c('v-card-media',{staticClass:"media",attrs:{"src":item.avatar,"height":"160px"}}),_vm._v(" "),_c('v-card-title',{staticClass:"title-container text-xs-center",attrs:{"primary-title":""}},[_c('h3',{staticClass:"title headline mb-0"},[_vm._v("\n              "+_vm._s(_vm.getFirstWord(item.text))+"\n            ")])])],1)],1)}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',{staticClass:"vrc-card theme--light",attrs:{"title":_vm.aggregator.text,"ripple":"","width":"160px"},nativeOn:{"click":function($event){_vm.dialog = true}}},[_c('v-card-media',{attrs:{"height":"160px"}},[_c('div',{staticClass:"icon-container"},[_c('v-icon',{staticClass:"icon"},[_vm._v("add")])],1)]),_vm._v(" "),_c('v-card-title',{staticClass:"title-container text-xs-center",attrs:{"primary-title":""}},[_c('h3',{staticClass:"title headline mb-0"},[_vm._v("\n              "+_vm._s(_vm.aggregator.text)+"\n            ")])])],1)],1)],2),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.aggregator),expression:"aggregator"}],attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"vrc-dialog",attrs:{"xs12":""}},[_c('v-card-media',{staticClass:"vrc-carousel"},[_c('v-carousel',{attrs:{"cycle":false,"hide-delimiters":"","value":_vm.avatar},model:{value:(_vm.avatar),callback:function ($$v) {_vm.avatar=$$v},expression:"avatar"}},_vm._l((_vm.defaultAvatars),function(avatar,i){return _c('v-carousel-item',{key:i,attrs:{"src":avatar.src,"transition":"fade","reverse-transition":"fade"}})}))],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"vrc-gender",attrs:{"xs12":""}},[_c('v-btn-toggle',{model:{value:(_vm.gender),callback:function ($$v) {_vm.gender=$$v},expression:"gender"}},[_c('v-btn',{attrs:{"flat":"","value":"male"}},[_c('span',{staticClass:"vrc-gender-title"},[_vm._v("\n                        "+_vm._s(_vm.aggregator.gender.man || 'man')+"\n                      ")]),_vm._v(" "),_c('svg',{staticClass:"vrc-gender-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M16 2v2h3.586l-3.972 3.972c-1.54-1.231-3.489-1.972-5.614-1.972-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-2.125-.741-4.074-1.972-5.614l3.972-3.972v3.586h2v-7h-7zm-6 20c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"}})])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":"female"}},[_c('span',{staticClass:"vrc-gender-title"},[_vm._v("\n                        "+_vm._s(_vm.aggregator.gender.woman || 'woman')+"\n                      ")]),_vm._v(" "),_c('svg',{staticClass:"vrc-gender-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 9c0-4.97-4.03-9-9-9s-9 4.03-9 9c0 4.632 3.501 8.443 8 8.941v2.059h-3v2h3v2h2v-2h3v-2h-3v-2.059c4.499-.498 8-4.309 8-8.941zm-16 0c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7-7-3.14-7-7z"}})])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{ref:"name",attrs:{"label":_vm.aggregator.label || 'Name',"rules":_vm.aggregator.rules || [],"autocomplete":_vm.aggregator.autocomplete || 'name',"single-line":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.aggregator.color,"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n            close\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.aggregator.color,"flat":"","disabled":!_vm.isValid},nativeOn:{"click":function($event){_vm.addItem(_vm.aggregator)}}},[_vm._v("\n            "+_vm._s(_vm.aggregator.buttons.save || 'save')+"\n          ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_places_autocomplete_vue__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_places_autocomplete_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_places_autocomplete_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90d1022_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_places_autocomplete_vue__ = __webpack_require__(589);
function injectStyle (ssrContext) {
  __webpack_require__(587)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_places_autocomplete_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90d1022_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_places_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 587:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(588);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("8e5d3204", content, true, {});

/***/ }),

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".map{height:100%;position:static!important}.controls{margin-top:10px;border:1px solid transparent;border-radius:2px 0 0 2px;-webkit-box-sizing:border-box;box-sizing:border-box;-moz-box-sizing:border-box;height:32px;outline:none;-webkit-box-shadow:0 2px 6px rgba(0,0,0,.3);box-shadow:0 2px 6px rgba(0,0,0,.3);background-color:#fff;font-family:Roboto;font-size:15px;font-weight:300;margin-left:12px;padding:0 11px 0 13px;text-overflow:ellipsis;width:300px}.controls:focus{border-color:#4d90fe}.pac-container{font-family:Roboto}#type-selector{color:#fff;background-color:#4d90fe;padding:5px 11px 0}#type-selector label{font-family:Roboto;font-size:13px;font-weight:300}#target{width:345px}.vpa-is-invalid{color:#ff5252!important}#validation>div>div.input-group__details:before,#validation>div>div.input-group__input{display:none}#validation>.input-group{padding:0}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-places-autocomplete.vue"],"names":[],"mappings":"AACA,KACE,YAAa,AACb,yBAA6B,CAC9B,AACD,UACE,gBAAiB,AACjB,6BAA8B,AAC9B,0BAA2B,AAC3B,8BAA+B,AACvB,sBAAuB,AAC/B,2BAA4B,AAC5B,YAAa,AACb,aAAc,AACd,4CAAiD,AACzC,oCAAyC,AAGjD,sBAAuB,AACvB,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,iBAAkB,AAClB,sBAAuB,AACvB,uBAAwB,AACxB,WAAa,CATd,AAWD,gBACE,oBAAsB,CACvB,AACD,eACE,kBAAoB,CACrB,AACD,eACE,WAAY,AACZ,yBAA0B,AAC1B,kBAA2B,CAC5B,AACD,qBACE,mBAAoB,AACpB,eAAgB,AAChB,eAAiB,CAClB,AACD,QACE,WAAa,CACd,AACD,gBACE,uBAA0B,CAC3B,AACD,uFAEE,YAAc,CACf,AACD,yBACE,SAAW,CACZ","file":"vuetify-places-autocomplete.vue","sourcesContent":["\n.map {\n  height: 100%;\n  position: initial !important;\n}\n.controls {\n  margin-top: 10px;\n  border: 1px solid transparent;\n  border-radius: 2px 0 0 2px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  height: 32px;\n  outline: none;\n  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n.controls {\n  background-color: #fff;\n  font-family: Roboto;\n  font-size: 15px;\n  font-weight: 300;\n  margin-left: 12px;\n  padding: 0 11px 0 13px;\n  text-overflow: ellipsis;\n  width: 300px;\n}\n.controls:focus {\n  border-color: #4d90fe;\n}\n.pac-container {\n  font-family: Roboto;\n}\n#type-selector {\n  color: #fff;\n  background-color: #4d90fe;\n  padding: 5px 11px 0px 11px;\n}\n#type-selector label {\n  font-family: Roboto;\n  font-size: 13px;\n  font-weight: 300;\n}\n#target {\n  width: 345px;\n}\n.vpa-is-invalid {\n  color: #ff5252 !important;\n}\n#validation > div > div.input-group__input,\n#validation > div > div.input-group__details::before {\n  display: none;\n}\n#validation > .input-group {\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInput),expression:"showInput"}],staticClass:"controls",attrs:{"id":_vm.mapConfig.id + '-input',"placeholder":"Buscar dirección"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-card',[_c('v-card-media',{attrs:{"height":"240px"}},[_c('div',{staticClass:"map",attrs:{"id":_vm.mapConfig.id}})]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.isValid ? 'primary' : 'red'}},[_vm._v("location_on")])],1),_vm._v(" "),_c('v-list-tile-content',_vm._l((_vm.address),function(section,i){return (section.title !== 'hidden')?_c('div',{key:i,class:!section.title ? 'list__tile__sub-title' : 'list__tile__title'},_vm._l((section.fields),function(item,i){return _c('v-edit-dialog',{key:i,ref:item.name,refInFor:true,attrs:{"return-value":item.value,"lazy":""},on:{"update:returnValue":function($event){_vm.$set(item, "value", $event)}}},[_c('span',{class:item.required && _vm.isSearch && !item.value ? 'vpa-is-invalid' : ''},[_vm._v(_vm._s(item.value || item.text))]),_vm._v(_vm._s(item.sufix)+"\n              "),_c('v-text-field',{attrs:{"slot":"input","label":item.label,"required":item.required || false,"hint":item.hint || undefined,"rules":item.rules || []},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.aaa(item)}},slot:"input",model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}),_vm._v(" "),_c('div',{attrs:{"slot":"input"},slot:"input"},[_vm._v("\n                dddddd\n              ")])],1)})):_vm._e()}))],1)],1)],1),_vm._v(" "),_vm._l((_vm.errorMessages),function(error,i){return _c('div',{key:i,staticClass:"input-group__details"},[_c('div',{staticClass:"vpa-is-invalid input-group__messages input-group__error"},[_vm._v(_vm._s(error))])])}),_vm._v(" "),_c('div',{attrs:{"id":"validation"}},[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(!_vm.itemValue),expression:"!itemValue"}],ref:"form",attrs:{"rules":_vm.rules || []},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1)],2),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.aaa()}}},[_vm._v("ssss")]),_vm._v(" "),_c('pre',[_vm._v("  "+_vm._s(_vm.fullAddress)+"\n")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_switch_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b06fd30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_switch_vue__ = __webpack_require__(591);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b06fd30_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',{attrs:{"label":("Switch 1: " + (_vm.item.hint.toString())),"hint":_vm.item.hint || undefined},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_radio_group_vue__ = __webpack_require__(546);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d83475d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_radio_group_vue__ = __webpack_require__(595);
function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_radio_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d83475d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_radio_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(594);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("034659b8", content, true, {});

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vrg-title{color:rgba(0,0,0,.54);display:inline-block;font-size:16px;line-height:30px;height:30px;text-align:left;text-overflow:ellipsis;z-index:0}.radio-group{margin-top:-47px}.input-group__messages{text-align:left}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-form-creator/fields/vuetify-radio-group.vue"],"names":[],"mappings":"AACA,WACE,sBAA2B,AAC3B,qBAAsB,AACtB,eAAgB,AAChB,iBAAkB,AAClB,YAAa,AACb,gBAAiB,AACjB,uBAAwB,AACxB,SAAW,CACZ,AACD,aACE,gBAAkB,CACnB,AACD,uBACE,eAAiB,CAClB","file":"vuetify-radio-group.vue","sourcesContent":["\n.vrg-title {\n  color: rgba(0, 0, 0, 0.54);\n  display: inline-block;\n  font-size: 16px;\n  line-height: 30px;\n  height: 30px;\n  text-align: left;\n  text-overflow: ellipsis;\n  z-index: 0;\n}\n.radio-group {\n  margin-top: -47px;\n}\n.input-group__messages {\n  text-align: left;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{class:_vm.item.class || '',attrs:{"rules":_vm.item.rules || [],"hint":_vm.item.hint,"column":""},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}},[_c('p',{staticClass:"vrg-title"},[_vm._v(_vm._s(_vm.item.label))]),_vm._v(" "),_vm._l((_vm.item.options),function(option,i){return _c('v-radio',{directives:[{name:"show",rawName:"v-show",value:(option.visible !== undefined ? option.visible : true),expression:"option.visible !== undefined ? option.visible : true"}],key:option.value + i,attrs:{"mandatory":"","label":option.label,"input-value":option.value,"value":option.value,"disabled":option.disabled || false,"title":option.value}})}),_vm._v(" "),_vm._l((_vm.item.options),function(option,i){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(option.hint && _vm.item.value === option.value),expression:"option.hint && item.value === option.value"}],key:i,staticClass:"input-group__details"},[_c('div',{staticClass:"input-group__messages input-group__error"},[_vm._v("\n         "+_vm._s(option.hint)+"\n       ")])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 596:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_checkbox_vue__ = __webpack_require__(547);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687fe2c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_checkbox_vue__ = __webpack_require__(597);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687fe2c8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{attrs:{"color":_vm.item.color || undefined,"value":_vm.itemValue,"label":_vm.item.label || undefined,"disabled":_vm.item.disabled || false,"rules":_vm.item.rules || [],"data-vv-name":"checkbox","type":"checkbox","required":_vm.item.required || false},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}},[(_vm.item.text)?_c('span',{attrs:{"slot":"label"},slot:"label"},_vm._l((_vm.item.text || []),function(item,i){return _c('span',{key:i},[(i === 'link')?_c('router-link',{attrs:{"to":item.to}},[_vm._v(_vm._s(item.value))]):_c('span',[_vm._v(_vm._s(item))])],1)})):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 598:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_link_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4cf9b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_link_vue__ = __webpack_require__(599);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_link_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4cf9b4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.item.class || ''},[_c('router-link',{attrs:{"to":_vm.item.to || undefined}},[_vm._v("\n    "+_vm._s(_vm.item.value)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_slider_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d16297_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_slider_vue__ = __webpack_require__(603);
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_slider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39d16297_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_slider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(602);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("3c4b2a72", content, true, {});

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"vuetify-slider.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"color":_vm.item.color || undefined,"label":_vm.item.label || undefined,"min":_vm.item.min || 0,"max":_vm.item.max || 100,"thumb-label":_vm.item.thumbLabel || false,"append-icon":_vm.item.appendIcon || undefined,"prepend-icon":_vm.item.prependIcon || undefined,"step":_vm.item.step || 1},model:{value:(_vm.item.value),callback:function ($$v) {_vm.$set(_vm.item, "value", $$v)},expression:"item.value"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{class:_vm.columns},[_c('v-form',{ref:"form_creator",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.onClickButton($event)}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-container',[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.fields),function(item,i){return _c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(item.visible !== undefined ? item.visible : true),expression:"item.visible !== undefined ? item.visible : true"}],key:i,class:[item.columns, (item.type === 'hidden' ? 'hidden' : '')]},[(item.type === 'text-field' || item.type === 'password' || item.type === 'hidden')?_c('vuetify-text-field',{attrs:{"item":item},on:{"on-change":_vm.onChange,"on-blur":_vm.onBlur},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}):_vm._e(),_vm._v(" "),(item.type === 'select')?_c('vuetify-select',{attrs:{"item":item},on:{"on-add-item":_vm.onAddItem,"on-change":_vm.onChange},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}):_vm._e(),_vm._v(" "),(item.type === 'date-picker')?_c('vuetify-date-picker',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'time-picker')?_c('vuetify-time-picker',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'radio-card')?_c('vuetify-radio-card',{ref:"form",refInFor:true,attrs:{"options":item.options,"avatars":item.avatars,"aggregator":item.aggregator,"rules":item.rules},on:{"on-add-item":_vm.onAddItem},model:{value:(item.selected),callback:function ($$v) {_vm.$set(item, "selected", $$v)},expression:"item.selected"}}):_vm._e(),_vm._v(" "),(item.type === 'places-autocomplete')?_c('vuetify-places-autocomplete',{attrs:{"item":item,"map-config":item.mapConfig,"rules":item.rules},on:{"on-add-item":_vm.onAddItem},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}}):_vm._e(),_vm._v(" "),(item.type === 'switch')?_c('vuetify-switch',{attrs:{"item":item},on:{"on-add-item":_vm.onAddItem}}):_vm._e(),_vm._v(" "),(item.type === 'checkbox')?_c('vuetify-checkbox',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'link')?_c('vuetify-link',{attrs:{"item":item}}):_vm._e(),_vm._v(" "),(item.type === 'radio-group')?_c('vuetify-radio-group',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'slider')?_c('vuetify-slider',{attrs:{"item":item},on:{"on-change":_vm.onChange}}):_vm._e(),_vm._v(" "),(item.type === 'button' && !item.items)?_c('v-btn',{class:_vm.setClassButton(item),attrs:{"disabled":item.loading || item.disabled || false,"color":item.color || 'primary',"outline":item.outline || false,"small":item.small || false,"round":item.round || false,"loading":item.loading || false},on:{"click":function($event){_vm.openNewWindow(item); _vm.onClickButton(item);}}},[_vm._v(_vm._s(item.text_button || 'Submit')+"\n            ")]):_vm._e(),_vm._v(" "),_vm._l((item.items || []),function(button,i){return (item.type === 'button' && item.items)?_c('v-btn',{key:i,class:_vm.setClassButton(button),attrs:{"disabled":button.loading || button.disabled || false,"color":button.color || 'primary',"outline":button.outline || false,"small":button.small || false,"round":button.round || false,"loading":button.loading || false},on:{"click":function($event){_vm.openNewWindow(button); _vm.onClickButton(button);}}},[_vm._v(_vm._s(button.text_button || 'Submit')+"\n            ")]):_vm._e()}),_vm._v(" "),(item.type === 'section-text')?_c('span',{staticClass:"section"},[(item.append_icon)?_c('v-icon',{staticClass:"section-icon",attrs:{"color":item.icon_color || 'primary'}},[_vm._v(_vm._s(item.append_icon))]):_vm._e(),_vm._v(" "),_c('span',{class:[item.class]},[_vm._v(_vm._s(item.value))])],1):_vm._e(),_vm._v(" "),(item.type === 'plain-text')?_c('div',[_c('div',{staticClass:"input-group input-group--dirty input-group--text-field primary--text"},[_c('label',[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('div',{staticClass:"menu edit-dialog",staticStyle:{"display":"inline-block"}},[_vm._v("\n                  "+_vm._s((item.value || {}).item_text ||
                    (item.value || {}).commerce_name ||
                    (item.value || {}).installer_alias ||
                    (item.value || {}).seller_name ||
                    item.value ||
                    '')+"\n                ")])])]):_vm._e()],2)}))],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__(606);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1682036_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__(622);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_a1682036_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ADDRESS_COMPONENTS = {
    street_number: 'long_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};

var CITIES_TYPE = ['locality', 'administrative_area_level_3'];
var REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country', 'administrative_area_level_1', 'administrative_area_level_2'];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'VueGoogleAutocomplete',

    props: {
        id: {
            type: String,
            required: true
        },

        classname: String,

        placeholder: {
            type: String,
            default: 'Start typing'
        },

        types: {
            type: String,
            default: 'address'
        },

        country: {
            type: [String, Array],
            default: null
        },

        enableGeolocation: {
            type: Boolean,
            default: false
        },

        geolocationOptions: {
            type: Object,
            default: null
        }
    },

    data: function data() {
        return {
            /**
             * The Autocomplete object.
             *
             * @type {Autocomplete}
             * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
             */
            autocomplete: null,

            /**
             * Autocomplete input text
             * @type {String}
             */
            autocompleteText: '',

            geolocation: {
                /**
                 * Google Geocoder Objet
                 * @type {Geocoder}
                 * @link https://developers.google.com/maps/documentation/javascript/reference#Geocoder
                 */
                geocoder: null,

                /**
                 * Filled after geolocate result
                 * @type {Coordinates}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Coordinates
                 */
                loc: null,

                /**
                 * Filled after geolocate result
                 * @type {Position}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Position
                 */
                position: null
            }
        };
    },


    watch: {
        autocompleteText: function autocompleteText(newVal, oldVal) {
            this.$emit('inputChange', { newVal: newVal, oldVal: oldVal }, this.id);
        },
        country: function country(newVal, oldVal) {
            this.autocomplete.setComponentRestrictions({
                country: this.country === null ? [] : this.country
            });
        }
    },

    mounted: function mounted() {
        var options = {};

        if (this.types) {
            options.types = [this.types];
        }

        if (this.country) {
            options.componentRestrictions = {
                country: this.country
            };
        }

        this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

        this.autocomplete.addListener('place_changed', this.onPlaceChanged);
    },

    methods: {
        /**
         * When a place changed
         */
        onPlaceChanged: function onPlaceChanged() {
            var place = this.autocomplete.getPlace();

            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                this.$emit('no-results-found', place, this.id);
                return;
            }

            if (place.address_components !== undefined) {
                // return returnData object and PlaceResult object
                this.$emit('placechanged', this.formatResult(place), place, this.id);

                // update autocompleteText then emit change event
                this.autocompleteText = document.getElementById(this.id).value;
                this.onChange();
            }
        },


        /**
         * When the input gets focus
         */
        onFocus: function onFocus() {
            this.biasAutocompleteLocation();
            this.$emit('focus');
        },


        /**
         * When the input loses focus
         */
        onBlur: function onBlur() {
            this.$emit('blur');
        },


        /**
         * When the input got changed
         */
        onChange: function onChange() {
            this.$emit('change', this.autocompleteText);
        },


        /**
         * When a key gets pressed
         * @param  {Event} event A keypress event
         */
        onKeyPress: function onKeyPress(event) {
            this.$emit('keypress', event);
        },


        /**
         * When a keyup occurs
         * @param  {Event} event A keyup event
         */
        onKeyUp: function onKeyUp(event) {
            this.$emit('keyup', event);
        },


        /**
         * Clear the input
         */
        clear: function clear() {
            this.autocompleteText = '';
        },


        /**
         * Focus the input
         */
        focus: function focus() {
            this.$refs.autocomplete.focus();
        },


        /**
         * Blur the input
         */
        blur: function blur() {
            this.$refs.autocomplete.blur();
        },


        /**
         * Update the value of the input
         * @param  {String} value
         */
        update: function update(value) {
            this.autocompleteText = value;
        },


        /**
         * Update the coordinates of the input
         * @param  {Coordinates} value
         */
        updateCoordinates: function updateCoordinates(value) {
            var _this = this;

            if (!value && !(value.lat || value.lng)) return;
            if (!this.geolocation.geocoder) this.geolocation.geocoder = new google.maps.Geocoder();
            this.geolocation.geocoder.geocode({ 'location': value }, function (results, status) {
                if (status === 'OK') {
                    results = _this.filterGeocodeResultTypes(results);
                    if (results[0]) {
                        _this.$emit('placechanged', _this.formatResult(results[0]), results[0], _this.id);
                        _this.update(results[0].formatted_address);
                    } else {
                        _this.$emit('error', 'no result for provided coordinates');
                    }
                } else {
                    _this.$emit('error', 'error getting address from coords');
                }
            });
        },


        /**
         * Update location based on navigator geolocation
         */
        geolocate: function geolocate() {
            var _this2 = this;

            this.updateGeolocation(function (geolocation, position) {
                _this2.updateCoordinates(geolocation);
            });
        },


        /**
         * Update internal location from navigator geolocation
         * @param  {Function} (geolocation, position)
         */
        updateGeolocation: function updateGeolocation() {
            var _this3 = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (navigator.geolocation) {
                var options = {};
                if (this.geolocationOptions) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, this.geolocationOptions);
                navigator.geolocation.getCurrentPosition(function (position) {
                    var geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    _this3.geolocation.loc = geolocation;
                    _this3.geolocation.position = position;

                    if (callback) callback(geolocation, position);
                }, function (err) {
                    _this3.$emit('error', 'Cannot get Coordinates from navigator', err);
                }, options);
            }
        },


        // Bias the autocomplete object to the user's geographical location,
        // as supplied by the browser's 'navigator.geolocation' object.
        biasAutocompleteLocation: function biasAutocompleteLocation() {
            var _this4 = this;

            if (this.enableGeolocation) {
                this.updateGeolocation(function (geolocation, position) {
                    var circle = new google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });
                    _this4.autocomplete.setBounds(circle.getBounds());
                });
            }
        },


        /**
         * Format result from Geo google APIs
         * @param place
         * @returns {{formatted output}}
         */
        formatResult: function formatResult(place) {
            var returnData = {};
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS[addressType]) {
                    var val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                    returnData[addressType] = val;
                }
            }

            returnData['latitude'] = place.geometry.location.lat();
            returnData['longitude'] = place.geometry.location.lng();
            return returnData;
        },


        /**
         * Extract configured types out of raw result as
         * Geocode API does not allow to do it
         * @param results
         * @returns {GeocoderResult}
         * @link https://developers.google.com/maps/documentation/javascript/reference#GeocoderResult
         */
        filterGeocodeResultTypes: function filterGeocodeResultTypes(results) {
            if (!results || !this.types) return results;
            var output = [];
            var types = [this.types];
            if (types.includes('(cities)')) types = types.concat(CITIES_TYPE);
            if (types.includes('(regions)')) types = types.concat(REGIONS_TYPE);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var r = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(r.types), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var t = _step2.value;

                            if (types.includes(t)) {
                                output.push(r);
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return output;
        }
    }
});

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyAvatarSelector',

  props: {
    avatar: {
      type: Object,
      default: null,
      required: true
    },
    avatars: {
      type: Array,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    controls: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: function data() {
    return {
      item: {},
      items: [],
      dialog: false,
      value: 0
    };
  },

  mounted: function mounted() {
    this.item = this.avatar;
    this.items = this.avatars;
  },


  watch: {
    avatars: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },
    avatar: {
      handler: function handler(newVal, oldVal) {
        this.item = newVal;
        if (this.$refs.carousel && this.$refs.carousel[this.value]) {
          this.$refs.carousel[this.value].$data.active = true;
        }
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    selectAvatarFile: function selectAvatarFile() {
      this.$refs.input.value = '';
      this.$refs.input.click();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    changeAvatar: function changeAvatar() {
      console.log('ssss');
      this.item.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkFile: function checkFile(format, maxFileSize, width, height) {
      var file = this.$refs.input.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);

      var self = this;
      reader.addEventListener('load', function () {
        var img = new Image();

        img.onload = function () {
          if (file.type !== format) {
            self.$emit('on-upload-error', 'format', format);
          } else if (file.size > maxFileSize) {
            self.$emit('on-upload-error', 'max-file-size', maxFileSize);
          } else if (img.width !== width) {
            self.$emit('on-upload-error', 'width', width);
          } else if (img.height !== height) {
            self.$emit('on-upload-error', 'height', height);
          } else {
            self.saveAvatar(reader.result);
          }
        };
        img.src = reader.result;
      }, false);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    saveAvatar: function saveAvatar(data) {
      if (!data) {
        data = this.items[this.value].src;
      }
      this.item.src = data;
      this.item.dialog = false;
      this.$emit('on-change-avatar', this.item);
      this.$forceUpdate();
    }
  }
});

/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__ = __webpack_require__(605);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyEditableAddressCard',

  components: {
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__["a" /* default */]
  },

  props: {
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    items: {
      type: Array,
      default: null,
      required: true
    },
    validateOnChanged: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data: function data() {
    return {
      fields: [],
      dialog: false
    };
  },

  mounted: function mounted() {
    this.fields = this.items;
  },


  watch: {
    items: {
      handler: function handler(newVal, oldVal) {
        this.fields = newVal;
      }
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange() {
      for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
        data[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['on-change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddItem: function onAddItem() {
      for (var _len2 = arguments.length, data = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        data[_key2] = arguments[_key2];
      }

      this.$emit.apply(this, ['on-add-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClickButton: function onClickButton() {
      for (var _len3 = arguments.length, data = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        data[_key3] = arguments[_key3];
      }

      this.$emit.apply(this, ['on-click-button'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
    }
  }
});

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__ = __webpack_require__(553);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyPhoneAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__["a" /* default */]
  },

  props: {
    phones: {
      type: Array,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    phoneTypes: {
      type: Array,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    value: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: [{
        text: 'Phone'
      }, {
        text: 'Mobile'
      }, {
        text: 'Fax'
      }],
      phoneType: null,
      phoneNumber: null
    };
  },

  watch: {
    phoneTypes: {
      handler: function handler(newVal, oldVal) {
        this.types = newVal;
        this.phoneType = this.types[0];
      },
      deep: true
    },

    phones: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validate: function validate() {
      return this.$refs.form.validate();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deletePhone();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deletePhone: function deletePhone() {
      this.items.splice(this.currentIndex, 1);
      this.$emit('on-delete-phone');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openDialog: function openDialog() {
      this.$refs.aggregator.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.$refs.aggregator.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addPhone: function addPhone() {
      if (this.validate()) {
        this.closeDialog();
        var item = {
          type: this.phoneType.text,
          value: this.phoneNumber
        };
        this.items.push(item);
        this.$refs.form.reset();
        this.$emit('on-add-phone');
      }
    }
  }
});

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyAggregatorCard',

  props: {
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    persistent: {
      type: Boolean,
      default: false,
      required: false
    },
    canEdit: {
      type: Boolean,
      default: true,
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    addButton: {
      type: Boolean,
      default: true,
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: function data() {
    return {
      dialog: false
    };
  }
});

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyDialogConfirm',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    reference: {
      type: String,
      default: 'dialog_confirm',
      required: false
    },
    value: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 290,
      required: false
    },
    headline: {
      type: String,
      default: 'Delete element?',
      required: false
    },
    text: {
      type: String,
      default: 'Delete element?',
      required: false
    },
    cancel: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirm: {
      type: String,
      default: 'Confirm',
      required: false
    },
    dark: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data: function data() {
    return {
      visible: false
    };
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onClick: function onClick(button) {
      this.$emit('on-' + button + '-dialog', this.reference);
      this.visible = false;
    }
  },

  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        this.visible = newVal;
      },
      deep: true
    },
    visible: {
      handler: function handler(newVal) {
        if (newVal === false) {
          this.$emit('on-cancel-dialog', this.reference);
        }
      },
      deep: true
    }
  }
});

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autocompleteText),expression:"autocompleteText"}],ref:"autocomplete",class:_vm.classname,attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder},domProps:{"value":(_vm.autocompleteText)},on:{"focus":function($event){_vm.onFocus()},"blur":function($event){_vm.onBlur()},"change":_vm.onChange,"keypress":_vm.onKeyPress,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.autocompleteText=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vue_signature_pad___ = __webpack_require__(666);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifySignatureAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__["a" /* default */],
    VueSignaturePad: __WEBPACK_IMPORTED_MODULE_2__components_vue_signature_pad___["a" /* default */]
  },

  props: {
    options: {
      type: Object,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    phoneTypes: {
      type: Array,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    uploadIconHoverText: {
      type: String,
      default: 'Upload image of 400 x 200 pixels in PNG format',
      required: false
    },
    clearIconHoverText: {
      type: String,
      default: 'Clean signature',
      required: false
    },
    saveIconHoverText: {
      type: String,
      default: 'Save signature',
      required: false
    },
    disableDeleteButton: {
      type: Boolean,
      default: false,
      required: false
    },
    disableCancelButton: {
      type: Boolean,
      default: false,
      required: false
    },
    disableSaveButton: {
      type: Boolean,
      default: false,
      required: false
    },
    disableClearButton: {
      type: Boolean,
      default: false,
      required: false
    },
    disableUploadButton: {
      type: Boolean,
      default: false,
      required: false
    },
    persistent: {
      type: Boolean,
      default: true,
      required: false
    },
    value: {
      type: String,
      default: null
    }
  },

  data: function data() {
    return {
      signature: null,
      showConfirmDialog: false,
      theToolbarTitle: ''
    };
  },

  created: function created() {
    this.signature = this.options;
    this.theToolbarTitle = this.toolbarTitle;
  },


  watch: {
    options: {
      handler: function handler(newVal, oldVal) {
        this.signature = newVal;
      },
      deep: true
    },
    toolbarTitle: {
      handler: function handler(newVal, oldVal) {
        this.theToolbarTitle = newVal;
      },
      deep: true
    },

    'signature.value': {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation() {
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.delSignature();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    clearSignature: function clearSignature() {
      this.$refs.signature.clear();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openDialog: function openDialog() {
      this.$refs.aggregator.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.$refs.aggregator.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    delSignature: function delSignature() {
      this.onSaveSignature('');
      this.$emit('on-del-signature');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onSaveSignature: function onSaveSignature(signature) {
      this.signature.value = signature;
      if (signature !== '') {
        this.$emit('on-add-signature');
      }
      this.$forceUpdate();
      this.$refs.signature.clear();
      this.closeDialog();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    selectSignatureFile: function selectSignatureFile() {
      this.$refs.signature.selectSignatureFile();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    setSignature: function setSignature() {
      this.$refs.signature.save();
      this.signature.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onUploadError: function onUploadError(type, requiredValue) {
      this.$emit('on-upload-error', type, requiredValue);
    }
  }
});

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_signature_pad__ = __webpack_require__(669);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VueSignaturePad',

  props: {
    background: {
      type: String,
      default: 'rgba(255, 255, 255, 0)',
      required: false
    },
    color: {
      type: String,
      default: 'rgba(0,0,0,0.87)',
      required: false
    },
    width: {
      type: Number,
      default: 400,
      required: false
    },
    height: {
      type: Number,
      default: 200,
      required: false
    },
    format: {
      type: String,
      default: 'image/png',
      required: false
    },
    maxFileSize: {
      type: Number,
      default: 200000,
      required: false
    }
  },

  data: function data() {
    return {
      signature: null,
      stamp: ''
    };
  },

  mounted: function mounted() {
    this.signaturePad = new __WEBPACK_IMPORTED_MODULE_0_signature_pad__["a" /* default */](this.$refs.signaturePad, {
      backgroundColor: this.background,
      penColor: this.color
    });
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    save: function save() {
      var signatureImage = this.signaturePad.toDataURL(this.format);

      if (this.stamp === '') {
        return this.$emit('on-save-signature', signatureImage);
      }
      var canvas = document.getElementById('canvas');
      var context = canvas.getContext('2d');
      var signature = new Image();
      var stamp = new Image();

      var self = this;
      signature.onload = function () {
        canvas.width = self.width;
        canvas.height = self.height;
        stamp.src = self.stamp;
      };
      stamp.onload = function () {
        context.drawImage(signature, 0, 0);
        context.drawImage(stamp, 0, 0);
        self.$emit('on-save-signature', canvas.toDataURL('image/png'));
        context.clearRect(0, 0, self.width, self.height);
      };
      signature.src = signatureImage;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    clear: function clear() {
      this.signaturePad.clear();
      this.stamp = '';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    checkFile: function checkFile() {
      var file = this.$refs.input.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);

      var self = this;
      reader.addEventListener('load', function () {
        var img = new Image();

        img.onload = function () {
          if (file.type !== self.format) {
            self.$emit('on-upload-error', 'format', self.format);
          } else if (file.size > self.maxFileSize) {
            self.$emit('on-upload-error', 'max-file-size', self.maxFileSize);
          } else if (img.width !== self.width) {
            self.$emit('on-upload-error', 'width', self.width);
          } else if (img.height !== self.height) {
            self.$emit('on-upload-error', 'height', self.height);
          } else {
            self.stamp = reader.result;
          }
        };
        img.src = reader.result;
      }, false);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    selectSignatureFile: function selectSignatureFile() {
      this.$refs.input.value = '';
      this.$refs.input.click();
    }
  }
});

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_avatar_card_vue__ = __webpack_require__(607);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7a2fcbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_avatar_card_vue__ = __webpack_require__(628);
function injectStyle (ssrContext) {
  __webpack_require__(626)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_avatar_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7a2fcbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_avatar_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(627);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("7f7c7cac", content, true, {});

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-avatar-selector{margin-bottom:20px}.avatar-image{margin-top:29px}.avatar-cursor{cursor:pointer}.avatar-content{margin-top:25px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-avatar-card.vue"],"names":[],"mappings":"AACA,yBACE,kBAAoB,CACrB,AACD,cACE,eAAiB,CAClB,AACD,eACE,cAAgB,CACjB,AACD,gBACE,eAAiB,CAClB","file":"vuetify-avatar-card.vue","sourcesContent":["\n.vuetify-avatar-selector {\n  margin-bottom: 20px;\n}\n.avatar-image {\n  margin-top: 29px;\n}\n.avatar-cursor {\n  cursor: pointer;\n}\n.avatar-content {\n  margin-top: 25px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-avatar-selector",attrs:{"tile":""}},[_c('v-card-media',{attrs:{"height":"200px"}},[_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","text-xs-center":"","layout":"","align-center":"","justify-center":""}},[(_vm.item.show_only || false)?_c('v-avatar',{staticClass:"avatar-image",attrs:{"size":"150px"}},[_c('img',{class:_vm.item.show_only ? '' : 'avatar-cursor',attrs:{"src":_vm.item.src ? _vm.item.src : '',"alt":""}})]):_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-avatar',{staticClass:"avatar-image",attrs:{"slot":"activator","size":"150px"},on:{"click":function($event){_vm.changeAvatar()}},slot:"activator"},[_c('img',{attrs:{"src":_vm.item.src ? _vm.item.src : '',"alt":""}})]),_vm._v(" "),_c('span',[_vm._v("Pulsa para cambiar")])],1)],1)],1),_vm._v(" "),_c('input',{ref:"input",staticClass:"input-file",attrs:{"type":"file","id":"avatar","accept":"image/x-png, image/jpeg"},on:{"change":function($event){_vm.checkFile('image/png', 200000, 180, 180)}}})],1),_vm._v(" "),_c('v-card-title',[_vm._t("card-title")],2),_vm._v(" "),_c('v-card-text',[_vm._t("card-text")],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350px"},model:{value:(_vm.item.dialog),callback:function ($$v) {_vm.$set(_vm.item, "dialog", $$v)},expression:"item.dialog"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Cambiar imagen")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-avatar',{staticClass:"avatar avatar-content",attrs:{"size":"250px"}},[_c('v-carousel',{attrs:{"cycle":false,"hide-delimiters":"","hide-controls":!_vm.controls,"lazy":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,ref:"carousel",refInFor:true,attrs:{"src":item.src,"transition":"fade","reverse-transition":"fade"}})}))],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{staticClass:"carousel-actions",attrs:{"row":"","align-center":"","justify-center":""}},[_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.selectAvatarFile()}},slot:"activator"},[_c('v-icon',[_vm._v("file_upload")])],1),_vm._v(" "),_c('span',[_vm._v("Subir imagen de 180 x 180 píxeles en formato PNG")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.saveAvatar()}},slot:"activator"},[_c('v-icon',[_vm._v("check")])],1),_vm._v(" "),_c('span',[_vm._v("Utilizar el seleccionado")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.item.dialog = false}},slot:"activator"},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('span',[_vm._v("Salir")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__ = __webpack_require__(605);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyEditableAddressCard',

  components: {
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_2_vue_google_autocomplete__["a" /* default */]
  },

  props: {
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    placeholder: {
      type: String,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    id: {
      type: String,
      default: 'google',
      required: false
    },
    route: {
      type: Object,
      default: null,
      required: true
    },
    routeExtras: {
      type: Object,
      default: null,
      required: true
    },
    postalCode: {
      type: Object,
      default: null,
      required: true
    },
    locality: {
      type: Object,
      default: null,
      required: true
    },
    province: {
      type: Object,
      default: null,
      required: true
    },
    placeId: {
      type: Object,
      default: null,
      required: false
    },
    checkbox: {
      type: Object,
      default: null,
      required: false
    },
    validateOnChanged: {
      type: Boolean,
      default: false,
      required: false
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    }
  },

  data: function data() {
    return {
      items: [{}, {}, {}, {}, {}, {}],
      dialog: false
    };
  },

  watch: {
    route: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(0, 0, newVal);
      }
    },
    routeExtras: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(1, 0, newVal);
      }
    },
    postalCode: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(2, 0, newVal);
      }
    },
    locality: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(3, 0, newVal);
      }
    },
    province: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(4, 0, newVal);
      }
    },
    placeId: {
      handler: function handler(newVal, oldVal) {
        this.items.splice(5, 0, newVal);
      }
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange() {
      for (var _len = arguments.length, data = Array(_len), _key = 0; _key < _len; _key++) {
        data[_key] = arguments[_key];
      }

      this.$emit.apply(this, ['on-change'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data)));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openDialog: function openDialog() {
      this.dialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.dialog = false;
    },


    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.address = {
        route: addressData.route || '',
        postalCode: addressData.postal_code || '',
        locality: addressData.locality || '',
        province: addressData.administrative_area_level_2 || '',
        country: addressData.country || '',
        latitude: addressData.latitude || '',
        longitude: addressData.longitude || '',
        formattedAddress: placeResultData.formatted_address || '',
        url: placeResultData.url || '',
        placeId: placeResultData.place_id || ''
      };
      var number = addressData.street_number || '';
      number = number ? ', ' + number : '';
      this.address.route += number;

      this.items[0].value = this.address.route || '';
      this.items[1].value = '';
      this.items[2].value = this.address.postalCode || '';
      this.items[3].value = this.address.locality || '';
      this.items[4].value = this.address.province || '';
      this.items[5].value = this.address.placeId || '';

      this.closeDialog();
    }
  }
});

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_editable_form_card_vue__ = __webpack_require__(608);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2965ef8d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_editable_form_card_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(631)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_editable_form_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2965ef8d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_editable_form_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(632);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("6bd58e01", content, true, {});

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-editable-form-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-editable-form-card.vue"],"names":[],"mappings":"AACA,4BACE,kBAAoB,CACrB","file":"vuetify-editable-form-card.vue","sourcesContent":["\n.vuetify-editable-form-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-editable-form-card",attrs:{"tile":"","light":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.toolbarTitle))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('vuetify-form-creator',{ref:"form_creator",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.fields,"validate-on-changed":_vm.validateOnChanged},on:{"on-click-button":_vm.onClickButton,"on-blur":_vm.onChange,"on-change":_vm.onChange,"on-add-item":_vm.onAddItem},model:{value:(_vm.fields),callback:function ($$v) {_vm.fields=$$v},expression:"fields"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_phone_aggregator_vue__ = __webpack_require__(619);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f03cc47c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_phone_aggregator_vue__ = __webpack_require__(662);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_phone_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f03cc47c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_phone_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(657);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("aed2851c", content, true, {});

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-aggregator-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/layouts/vuetify-aggregator-card.vue"],"names":[],"mappings":"AACA,yBACE,kBAAoB,CACrB","file":"vuetify-aggregator-card.vue","sourcesContent":["\n.vuetify-aggregator-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-aggregator-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.toolbarTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{directives:[{name:"show",rawName:"v-show",value:(_vm.$slots['card-text'] && _vm.navigationMenu),expression:"$slots['card-text'] && navigationMenu"}],attrs:{"bottom":"","left":""}},[(_vm.canEdit)?_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1):_vm._e(),_vm._v(" "),_c('v-list',{staticClass:"scroll-y",staticStyle:{"max-height":"282px"}},[_c('v-list-tile',{on:{"click":function($event){_vm.dialog = !_vm.dialog}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.listTitle))])],1)],1)],1)],1),_vm._v(" "),(_vm.$slots['card-text'])?_vm._t("card-text"):_c('v-card-text',[_c('div',{staticClass:"add-area"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.addButton),expression:"addButton"}],attrs:{"slot":"activator","fab":"","dark":"","color":_vm.color},on:{"click":function($event){_vm.dialog = true}},slot:"activator"},[_c('v-icon',{attrs:{"dark":"","large":""}},[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.addButtonHoverText))])],1)],1)]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":_vm.dialogMaxWidth,"persistent":_vm.persistent},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._t("dialog"),_vm._v(" "),(!_vm.$slots['dialog'])?_c('v-card',{attrs:{"tile":""}},[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n              "+_vm._s(_vm.dialogToolbarTitle)+"\n            ")]),_vm._v(" "),_c('v-card-text',[_vm._t("dialog-card-text")],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_vm._t("dialog-card-actions")],2)],1):_vm._e()],2),_vm._v(" "),_vm._t("extras")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(660);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("4a8283a0", content, true, {});

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"vuetify-dialog-confirm.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 661:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{ref:_vm.reference,attrs:{"max-width":_vm.maxWidth},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('v-card',{attrs:{"dark":_vm.dark}},[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secundary","flat":"flat"},nativeOn:{"click":function($event){_vm.onClick('cancel')}}},[_vm._v(_vm._s(_vm.cancel))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"flat"},on:{"click":function($event){_vm.onClick('confirm')}}},[_vm._v(_vm._s(_vm.confirm))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 662:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"list-title":_vm.listTitle,"navigation-menu":_vm.navigationMenu,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle}},[(_vm.items.length > 0)?_c('v-list',{attrs:{"slot":"card-text","two-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100)},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.value))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.type))])],1),_vm._v(" "),(_vm.deleteButton)?_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":_vm.color},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1):_vm._e()],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"slot":"dialog-card-text","row":"","align-center":"","justify-center":""},slot:"dialog-card-text"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg6":""}},[_c('v-form',{ref:"form"},[_c('v-text-field',{attrs:{"label":_vm.textFieldLabel,"single-line":"","required":"","rules":_vm.textFieldRules || []},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg6":""}},[_c('v-select',{attrs:{"items":_vm.types,"label":_vm.selectLabel},model:{value:(_vm.phoneType),callback:function ($$v) {_vm.phoneType=$$v},expression:"phoneType"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('v-btn',{attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("\n      "+_vm._s(_vm.cancelButton)+"\n    ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.addPhone()}}},[_vm._v("\n      "+_vm._s(_vm.confirmButton)+"\n    ")])],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 663:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_signature_aggregator_vue__ = __webpack_require__(623);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9064b8c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_signature_aggregator_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(664)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_signature_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9064b8c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_signature_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(665);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("7e215cb2", content, true, {});

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".signature-image>div{background-size:240px 120px!important}.signature-card{max-height:206px!important}.signature-actions{padding:18px}.fade-enter-active,.fade-leave-active,.fade-leave-to{-webkit-transition:.3s ease-out;transition:.3s ease-out;position:absolute;top:0;left:0}.fade-enter,.fade-leave,.fade-leave-to{opacity:0}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-signature-aggregator.vue"],"names":[],"mappings":"AACA,qBACE,qCAAwC,CACzC,AACD,gBACE,0BAA6B,CAC9B,AACD,mBACE,YAAc,CACf,AACD,qDACE,gCAAiC,AACjC,wBAAyB,AACzB,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACT,AACD,uCACE,SAAW,CACZ","file":"vuetify-signature-aggregator.vue","sourcesContent":["\n.signature-image > div {\n  background-size: 240px 120px !important;\n}\n.signature-card {\n  max-height: 206px !important;\n}\n.signature-actions {\n  padding: 18px;\n}\n.fade-enter-active, .fade-leave-active, .fade-leave-to {\n  -webkit-transition: .3s ease-out;\n  transition: .3s ease-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.fade-enter, .fade-leave, .fade-leave-to {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_signature_pad_vue__ = __webpack_require__(624);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9835709a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_signature_pad_vue__ = __webpack_require__(670);
function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9835709a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vue_signature_pad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9835709a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vue_signature_pad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("32c9f3d1", content, true, {});

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, "#canvas[data-v-9835709a]{display:none}.wrapper[data-v-9835709a]{position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;margin:0 auto}img[data-v-9835709a]{position:absolute;left:0;top:0}.signature-pad[data-v-9835709a]{position:absolute;left:0;top:0;border:2px dashed #ccc}.input-file[data-v-9835709a]{display:none}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vue-signature-pad.vue"],"names":[],"mappings":"AACA,yBACE,YAAc,CACf,AACD,0BACE,kBAAmB,AACnB,sBAAuB,AACvB,yBAA0B,AAC1B,qBAAsB,AACtB,iBAAkB,AAClB,aAAe,CAChB,AACD,qBACE,kBAAmB,AACnB,OAAQ,AACR,KAAO,CACR,AACD,gCACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,sBAAwB,CACzB,AACD,6BACE,YAAc,CACf","file":"vue-signature-pad.vue","sourcesContent":["\n#canvas[data-v-9835709a] {\n  display: none;\n}\n.wrapper[data-v-9835709a] {\n  position: relative;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: 0 auto;\n}\nimg[data-v-9835709a] {\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.signature-pad[data-v-9835709a] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  border: 2px dashed #ccc;\n}\n.input-file[data-v-9835709a] {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */

function Point(x, y, time) {
  this.x = x;
  this.y = y;
  this.time = time || new Date().getTime();
}

Point.prototype.velocityFrom = function (start) {
  return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};

Point.prototype.distanceTo = function (start) {
  return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};

Point.prototype.equals = function (other) {
  return this.x === other.x && this.y === other.y && this.time === other.time;
};

function Bezier(startPoint, control1, control2, endPoint) {
  this.startPoint = startPoint;
  this.control1 = control1;
  this.control2 = control2;
  this.endPoint = endPoint;
}

// Returns approximated length.
Bezier.prototype.length = function () {
  var steps = 10;
  var length = 0;
  var px = void 0;
  var py = void 0;

  for (var i = 0; i <= steps; i += 1) {
    var t = i / steps;
    var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
    var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
    if (i > 0) {
      var xdiff = cx - px;
      var ydiff = cy - py;
      length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
    }
    px = cx;
    py = cy;
  }

  return length;
};

/* eslint-disable no-multi-spaces, space-in-parens */
Bezier.prototype._point = function (t, start, c1, c2, end) {
  return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};

/* eslint-disable */

// http://stackoverflow.com/a/27078401/815507
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function later() {
    previous = options.leading === false ? 0 : Date.now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function () {
    var now = Date.now();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
}

function SignaturePad(canvas, options) {
  var self = this;
  var opts = options || {};

  this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
  this.minWidth = opts.minWidth || 0.5;
  this.maxWidth = opts.maxWidth || 2.5;
  this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
  this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;

  if (this.throttle) {
    this._strokeMoveUpdate = throttle(SignaturePad.prototype._strokeUpdate, this.throttle);
  } else {
    this._strokeMoveUpdate = SignaturePad.prototype._strokeUpdate;
  }

  this.dotSize = opts.dotSize || function () {
    return (this.minWidth + this.maxWidth) / 2;
  };
  this.penColor = opts.penColor || 'black';
  this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
  this.onBegin = opts.onBegin;
  this.onEnd = opts.onEnd;

  this._canvas = canvas;
  this._ctx = canvas.getContext('2d');
  this.clear();

  // We need add these inline so they are available to unbind while still having
  // access to 'self' we could use _.bind but it's not worth adding a dependency.
  this._handleMouseDown = function (event) {
    if (event.which === 1) {
      self._mouseButtonDown = true;
      self._strokeBegin(event);
    }
  };

  this._handleMouseMove = function (event) {
    if (self._mouseButtonDown) {
      self._strokeMoveUpdate(event);
    }
  };

  this._handleMouseUp = function (event) {
    if (event.which === 1 && self._mouseButtonDown) {
      self._mouseButtonDown = false;
      self._strokeEnd(event);
    }
  };

  this._handleTouchStart = function (event) {
    if (event.targetTouches.length === 1) {
      var touch = event.changedTouches[0];
      self._strokeBegin(touch);
    }
  };

  this._handleTouchMove = function (event) {
    // Prevent scrolling.
    event.preventDefault();

    var touch = event.targetTouches[0];
    self._strokeMoveUpdate(touch);
  };

  this._handleTouchEnd = function (event) {
    var wasCanvasTouched = event.target === self._canvas;
    if (wasCanvasTouched) {
      event.preventDefault();
      self._strokeEnd(event);
    }
  };

  // Enable mouse and touch event handlers
  this.on();
}

// Public methods
SignaturePad.prototype.clear = function () {
  var ctx = this._ctx;
  var canvas = this._canvas;

  ctx.fillStyle = this.backgroundColor;
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  this._data = [];
  this._reset();
  this._isEmpty = true;
};

SignaturePad.prototype.fromDataURL = function (dataUrl) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var image = new Image();
  var ratio = options.ratio || window.devicePixelRatio || 1;
  var width = options.width || this._canvas.width / ratio;
  var height = options.height || this._canvas.height / ratio;

  this._reset();
  image.src = dataUrl;
  image.onload = function () {
    _this._ctx.drawImage(image, 0, 0, width, height);
  };
  this._isEmpty = false;
};

SignaturePad.prototype.toDataURL = function (type) {
  var _canvas;

  switch (type) {
    case 'image/svg+xml':
      return this._toSVG();
    default:
      for (var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        options[_key - 1] = arguments[_key];
      }

      return (_canvas = this._canvas).toDataURL.apply(_canvas, [type].concat(options));
  }
};

SignaturePad.prototype.on = function () {
  this._handleMouseEvents();
  this._handleTouchEvents();
};

SignaturePad.prototype.off = function () {
  this._canvas.removeEventListener('mousedown', this._handleMouseDown);
  this._canvas.removeEventListener('mousemove', this._handleMouseMove);
  document.removeEventListener('mouseup', this._handleMouseUp);

  this._canvas.removeEventListener('touchstart', this._handleTouchStart);
  this._canvas.removeEventListener('touchmove', this._handleTouchMove);
  this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype.isEmpty = function () {
  return this._isEmpty;
};

// Private methods
SignaturePad.prototype._strokeBegin = function (event) {
  this._data.push([]);
  this._reset();
  this._strokeUpdate(event);

  if (typeof this.onBegin === 'function') {
    this.onBegin(event);
  }
};

SignaturePad.prototype._strokeUpdate = function (event) {
  var x = event.clientX;
  var y = event.clientY;

  var point = this._createPoint(x, y);
  var lastPointGroup = this._data[this._data.length - 1];
  var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
  var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;

  // Skip this point if it's too close to the previous one
  if (!(lastPoint && isLastPointTooClose)) {
    var _addPoint = this._addPoint(point),
        curve = _addPoint.curve,
        widths = _addPoint.widths;

    if (curve && widths) {
      this._drawCurve(curve, widths.start, widths.end);
    }

    this._data[this._data.length - 1].push({
      x: point.x,
      y: point.y,
      time: point.time,
      color: this.penColor
    });
  }
};

SignaturePad.prototype._strokeEnd = function (event) {
  var canDrawCurve = this.points.length > 2;
  var point = this.points[0]; // Point instance

  if (!canDrawCurve && point) {
    this._drawDot(point);
  }

  if (point) {
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object

    // When drawing a dot, there's only one point in a group, so without this check
    // such group would end up with exactly the same 2 points.
    if (!point.equals(lastPoint)) {
      lastPointGroup.push({
        x: point.x,
        y: point.y,
        time: point.time,
        color: this.penColor
      });
    }
  }

  if (typeof this.onEnd === 'function') {
    this.onEnd(event);
  }
};

SignaturePad.prototype._handleMouseEvents = function () {
  this._mouseButtonDown = false;

  this._canvas.addEventListener('mousedown', this._handleMouseDown);
  this._canvas.addEventListener('mousemove', this._handleMouseMove);
  document.addEventListener('mouseup', this._handleMouseUp);
};

SignaturePad.prototype._handleTouchEvents = function () {
  // Pass touch events to canvas element on mobile IE11 and Edge.
  this._canvas.style.msTouchAction = 'none';
  this._canvas.style.touchAction = 'none';

  this._canvas.addEventListener('touchstart', this._handleTouchStart, {passive: false}); // CUSTOM CHANGE
  this._canvas.addEventListener('touchmove', this._handleTouchMove, {passive: false}); // CUSTOM CHANGE
  this._canvas.addEventListener('touchend', this._handleTouchEnd);
};

SignaturePad.prototype._reset = function () {
  this.points = [];
  this._lastVelocity = 0;
  this._lastWidth = (this.minWidth + this.maxWidth) / 2;
  this._ctx.fillStyle = this.penColor;
};

SignaturePad.prototype._createPoint = function (x, y, time) {
  var rect = this._canvas.getBoundingClientRect();

  return new Point(x - rect.left, y - rect.top, time || new Date().getTime());
};

SignaturePad.prototype._addPoint = function (point) {
  var points = this.points;
  var tmp = void 0;

  points.push(point);

  if (points.length > 2) {
    // To reduce the initial lag make it work with 3 points
    // by copying the first point to the beginning.
    if (points.length === 3) points.unshift(points[0]);

    tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
    var c2 = tmp.c2;
    tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
    var c3 = tmp.c1;
    var curve = new Bezier(points[1], c2, c3, points[2]);
    var widths = this._calculateCurveWidths(curve);

    // Remove the first element from the list,
    // so that we always have no more than 4 points in points array.
    points.shift();

    return { curve: curve, widths: widths };
  }

  return {};
};

SignaturePad.prototype._calculateCurveControlPoints = function (s1, s2, s3) {
  var dx1 = s1.x - s2.x;
  var dy1 = s1.y - s2.y;
  var dx2 = s2.x - s3.x;
  var dy2 = s2.y - s3.y;

  var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
  var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

  var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
  var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

  var dxm = m1.x - m2.x;
  var dym = m1.y - m2.y;

  var k = l2 / (l1 + l2);
  var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

  var tx = s2.x - cm.x;
  var ty = s2.y - cm.y;

  return {
    c1: new Point(m1.x + tx, m1.y + ty),
    c2: new Point(m2.x + tx, m2.y + ty)
  };
};

SignaturePad.prototype._calculateCurveWidths = function (curve) {
  var startPoint = curve.startPoint;
  var endPoint = curve.endPoint;
  var widths = { start: null, end: null };

  var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;

  var newWidth = this._strokeWidth(velocity);

  widths.start = this._lastWidth;
  widths.end = newWidth;

  this._lastVelocity = velocity;
  this._lastWidth = newWidth;

  return widths;
};

SignaturePad.prototype._strokeWidth = function (velocity) {
  return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};

SignaturePad.prototype._drawPoint = function (x, y, size) {
  var ctx = this._ctx;

  ctx.moveTo(x, y);
  ctx.arc(x, y, size, 0, 2 * Math.PI, false);
  this._isEmpty = false;
};

SignaturePad.prototype._drawCurve = function (curve, startWidth, endWidth) {
  var ctx = this._ctx;
  var widthDelta = endWidth - startWidth;
  var drawSteps = Math.floor(curve.length());

  ctx.beginPath();

  for (var i = 0; i < drawSteps; i += 1) {
    // Calculate the Bezier (x, y) coordinate for this step.
    var t = i / drawSteps;
    var tt = t * t;
    var ttt = tt * t;
    var u = 1 - t;
    var uu = u * u;
    var uuu = uu * u;

    var x = uuu * curve.startPoint.x;
    x += 3 * uu * t * curve.control1.x;
    x += 3 * u * tt * curve.control2.x;
    x += ttt * curve.endPoint.x;

    var y = uuu * curve.startPoint.y;
    y += 3 * uu * t * curve.control1.y;
    y += 3 * u * tt * curve.control2.y;
    y += ttt * curve.endPoint.y;

    var width = startWidth + ttt * widthDelta;
    this._drawPoint(x, y, width);
  }

  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._drawDot = function (point) {
  var ctx = this._ctx;
  var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;

  ctx.beginPath();
  this._drawPoint(point.x, point.y, width);
  ctx.closePath();
  ctx.fill();
};

SignaturePad.prototype._fromData = function (pointGroups, drawCurve, drawDot) {
  for (var i = 0; i < pointGroups.length; i += 1) {
    var group = pointGroups[i];

    if (group.length > 1) {
      for (var j = 0; j < group.length; j += 1) {
        var rawPoint = group[j];
        var point = new Point(rawPoint.x, rawPoint.y, rawPoint.time);
        var color = rawPoint.color;

        if (j === 0) {
          // First point in a group. Nothing to draw yet.

          // All points in the group have the same color, so it's enough to set
          // penColor just at the beginning.
          this.penColor = color;
          this._reset();

          this._addPoint(point);
        } else if (j !== group.length - 1) {
          // Middle point in a group.
          var _addPoint2 = this._addPoint(point),
              curve = _addPoint2.curve,
              widths = _addPoint2.widths;

          if (curve && widths) {
            drawCurve(curve, widths, color);
          }
        } else {
          // Last point in a group. Do nothing.
        }
      }
    } else {
      this._reset();
      var _rawPoint = group[0];
      drawDot(_rawPoint);
    }
  }
};

SignaturePad.prototype._toSVG = function () {
  var _this2 = this;

  var pointGroups = this._data;
  var canvas = this._canvas;
  var ratio = Math.max(window.devicePixelRatio || 1, 1);
  var minX = 0;
  var minY = 0;
  var maxX = canvas.width / ratio;
  var maxY = canvas.height / ratio;
  var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

  svg.setAttributeNS(null, 'width', canvas.width);
  svg.setAttributeNS(null, 'height', canvas.height);

  this._fromData(pointGroups, function (curve, widths, color) {
    var path = document.createElement('path');

    // Need to check curve for NaN values, these pop up when drawing
    // lines on the canvas that are not continuous. E.g. Sharp corners
    // or stopping mid-stroke and than continuing without lifting mouse.
    if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
      var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));

      path.setAttribute('d', attr);
      path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
      path.setAttribute('stroke', color);
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke-linecap', 'round');

      svg.appendChild(path);
    }
  }, function (rawPoint) {
    var circle = document.createElement('circle');
    var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
    circle.setAttribute('r', dotSize);
    circle.setAttribute('cx', rawPoint.x);
    circle.setAttribute('cy', rawPoint.y);
    circle.setAttribute('fill', rawPoint.color);

    svg.appendChild(circle);
  });

  var prefix = 'data:image/svg+xml;base64,';
  var header = '<svg' + ' xmlns="http://www.w3.org/2000/svg"' + ' xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
  var body = svg.innerHTML;

  // IE hack for missing innerHTML property on SVGElement
  if (body === undefined) {
    var dummy = document.createElement('dummy');
    var nodes = svg.childNodes;
    dummy.innerHTML = '';

    for (var i = 0; i < nodes.length; i += 1) {
      dummy.appendChild(nodes[i].cloneNode(true));
    }

    body = dummy.innerHTML;
  }

  var footer = '</svg>';
  var data = header + body + footer;

  return prefix + btoa(data);
};

SignaturePad.prototype.fromData = function (pointGroups) {
  var _this3 = this;

  this.clear();

  this._fromData(pointGroups, function (curve, widths) {
    return _this3._drawCurve(curve, widths.start, widths.end);
  }, function (rawPoint) {
    return _this3._drawDot(rawPoint);
  });

  this._data = pointGroups;
};

SignaturePad.prototype.toData = function () {
  return this._data;
};

/* harmony default export */ __webpack_exports__["a"] = (SignaturePad);


/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper",style:({width: _vm.width + 'px', height: _vm.height + 'px'})},[_c('canvas',{ref:"signaturePad",staticClass:"signature-pad",style:('background: url(' + _vm.stamp + ') center center / cover no-repeat;'),attrs:{"width":_vm.width,"height":_vm.height}},[_vm._v("\n      Your browser does not support the canvas element.\n    ")]),_vm._v(" "),_c('canvas',{attrs:{"id":"canvas"}}),_vm._v(" "),_c('input',{ref:"input",staticClass:"input-file",attrs:{"type":"file","id":"signature","accept":"image/x-png"},on:{"change":function($event){_vm.checkFile()}}})]),_vm._v(" "),_c('div',[_vm._t("buttons")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 671:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"persistent":_vm.persistent,"toolbar-title":_vm.theToolbarTitle,"list-title":_vm.listTitle,"navigation-menu":_vm.navigationMenu,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle}},[(_vm.signature.value)?_c('div',{attrs:{"slot":"card-text"},slot:"card-text"},[_c('v-scale-transition',{attrs:{"origin":"center center"}},[(_vm.signature.value)?_c('div',[_c('v-card-media',{staticClass:"signature-image",attrs:{"src":_vm.signature.value || '',"height":"150px"}})],1):_vm._e()])],1):_vm._e(),_vm._v(" "),_c('vue-signature-pad',{ref:"signature",attrs:{"slot":"dialog-card-text"},on:{"on-save-signature":_vm.onSaveSignature,"on-upload-error":_vm.onUploadError},slot:"dialog-card-text"},[_c('template',{slot:"buttons"},[_c('v-layout',{staticClass:"signature-actions",attrs:{"row":"","align-center":"","justify-center":""}},[(!_vm.disableUploadButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.selectSignatureFile()}},slot:"activator"},[_c('v-icon',[_vm._v("file_upload")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.uploadIconHoverText))])],1):_vm._e(),_vm._v(" "),(!_vm.disableClearButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":_vm.clearSignature},slot:"activator"},[_c('v-icon',[_vm._v("settings_backup_restore")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.clearIconHoverText))])],1):_vm._e(),_vm._v(" "),(!_vm.disableSaveButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.setSignature()}},slot:"activator"},[_c('v-icon',[_vm._v("check")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.saveIconHoverText))])],1):_vm._e(),_vm._v(" "),(!_vm.disableDeleteButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.askForConfirmation()}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1):_vm._e(),_vm._v(" "),(!_vm.disableCancelButton)?_c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","fab":"","color":"primary"},on:{"click":function($event){_vm.closeDialog()}},slot:"activator"},[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('span',[_vm._v("Salir")])],1):_vm._e(),_vm._v(" "),(_vm.disableSaveButton)?_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":function($event){_vm.setSignature()}}},[_vm._v(_vm._s(_vm.saveIconHoverText))]):_vm._e(),_vm._v(" "),(_vm.disableSaveButton)?_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":function($event){_vm.closeDialog()}}},[_vm._v("Cancelar")]):_vm._e()],1)],1)],2),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_editable_address_card_vue__ = __webpack_require__(629);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb5ae64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_editable_address_card_vue__ = __webpack_require__(675);
function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_editable_address_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb5ae64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_editable_address_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(674);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("48faa726", content, true, {});

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".input-autocomplete{margin-bottom:32px}.vuetify-editable-address-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-editable-address-card.vue"],"names":[],"mappings":"AACA,oBACE,kBAAoB,CACrB,AACD,+BACE,kBAAoB,CACrB","file":"vuetify-editable-address-card.vue","sourcesContent":["\n.input-autocomplete {\n  margin-bottom: 32px;\n}\n.vuetify-editable-address-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-editable-address-card",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.toolbarTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.navigationMenu)?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.openDialog()}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.listTitle))])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('vuetify-form-creator',{ref:"form_creator",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.items,"validate-on-changed":_vm.validateOnChanged},on:{"on-blur":_vm.onChange,"on-change":_vm.onChange},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n              "+_vm._s(_vm.dialogToolbarTitle)+"\n            ")]),_vm._v(" "),_c('v-layout',{staticClass:"address-autocomplete",attrs:{"row":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"input-autocomplete input-group input-group--dirty input-group--solo input-group--text-field input-group--single-line primary--text"},[_c('div',{staticClass:"input-group__input"},[_c('vue-google-autocomplete',{ref:_vm.id,attrs:{"id":_vm.id,"classname":"form-control","placeholder":_vm.placeholder,"country":"es"},on:{"placechanged":_vm.getAddressData}})],1)])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config_api__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_vuetify_form_creator_fields_vuetify_text_field__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixins_rule__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_vuetify_phone_aggregator__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_vuetify_user_aggregator__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_vuetify_commerce_aggregator__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_vuetify_area_aggregator__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_vuetify_signature_aggregator__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_vuetify_schedule_selector__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_vuetify_avatar_card__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_vuetify_user_observation_aggregator__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_vuetify_editable_address_card__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_vuetify_editable_form_card__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_vue_user_visible_for__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_color__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_color__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_6_mixins_rule__["a" /* default */]],

  components: {
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_4__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */],
    VuetifyTextField: __WEBPACK_IMPORTED_MODULE_5__components_vuetify_form_creator_fields_vuetify_text_field__["a" /* default */],
    VuetifyPhoneAggregator: __WEBPACK_IMPORTED_MODULE_7__components_vuetify_phone_aggregator__["a" /* default */],
    VuetifyAreaAggregator: __WEBPACK_IMPORTED_MODULE_10__components_vuetify_area_aggregator__["a" /* default */],
    VuetifyUserObservationAggregator: __WEBPACK_IMPORTED_MODULE_14__components_vuetify_user_observation_aggregator__["a" /* default */],
    VuetifySignatureAggregator: __WEBPACK_IMPORTED_MODULE_11__components_vuetify_signature_aggregator__["a" /* default */],
    VuetifyScheduleSelector: __WEBPACK_IMPORTED_MODULE_12__components_vuetify_schedule_selector__["a" /* default */],
    VuetifyAvatarCard: __WEBPACK_IMPORTED_MODULE_13__components_vuetify_avatar_card__["a" /* default */],
    VuetifyEditableAddressCard: __WEBPACK_IMPORTED_MODULE_15__components_vuetify_editable_address_card__["a" /* default */],
    VuetifyEditableFormCard: __WEBPACK_IMPORTED_MODULE_16__components_vuetify_editable_form_card__["a" /* default */],
    VuetifyUserAggregator: __WEBPACK_IMPORTED_MODULE_8__components_vuetify_user_aggregator__["a" /* default */],
    VuetifyCommerceAggregator: __WEBPACK_IMPORTED_MODULE_9__components_vuetify_commerce_aggregator__["a" /* default */],
    VisibleFor: __WEBPACK_IMPORTED_MODULE_17__components_vue_user_visible_for__["a" /* default */],
    'chrome-picker': __WEBPACK_IMPORTED_MODULE_18_vue_color__["Chrome"]
  },

  data: function data() {
    return {
      alias: {},
      afterPromises: [],
      colors: [],
      status: {},
      installerColor: {},
      commerceColor: {},
      observations: {},
      businnes: null,
      clickTimer: null,
      avatar: {},
      name: {},
      observation: {
        type: 'select',
        assign_to: 'assignTo',
        editable: true,
        columns: 'xs12',
        label: 'Vendedor',
        item_text: 'seller_name',
        item_value: 'seller_id',
        items: [],
        rules: [],
        return_object: true,
        autocomplete: true
      },
      formattedColor: 'red',
      surname: {},
      username: {},
      password: [],
      renewPasswordDialog: false,
      colorDialog: false,
      schedules: [],
      commercesList: [],
      areas: {},
      businessName: {},
      phone: {},
      signature: {},
      calendar_visibility: {},
      stamp: {},
      account: [],
      fields: [],
      company: [],
      address: {
        dialog: false
      },
      assignedCommerces: [],
      route: {},
      routeExtras: {},
      postalCode: {},
      locality: {},
      province: {},
      corporation: [],
      companyID: {},
      commerceType: {},
      commerceID: {},
      responsibleID: {},
      commerces: {},
      companies: {},
      userID: {},
      AdminID: {},
      isSuper: {},
      sellers: [],
      installers: {},
      installersList: [],
      avatars: [],
      rol: {},
      roles: __WEBPACK_IMPORTED_MODULE_3_config_api__["a" /* default */].roles,
      display: false,
      path: this.$route.path.toLowerCase()
    };
  },
  created: function created() {
    var _this = this;

    this.getProfile().then(function (response) {
      console.log(response);
      _this.normalizeAndAssign(response.data);
      if (_this.isResponsibleAccount()) {
        _this.assignedCommerces = JSON.parse(_this.commerces.value);
      }
      _this.getObservations().then(function (response) {
        console.log(response);
        // console.log('·····dd···', this.roles[this.rol.value - 1])

        if (!_this.isNew() && (_this.isSuperadmin() || _this.isAdmin())) {
          if (!(_this.isInstallerAccount() || _this.isCommerceAccount() || _this.isAdminAccount() || _this.isSuperadminAccount() || _this.isManagerAccount() || _this.isResponsibleAccount())) {
            _this.$awn.alert('No se ha podido acceder a este perfil');
            return setTimeout(function () {
              _this.$router.go(-1);
            }, 4000);
          }
        }

        if (!_this.isNew() && _this.$route.params.username !== 'me' && _this.$route.params && _this.username.value !== _this.$route.params.username) {
          _this.$awn.alert('No se ha podido acceder a este perfil');
          return setTimeout(function () {
            _this.$router.go(-1);
          }, 4000);
        }
        _this.normalizePassword();
        var url = _this.avatar.default;
        _this.avatar.src = _this.avatar.value || _this.avatar.default + '0.png';
        for (var i = 0; i < 50; i++) {
          _this.avatars.push({ src: url + i + '.png' });
        }
        var status = parseInt(_this.status.value);
        if (status !== 3) {
          delete _this.account[2];
        }

        if (_this.corporation[0] && parseInt(_this.corporation[0].value) === 1) {
          _this.corporation[0].value = '';
        }
        if (_this.corporation[1] && parseInt(_this.corporation[1].value) === 1) {
          _this.corporation[1].value = '';
        }
        if (_this.corporation[2] && parseInt(_this.corporation[2].value) === 1) {
          _this.corporation[2].value = '';
        }
        if (_this.corporation[3] && parseInt(_this.corporation[3].value) === 1) {
          _this.corporation[3].value = '';
        }

        console.log('this.corporation', _this.corporation);

        if (_this.isManager() || _this.isResponsible()) {
          _this.avatar.show_only = !_this.isHisAccount();
          _this.account[0].disabled = !_this.isHisAccount();
          _this.account[1].disabled = !_this.isHisAccount();
          _this.fields[0].disabled = true;
          _this.fields[1].disabled = true;
          _this.fields[2].disabled = true;
          _this.route.disabled = true;
          _this.routeExtras.disabled = true;
          _this.postalCode.disabled = true;
          _this.locality.disabled = true;
          _this.province.disabled = true;
          /*
          this.installationInfo[4].type = 'hidden'
          this.customer[0].disabled = true
          this.customer[1].disabled = true
          this.customer[2].disabled = true
          this.customer[3].disabled = true
          this.installationStateForm[0].disabled = true
          this.installationStateCausesForm[0].disabled = true
          this.fields[0].disabled = true
          this.fields[0].type = 'text-field'
          this.fields[1].disabled = true
          this.fields[1].type = 'text-field'
          this.fields[2].disabled = true
          this.fields[2].type = 'text-field'
          this.fields[3].disabled = true
          this.fields[3].type = 'text-field'
          this.fields[4].disabled = true
          this.fields[4].type = 'text-field'
          this.fields[5].disabled = true
          this.fields[5].type = 'text-field'
          this.fields[5].value = this.fields[5].value.seller_name
          this.route.disabled = true
          this.routeExtras.disabled = true
          this.postalCode.disabled = true
          this.locality.disabled = true
          this.province.disabled = true
          this.routeDelivery.disabled = true
          this.routeExtrasDelivery.disabled = true
          this.postalCodeDelivery.disabled = true
          this.localityDelivery.disabled = true
          this.provinceDelivery.disabled = true
          */
        }
        _this.getCommerces().then(function (response) {
          _this.commercesList = response.data.items || [];
          console.log('COMMERCES', response.data.items);
          _this.installerInit(status);
          _this.commerceInit(status);
          _this.adminInit(status);
          _this.managerInit(status);
          _this.responsibleInit(status);
          _this.formattedColor = _this.isCommerceAccount() ? _this.commerceColor.value || 'white' : _this.installerColor.value || 'white';
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
    }).catch(function (error) {
      console.log(error);
    });
  },


  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isNew: function isNew() {
      if (this.$route.params.username) {
        return false;
      } else {
        return true;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeAndAssign: function normalizeAndAssign(params) {
      var _this2 = this;

      var filter = function filter(param, def) {
        return typeof param !== 'undefined' ? param : def;
      };
      params.map(function (obj, index) {
        obj.label = filter(obj.label, undefined);
        obj.ref = filter(obj.ref, '');
        obj.order = filter(obj.order, '');
        obj.assign_to = filter(obj.assign_to, 'fields');
        obj.value_class = filter(obj.value_class, '');
        obj.tooltip = filter(obj.tooltip, 'Pulsa para editar');
        obj.hint = filter(obj.hint, 'Pulsa enter para guardar');
        obj.focusNextOnEnter = filter(obj.focusNextOnEnter, true);
        obj.dark = filter(obj.dark, false);
        obj.color = filter(obj.color, 'primary');
        obj.columns = filter(obj.columns, 'xs12 sm6 md6 lg6');
        obj.counter = filter(obj.counter, false);
        obj.dialog = filter(obj.dialog, false);
        obj.editable = filter(obj.editable, true);
        obj.data_type = filter(obj.data_type, 'str');
        obj.required = filter(obj.required, true);
        obj.disabled = filter(obj.disabled, false);
        obj.type = filter(obj.type, 'text-field');
        obj.autocomplete = filter(obj.autocomplete, obj.ref);
        obj.rules = _this2.setRules(obj.rules);
        var assignTo = Array.isArray(obj.assign_to) ? obj.assign_to : [obj.assign_to];

        assignTo.forEach(function (item) {
          if (Array.isArray(_this2[item])) {
            _this2[item].push(obj);
          } else {
            _this2[item] = obj;
          }
        });
        return obj;
      });
      return params;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizePassword: function normalizePassword() {
      var fields = [{
        type: 'password',
        columns: 'xs12',
        label: this.isSuperadmin() || this.isAdmin() ? 'Nueva contraseña' : 'Contraseña actual',
        assign_to: 'password',
        autocomplete: 'password',
        dialog: false,
        editable: false,
        hint: '',
        rules: ['required']
      }, {
        type: 'password',
        columns: 'xs12',
        label: this.isSuperadmin() || this.isAdmin() ? 'Repetir contraseña' : 'Nueva contraseña',
        assign_to: 'password',
        autocomplete: 'password',
        dialog: false,
        editable: false,
        hint: '',
        rules: ['required']
      }];

      this.normalizeAndAssign(fields);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validateInstaller: function validateInstaller() {
      var account = this.$refs.account.$refs.form_creator.validateForm();
      var fields = this.$refs.fields.$refs.form_creator.validateForm();
      var company = this.$refs.company.$refs.form_creator.validateForm();
      var route = this.$refs.route.$refs.form_creator.validateForm();
      // console.log(this.schedules)
      if (account && fields && company && route) {
        if (this.phone.value.length === 0) {
          return this.$awn.warning('Debes agregar al menos un teléfono');
        } else if (this.areas.length === 0) {
          return this.$awn.warning('Debes agregar al menos un área de trabajo');
        } else if (!this.signature.value) {
          return this.$awn.warning('Debes agregar una firma');
        } else if (!this.stamp.value) {
          return this.$awn.warning('Debes agregar un sello de empresa');
        } else if (this.schedules[0].selected.length + this.schedules[1].selected.length === 0) {
          return this.$awn.warning('Debes habilitar al menos un horario');
        }
        this.status.value = '2';
        this.onChange(this.status.value, null, this.status, true);
        this.$router.push({
          name: 'account',
          params: {
            username: this.username.value
          }
        });
      } else {
        this.$awn.warning('Debes completar todos los campos requeridos');
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validateCommerce: function validateCommerce() {
      var account = this.$refs.account.$refs.form_creator.validateForm();
      var fields = this.$refs.fields.$refs.form_creator.validateForm();

      var corporation = true;
      if (this.isSuperadmin() || this.isAdmin()) {
        corporation = this.$refs.corporation.$refs.form_creator.validateForm();
      }

      var route = this.$refs.route.$refs.form_creator.validateForm();
      if (account && fields && corporation && route) {
        if (this.phone.value.length === 0) {
          return this.$awn.warning('Debes agregar al menos un teléfono');
        } else if (this.sellers.length === 0) {
          return this.$awn.warning('Debes agregar al menos un vendedor');
        } else if (!this.signature.value) {
          return this.$awn.warning('Debes agregar una firma');
        }
        this.status.value = '2';
        this.onChange(this.status.value, null, this.status, true);
        this.$router.push({
          name: 'account',
          params: {
            username: this.username.value
          }
        });
      } else {
        this.$awn.warning('Debes completar todos los campos requeridos');
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validateAdmin: function validateAdmin() {
      var account = this.$refs.account.$refs.form_creator.validateForm();
      var fields = this.$refs.fields.$refs.form_creator.validateForm();
      if (account && fields) {
        this.status.value = '2';
        this.onChange(this.status.value, null, this.status, true);
        this.$router.push({
          name: 'account',
          params: {
            username: this.username.value
          }
        });
      } else {
        this.$awn.warning('Debes completar todos los campos requeridos');
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validateManager: function validateManager() {
      var account = this.$refs.account.$refs.form_creator.validateForm();
      var fields = this.$refs.fields.$refs.form_creator.validateForm();
      var corporation = true;
      if (this.isSuperadmin() || this.isAdmin()) {
        corporation = this.$refs.corporation.$refs.form_creator.validateForm();
      }
      if (account && fields && corporation) {
        this.status.value = '2';
        this.onChange(this.status.value, null, this.status, true);
        this.$router.push({
          name: 'account',
          params: {
            username: this.username.value
          }
        });
      } else {
        this.$awn.warning('Debes completar todos los campos requeridos');
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    validateResponsible: function validateResponsible() {
      var account = this.$refs.account.$refs.form_creator.validateForm();
      var fields = this.$refs.fields.$refs.form_creator.validateForm();
      if (!this.commerces.value) {
        this.$awn.warning('Debes asignar al menos un comercio a este encargado.');
      } else if (this.commerces.value && account && fields) {
        this.status.value = '2';
        this.onChange(this.status.value, null, this.status, true);
        this.$router.push({
          name: 'account',
          params: {
            username: this.username.value
          }
        });
      } else {
        this.$awn.warning('Debes completar todos los campos requeridos');
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    returnToInstallers: function returnToInstallers() {
      this.$router.push({
        name: 'installers'
      });
      this.deleteUser(this.userID.value);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    returnToResponsible: function returnToResponsible() {
      this.$router.push({
        name: 'responsibles'
      });
      this.deleteUser(this.userID.value);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    returnToManager: function returnToManager() {
      this.$router.push({
        name: 'managers'
      });
      this.deleteUser(this.userID.value);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    returnToCommerce: function returnToCommerce() {
      this.$router.push({
        name: 'commerces'
      });
      this.deleteUser(this.userID.value);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    returnToAdmin: function returnToAdmin() {
      this.$router.push({
        name: 'admins'
      });
      this.deleteUser(this.userID.value);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteUser: function deleteUser(userID) {
      var _this3 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'user/profile/' + userID + '/'
      }).then(function (response) {
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
        var message = _this3.$store.getters['api/getMessage'];
        _this3.$awn.alert('Error al guardar: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCommerces: function getCommerces() {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/commerces/'
        }).then(function (response) {
          console.log(response.data);
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this4.$store.dispatch('snackbar/show', 'Error al obtener el perfil: ' + _this4.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getProfile: function getProfile() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var url = '';
        if (_this5.$route.params.username) {
          url = 'user/profile/' + _this5.$route.params.username + '/';
        } else {
          url = 'user/new/' + _this5.$route.params.type + '/';
        }
        _this5.$store.dispatch('api/authRequest', {
          method: 'get',
          url: url
        }).then(function (response) {
          // console.log('USER', response)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          // let message = this.$store.getters['api/getMessage']
          _this5.$awn.alert('No se ha podido acceder a este perfil');
          reject(error.response);
          setTimeout(function () {
            _this5.$router.go(-1);
          }, 4000);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    installerInit: function installerInit(status) {
      var _this6 = this;

      if (this.isInstallerAccount()) {
        this.getInstallationAreas().then(function (response) {
          _this6.areas = response.data;
          _this6.getInstallerSchedules().then(function (response) {
            _this6.schedules = response.data;
            _this6.display = true;
            if (status === 3 && !(_this6.isSuperadmin() || _this6.isAdmin())) {
              _this6.$awn.tip('Debes completar tu perfil para poder acceder al resto del sistema');
            } else if (status === 2 && !(_this6.isSuperadmin() || _this6.isAdmin())) {
              _this6.$awn.tip('Un administrador debe revisar tu perfil para poder acceder al resto del sistema');
            }
          }).catch(function (error) {
            console.log(error);
          });
        }).catch(function (error) {
          console.log(error);
        });
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    managerInit: function managerInit(status) {
      if (this.isManagerAccount()) {
        this.display = true;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    responsibleInit: function responsibleInit(status) {
      if (this.isResponsibleAccount()) {
        this.display = true;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    adminInit: function adminInit(status) {
      if (this.isAdminAccount() || this.isSuperadminAccount()) {
        this.display = true;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isSuperadminAccount: function isSuperadminAccount() {
      return this.roles[this.rol.value - 1] === 'superadmin';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isAdminAccount: function isAdminAccount() {
      return this.roles[this.rol.value - 1] === 'administrator';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isManagerAccount: function isManagerAccount() {
      return this.roles[this.rol.value - 1] === 'manager';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isResponsibleAccount: function isResponsibleAccount() {
      return this.roles[this.rol.value - 1] === 'responsible';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isInstallerAccount: function isInstallerAccount() {
      return this.roles[this.rol.value - 1] === 'installer';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isCommerceAccount: function isCommerceAccount() {
      return this.roles[this.rol.value - 1] === 'commerce';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isSuperadmin: function isSuperadmin() {
      return this.$store.getters['api/getUserRol'] === 'superadmin';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isManager: function isManager() {
      return this.$store.getters['api/getUserRol'] === 'manager';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isResponsible: function isResponsible() {
      return this.$store.getters['api/getUserRol'] === 'responsible';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isAdmin: function isAdmin() {
      return this.$store.getters['api/getUserRol'] === 'administrator';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInstallationAreas: function getInstallationAreas() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var userID = _this7.userID.value;
        _this7.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/installer/installation/area/' + userID + '/'
        }).then(function (response) {
          // console.log(response.data)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          var message = _this7.$store.getters['api/getMessage'];
          _this7.$awn.alert('Error al obtener el perfil: ' + message);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    changeCommerces: function changeCommerces(currentCommerces) {
      this.commerces.value = currentCommerces;
      this.updateItem(this.commerces, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(currentCommerces));
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteInstallerArea: function deleteInstallerArea(item) {
      var _this8 = this;

      // console.log(item)
      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'user/installer/installation/area/' + item.area_id + '/'
      }).then(function (response) {
        // console.log(response)
        if (_this8.status.value < 3) {
          _this8.$awn.success('Área eliminada');
        }
      }).catch(function () {
        var message = _this8.$store.getters['api/getMessage'];
        _this8.$awn.alert('Error al eliminar el área: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInstallerSchedules: function getInstallerSchedules() {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var userID = _this9.userID.value;
        _this9.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/installer/schedules/' + userID + '/'
        }).then(function (response) {
          // console.log(response.data)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          var message = _this9.$store.getters['api/getMessage'];
          _this9.$awn.alert('Error al obtener el perfil: ' + message);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *pause_circle_filled
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addInstallerSchedule: function addInstallerSchedule(item, selected) {
      var _this10 = this;

      var userID = this.userID.value;
      this.$store.dispatch('api/authRequest', {
        method: 'post',
        url: 'user/installer/schedules/' + userID + '/',
        data: {
          schedule_id: item.value
        }
      }).then(function (response) {
        // console.log(response)
        item.id = response.data;
        selected.push(item.value);
        if (_this10.status.value < 3) {
          _this10.$awn.success('Horario agregado');
        }
      }).catch(function (error) {
        console.log(error);
        var message = _this10.$store.getters['api/getMessage'];
        _this10.$awn.alert('Error al guardar: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteInstallerSchedule: function deleteInstallerSchedule(index, item, selected) {
      var _this11 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'user/installer/schedules/' + item.id + '/'
      }).then(function (response) {
        selected.splice(index, 1);
        if (_this11.status.value < 3) {
          _this11.$awn.success('Horario eliminado');
        }
      }).catch(function (error) {
        console.log(error);
        var message = _this11.$store.getters['api/getMessage'];
        _this11.$awn.alert('Error al eliminar la disponibilidad: ' + message);
      });
    },


    /**
     * Get theme style.
     *pause_circle_filled
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addCommerceSeller: function addCommerceSeller(item) {
      var _this12 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'post',
        url: 'user/commerce/sellers/' + this.commerceID.value + '/',
        data: {
          seller_id: item.id,
          seller_avatar: item.avatar,
          seller_gender: item.gender,
          seller_name: item.name
        }
      }).then(function (response) {
        // console.log(response)
        if (_this12.status.value < 3) {
          _this12.$awn.success('Vendedor agregado');
        }
        item.id = response.data;
        _this12.sellers.push(item);
      }).catch(function (error) {
        console.log(error);
        var message = _this12.$store.getters['api/getMessage'];
        _this12.$awn.alert('Error al guardar: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteCommerceSeller: function deleteCommerceSeller(item, index) {
      var _this13 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'user/commerce/sellers/' + item.id + '/'
      }).then(function (response) {
        _this13.sellers.splice(index, 1);
        if (_this13.status.value < 3) {
          _this13.$awn.success('Vendedor eliminado');
        }
        // console.log(response)
      }).catch(function (error) {
        console.log(error);
        _this13.$awn.alert('Este vendedor está asignado a alguna reserva y no puedes eliminarlo.');
      });
    },


    /**
     * Get theme style.
     *pause_circle_filled
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addCommerceInstaller: function addCommerceInstaller(item) {
      if (!this.installers.value) {
        this.installers.value = [];
      }
      this.installers.value.push(parseInt(item.id));
      this.onChange(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.installers.value), null, this.installers, true);
      this.installers.value = JSON.parse(this.installers.value);
      this.getInstallersItems();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteCommerceInstaller: function deleteCommerceInstaller(item, index) {
      var theIndex = this.installers.value.indexOf(parseInt(item.id));
      this.installers.value.splice(theIndex, 1);
      this.installers.items.splice(index, 1);
      this.installersList.push(item);
      this.onChange(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.installers.value), null, this.installers, true);
      this.installers.value = JSON.parse(this.installers.value);
      this.getInstallersItems();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    commerceInit: function commerceInit(status) {
      var _this14 = this;

      if (this.isCommerceAccount()) {
        this.getCommerceSellers().then(function (response) {
          _this14.sellers = _this14.normalizeSellers(response.data);
          if (_this14.isSuperadmin() || _this14.isAdmin()) {
            _this14.getInstallers().then(function (response) {
              _this14.installers.all = _this14.normalizeInstallers(response.data);
              _this14.getInstallersItems();
              if (status === 3 && _this14.installers.all.length === 0) {
                // return this.$awn.warning('Debes agregar instaladores antes de editar o crear comercios')
              }
              _this14.display = true;
            }).catch(function (error) {
              console.log(error);
            });
            // console.log(status)
          } else {
            _this14.display = true;
          }
          if (status === 3 && !(_this14.isSuperadmin() || _this14.isAdmin())) {
            _this14.$awn.tip('Debes completar tu perfil para poder acceder al resto del sistema');
          } else if (status === 2 && !(_this14.isSuperadmin() || _this14.isAdmin())) {
            _this14.$awn.tip('Un administrador debe revisar tu perfil para poder acceder al resto del sistema');
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeInstallers: function normalizeInstallers(params) {
      this.installers.items = [];
      params.items.map(function (obj, index) {
        obj.id = obj[params.item_value];
        obj.name = obj[params.item_text_12];
        obj.avatar = obj[params.item_text_4];
        return obj;
      });
      return params.items;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInstallersItems: function getInstallersItems() {
      var _this15 = this;

      this.installersList = this.installers.all;

      var _loop = function _loop(installerID) {
        var id = _this15.installers.value[installerID];
        var index = _this15.installersList.findIndex(function (item) {
          return parseInt(item.id) === parseInt(id);
        });
        if (index > -1) {
          _this15.installers.items.push(_this15.installersList[index]);
          _this15.installersList.splice(index, 1);
        }
      };

      for (var installerID in this.installers.value) {
        _loop(installerID);
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCommerceSellers: function getCommerceSellers() {
      var _this16 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this16.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/commerce/sellers/' + _this16.commerceID.value + '/'
        }).then(function (response) {
          // console.log(response)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          var message = _this16.$store.getters['api/getMessage'];
          _this16.$awn.alert('Error al obtener el perfil: ' + message);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeSellers: function normalizeSellers(params) {
      params.map(function (obj, index) {
        obj.id = obj.seller_id;
        obj.avatar = obj.seller_avatar;
        obj.gender = obj.seller_gender;
        obj.name = obj.seller_name;
        return obj;
      });
      return params;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getInstallers: function getInstallers() {
      var _this17 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this17.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/installers/'
        }).then(function (response) {
          // console.log('sssssssss', response.data)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          var message = _this17.$store.getters['api/getMessage'];
          _this17.$awn.alert('Error al obtener el perfil: ' + message);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCorporateInformation: function getCorporateInformation() {
      var _this18 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this18.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/commerce/corporate-information/'
        }).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          var message = _this18.$store.getters['api/getMessage'];
          _this18.$awn.alert('Error al obtener el perfil: ' + message);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getUserRol: function getUserRol(rolID) {
      var roles = ['Superadmin', 'Administrador', 'Supervisor', 'Comercio', 'Instalador', 'Invitado', 'Gerente', 'Encargado'];
      return roles[rolID - 1];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeStatus: function onChangeStatus() {
      var userID = parseInt(this.userID.value);
      if (userID === 3 || this.isHisAccount()) {
        return this.$awn.alert('No puedes modificar el estado de este usuario.');
      }
      var status = parseInt(this.status.value) === 1 ? 2 : 1;
      this.status.value = status;
      this.onChange(this.status.value, null, this.status, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    isHisAccount: function isHisAccount() {
      return parseInt(this.userID.value) === parseInt(this.$store.getters['api/getUserId']);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeCalendarVisibility: function onChangeCalendarVisibility() {
      this.calendar_visibility.value = parseInt(this.calendar_visibility.value) === 1 ? 0 : 1;
      this.onChange(this.calendar_visibility.value, null, this.calendar_visibility, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeRole: function onChangeRole() {
      if (parseInt(this.userID.value) === 3) {
        return this.$awn.alert('No puedes modificar los privilegios de este usuario.');
      }
      this.rol.value = parseInt(this.rol.value) === 1 ? 2 : 1;
      this.onChange(this.rol.value, null, this.rol, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangePhone: function onChangePhone() {
      this.onChange(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.phone.value), null, this.phone, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeSignature: function onChangeSignature() {
      this.onChange(this.signature.value, null, this.signature, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeStamp: function onChangeStamp() {
      this.onChange(this.stamp.value, null, this.stamp, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeAvatar: function onChangeAvatar(item) {
      item.value = item.src;
      this.onChange(item.src, null, item, true);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onUploadError: function onUploadError(type, requiredValue) {
      var errors = {
        'format': 'ERROR: La imagen debe tener un formato: ' + requiredValue,
        'max-file-size': 'ERROR: La imagen no debe superar los ' + requiredValue / 1000 + 'kB',
        'width': 'ERROR: La imagen debe tener un ancho de ' + requiredValue + 'px',
        'height': 'ERROR: La imagen debe tener un alto de ' + requiredValue + 'px'
      };
      this.$awn.alert(errors[type]);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange(newVal, oldVal, item, isValid) {
      if (this.$store.getters['api/getStatus'] !== 'loading') {
        if (this.display && isValid) {
          if (item.business_relations && this.isManagerAccount()) {
            item.table = 'managers';
          }
          if (item.assign_to !== 'avatar' && item.assign_to !== 'phone') {
            item.value = newVal;
          }
          if (item.type === 'text-field') {
            this.updateItem(item, item.value);
          } else if (newVal && item.type === 'select') {
            this.updateItem(item, newVal[item.item_value]);
            item.value = newVal;
          } else if (item.ref === 'password' && isValid) {
            this.updateItem(item, item.value);
          }
        }
      }
      if (item.business_relations && this.isCommerceAccount()) {
        this.normalizeBusiness(item);
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddItem: function onAddItem(newVal, oldVal, item, isValid) {
      var _this19 = this;

      var userID = this.userID.value;
      this.$store.dispatch('api/authRequest', {
        method: 'post',
        url: 'user/profile/' + userID + '/',
        data: {
          controller: item.item_controller,
          value: newVal
        }
      }).then(function (response) {
        var _value;

        // console.log(response)
        var value = (_value = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_value, item.item_text, newVal), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_value, item.item_value, response.data), _value);
        item.items.unshift(value);
        item.value = item.items[0];
      }).catch(function (error) {
        console.log(error);
        _this19.$awn.alert('Al agregar nuevo elemento');
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeBusiness: function normalizeBusiness(item) {
      var _this20 = this;

      var currentBrandID = item.value[item.item_value];

      if (item.business_relations[currentBrandID]) {
        if (!this.businnes) {
          this.businnes = this.corporation[3].items;
        }
        var brandModels = item.business_relations[currentBrandID];

        var items = [];
        this.businnes.forEach(function (obj) {
          var modelID = obj[_this20.corporation[3].item_value];

          if (brandModels.indexOf(modelID) > -1) {
            items.push(obj);
          }
        });
        this.corporation[3].items = items;
        this.corporation[3].value = items ? this.corporation[3].value ? this.corporation[3].value : [] : [];
      } else {
        this.corporation[3].items = [];
        this.corporation[3].value = '';
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    updateItem: function updateItem(item, value) {
      var _this21 = this;

      var userID = this.userID.value;
      this.$store.dispatch('api/authRequest', {
        method: 'put',
        url: 'user/profile/' + userID + '/',
        data: {
          table: item.table,
          column: item.column,
          data_type: item.data_type,
          value: value
        }
      }).then(function (response) {
        // console.log(response)
        if (response.data && _this21.status.value < 3) {
          _this21.$awn.success('¡Hecho!');
        } else if (!response.data && _this21.status.value < 3) {
          var message = _this21.$store.getters['api/getMessage'];
          _this21.$awn.alert('Error al guardar: ' + message);
        }
        // this.runPendingPromises()
      }).catch(function (error) {
        console.log(error);
        var message = _this21.$store.getters['api/getMessage'];
        _this21.$awn.alert('Error al guardar: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    changePassword: function changePassword() {
      var _this22 = this;

      if (this.$refs.form_creator.validateForm()) {
        if (this.isSuperadmin() || this.isAdmin()) {
          if (this.password[0].value !== this.password[1].value) {
            return this.$awn.warning('Las contraseñas no coinciden');
          }
        }
        var userID = this.userID.value;
        this.$store.dispatch('api/authRequest', {
          method: 'put',
          url: 'user/change-password/' + userID + '/',
          data: {
            old: this.password[0].value,
            new: this.password[1].value
          }
        }).then(function (response) {
          // console.log(response)
          _this22.renewPasswordDialog = false;
          _this22.password[0].value = '';
          _this22.password[1].value = '';
          _this22.$refs.form_creator.reset();
          if (_this22.status.value < 3) {
            _this22.$awn.success('Contraseña modificada');
          }
        }).catch(function (error) {
          console.log(error);
          var message = _this22.$store.getters['api/getMessage'];
          _this22.$awn.alert('Error: ' + message);
        });
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getObservations: function getObservations() {
      var _this23 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!(_this23.isSuperadmin() || _this23.isAdmin())) {
          resolve(true);
          return true;
        }
        var userID = _this23.userID.value;
        _this23.$store.dispatch('api/authRequest', {
          method: 'get',
          url: 'user/observations/' + userID + '/'
        }).then(function (response) {
          _this23.observation.items = response.data;
          // console.log(response)
          resolve(response);
        }).catch(function (error) {
          console.log(error);
          _this23.$store.dispatch('snackbar/show', 'Error al obtener observaciones: ' + _this23.$store.getters['api/getMessage']);
          reject(error.response);
        });
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    updateColor: function updateColor(color) {
      var _this24 = this;

      this.formattedColor = color.rgba ? 'rgba(' + color.rgba.r + ',' + color.rgba.g + ',' + color.rgba.b + ',' + color.rgba.a + ')' : color;
      clearTimeout(this.clickTimer);
      this.clickTimer = setTimeout(function () {
        console.log('updateColor');
        var item = _this24.isCommerceAccount() ? _this24.commerceColor : _this24.installerColor;
        item.value = _this24.formattedColor;
        _this24.updateItem(item, item.value);
      }, 1000);
      if (this.isInstallerAccount()) {
        this.colorDialog = false;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddObservation: function onAddObservation(item) {
      var _this25 = this;

      item.from_user_id = parseInt(this.$store.getters['api/getUserId']);
      item.to_user_id = parseInt(this.userID.value);
      // console.log('OBSERVATION', item)
      this.$store.dispatch('api/authRequest', {
        method: 'post',
        url: 'user/observations/',
        data: item
      }).then(function (response) {
        // console.log('onAddObservation', response.data)
        item.user_observation_id = response.data;
        item.user_observation_user = 'Tú';
        _this25.observation.items.push(item);
        if (!_this25.isNew()) {
          _this25.$awn.success('Observación agregada');
        }
      }).catch(function (error) {
        console.log(error);
        var message = _this25.$store.getters['api/getMessage'];
        _this25.$awn.alert('Error al agregar la nota: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteObservation: function deleteObservation(index, item) {
      var _this26 = this;

      this.$store.dispatch('api/authRequest', {
        method: 'delete',
        url: 'user/observations/' + item.user_observation_id + '/'
      }).then(function (response) {
        // console.log(response)
        _this26.observation.items.splice(index, 1);
        if (!_this26.isNew()) {
          _this26.$awn.success('Observación eliminada');
        }
      }).catch(function () {
        var message = _this26.$store.getters['api/getMessage'];
        _this26.$awn.alert('Error al eliminar la observación: ' + message);
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    runPendingPromises: function runPendingPromises() {
      var _this27 = this;

      this.afterPromises.reverse();
      this.afterPromises.forEach(function (promise, index) {
        promise();
        _this27.afterPromises.splice(index, 1);
      });
    }
  },

  watch: {
    'username.value': {
      handler: function handler(newVal, oldVal) {
        var _this28 = this;

        this.afterPromises.push(function () {
          _this28.$router.push({
            name: 'account',
            params: {
              username: newVal
            }
          });
        });
      }
    }
  }
});

/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vuetify_form_creator_fields_vuetify_select__ = __webpack_require__(529);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyUserAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__["a" /* default */],
    VuetifySelect: __WEBPACK_IMPORTED_MODULE_2__components_vuetify_form_creator_fields_vuetify_select__["a" /* default */]
  },

  props: {
    users: {
      type: Array,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    navigationMenu: {
      type: Boolean,
      default: true,
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    usersList: {
      type: Array,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    leftIcon: {
      type: String,
      default: 'supervisor_account',
      required: false
    },
    addOnEnter: {
      type: Boolean,
      default: false,
      required: false
    },
    hiddenMenuWhenNoOptions: {
      type: Boolean,
      default: false,
      required: false
    },
    returnObject: {
      type: Boolean,
      default: false,
      required: false
    },
    noDataText: {
      type: String,
      default: false,
      required: false
    },
    value: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      showConfirmButton: true,
      select: {
        items: [],
        item_text: 'name',
        item_value: 'id',
        label: '',
        no_data_text: null,
        value: [],
        dark: false,
        color: 'primary',
        columns: 'xs12 sm6 md6 lg6',
        disabled: false,
        autocomplete: true
      },
      list: null,
      name: null
    };
  },

  created: function created() {
    this.select.items = this.usersList;
    this.select.label = this.textFieldLabel;
    this.select.no_data_text = this.noDataText;
    this.select.return_object = this.returnObject;
  },


  watch: {
    usersList: {
      handler: function handler(newVal, oldVal) {
        this.list = newVal;
        this.select.items = this.usersList;
      },
      deep: true
    },

    users: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onAddItem: function onAddItem(newVal, oldVal, item, isValid) {
      if (this.addOnEnter && !this.showConfirmButton) {
        this.$refs.aggregator.dialog = false;
        this.$refs.form.reset();
        this.$emit('on-add-new-user', newVal, oldVal, item, isValid);
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange(newVal, oldVal, item, isValid) {
      if (isValid && newVal !== oldVal) {
        this.select.value = newVal;
      }
      this.showConfirmButton = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onKeyup: function onKeyup() {
      if (this.addOnEnter) {
        this.showConfirmButton = this.$refs.select.filteredItems;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deleteUser();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteUser: function deleteUser() {
      this.$emit('on-delete-user', this.items[this.currentIndex], this.currentIndex);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addUser: function addUser() {
      this.$refs.aggregator.dialog = false;
      var item = {
        id: this.select.value.id ? this.select.value.id : 0,
        avatar: '',
        gender: '',
        name: this.select.value.name ? this.select.value.name : this.name
      };

      this.$refs.form.reset();
      this.$emit('on-add-user', item);
    }
  }
});

/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_google_autocomplete__ = __webpack_require__(605);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyCommerceAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__["a" /* default */],
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_2__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_3_vue_google_autocomplete__["a" /* default */]
  },

  props: {
    commerces: {
      default: null,
      required: true
    },
    commercesList: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 350,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete commerce',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: '¿Delete commerce?',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    locationIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: null,
      businessSelect: [],
      businessSelected: null,
      companiesSelect: [],
      companySelected: null,
      commercesSelect: [],
      commerceSelected: null,
      phoneType: null,
      phoneNumber: null,
      humanizeDuration: __webpack_require__(701),
      address: {
        dialog: false,
        data: null
      },
      commerce: {
        current: {
          id: 0,
          index: 0
        },
        dialog: false,
        iframe: {
          dialog: false
        },
        visible: false,
        form: [{
          ref: '',
          type: 'radio-group',
          label: 'Selecciona el área a habilitar:',
          columns: 'xs12 sm12 md12 lg12',
          value: '',
          class: 'commerce-radio-group',
          itemText: 'quantity_value',
          itemValue: 'quantity_id',
          avatars: false,
          options: [{
            value: 'commerce_postal_code',
            visible: false,
            label: '',
            hint: ''
          }, {
            value: 'commerce_locality',
            visible: false,
            label: '',
            hint: ''
          }, {
            value: 'commerce_province',
            visible: false,
            label: '',
            hint: ''
          }, {
            value: 'commerce_distance',
            visible: false,
            label: '',
            hint: ''
          }, {
            value: 'commerce_duration',
            visible: false,
            label: '',
            hint: ''
          }],
          rules: [],
          required: true,
          autocomplete: true,
          disabled: false,
          chips: true
        }, {
          ref: 'distance',
          type: 'slider',
          label: 'Distancia',
          columns: 'xs12 sm12 md12 lg12',
          visible: false,
          value: 10,
          min: 1,
          max: 1000
        }, {
          ref: 'duration',
          type: 'slider',
          label: 'Tiempo',
          columns: 'xs12 sm12 md12 lg12',
          visible: false,
          value: 3600000,
          step: 60000,
          min: 60000,
          max: 86400000
        }],
        distance: 0
      }
    };
  },

  created: function created() {
    if (this.commerces.length > 0) {
      this.normalizeCommerces(this.commerces);
    }
  },


  watch: {
    commerces: {
      handler: function handler(newVal, oldVal) {
        this.normalizeCommerces(newVal);
      },
      deep: true
    },
    commercesList: {
      handler: function handler(newVal, oldVal) {
        this.normalizeCommerces(newVal);
        this.getBusiness();
      },
      deep: true
    },
    businessSelected: {
      handler: function handler(newVal, oldVal) {
        this.getCompanies();
      },
      deep: true
    },
    companySelected: {
      handler: function handler(newVal, oldVal) {
        this.getCommerces();
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        // this.$emit('update:value', newVal)
      },
      deep: true
    },
    'commerce.form.0.value': {
      handler: function handler(newVal, oldVal) {
        console.log(newVal);
        this.commerce.form[1].visible = false;
        this.commerce.form[2].visible = false;
        if (newVal === 'commerce_distance') {
          this.commerce.form[1].visible = true;
        } else if (newVal === 'commerce_duration') {
          this.commerce.form[2].visible = true;
        }
      },
      deep: true
    },
    'commerce.form.1.value': {
      handler: function handler(newVal, oldVal) {
        this.address.data.distance = newVal;
      },
      deep: true
    },
    'commerce.form.2.value': {
      handler: function handler(newVal, oldVal) {
        this.address.data.duration = newVal;
      },
      deep: true
    }
  },

  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange() {
      this.updateAreaOptions();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openExternalMap: function openExternalMap(url) {
      window.open(url, '_blank');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onFocusAutocomplete: function onFocusAutocomplete(ref) {
      // this.$refs[ref].clear()
      // this.address.data = null
      // this.commerce.form[0].value = null
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeCommerces: function normalizeCommerces() {
      var _this = this;

      var commerces = [];

      var _loop = function _loop(i) {
        var commerceId = parseInt(_this.commerces[i] || 0);

        var index = _this.commercesList.findIndex(function (item) {
          return parseInt(item.commerce_id) === commerceId;
        });

        var commerce = _this.commercesList[index] || null;

        if (commerce) {
          commerces.push(commerce);
        }
      };

      for (var i = 0; i < this.commerces.length; i++) {
        _loop(i);
      }
      this.items = commerces;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getBusiness: function getBusiness() {
      var business = [];
      this.commercesList.forEach(function (commerce) {
        var index = business.findIndex(function (item) {
          return parseInt(item.value) === parseInt(commerce.business_id);
        });

        if (index === -1) {
          business.push({
            text: commerce.business_name,
            value: commerce.business_id
          });
        }
      });
      this.businessSelect = business.sort(function (a, b) {
        return a.text - b.text;
      });
      this.companySelected = null;
      this.companiesSelect = [];
      this.commerceSelected = null;
      this.commercesSelect = [];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCompanies: function getCompanies() {
      var _this2 = this;

      var companies = [];
      this.commercesList.forEach(function (commerce) {
        if (parseInt(commerce.business_id) === parseInt(_this2.businessSelected)) {
          var index = companies.findIndex(function (item) {
            return parseInt(item.value) === parseInt(commerce.company_id);
          });

          if (index === -1) {
            companies.push({
              text: commerce.company_name,
              value: commerce.company_id
            });
          }
        }
      });
      this.companiesSelect = companies.sort(function (a, b) {
        return a.text - b.text;
      });
      this.commerceSelected = null;
      this.commercesSelect = [];
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    getCommerces: function getCommerces() {
      var _this3 = this;

      var commerces = [];
      this.commercesList.forEach(function (commerce) {
        if (parseInt(commerce.company_id) === parseInt(_this3.companySelected)) {
          var index = commerces.findIndex(function (item) {
            return parseInt(item.value) === parseInt(commerce.commerce_id);
          });

          if (index === -1) {
            commerces.push({
              text: commerce.commerce_name,
              value: commerce.commerce_id
            });
          }
        }
      });
      this.commercesSelect = commerces.sort(function (a, b) {
        return a.text - b.text;
      });
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addCommerce: function addCommerce() {
      if (this.commerces.indexOf(parseInt(this.commerceSelected)) === -1) {
        this.commerces.push(this.commerceSelected);
        this.normalizeCommerces();
        this.$emit('on-add-commerce', this.commerces);
      }
      this.closeDialog();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeDialog: function closeDialog() {
      this.$refs.aggregator.dialog = false;
      this.businessSelected = null;
      this.companySelected = null;
      this.companiesSelect = [];
      this.commerceSelected = null;
      this.commercesSelect = [];
    },


    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.address.data = {
        route: addressData.route || '',
        postalCode: addressData.postal_code || '',
        locality: addressData.locality || '',
        province: addressData.administrative_commerce_level_2 || '',
        country: addressData.country || '',
        latitude: addressData.latitude || '',
        longitude: addressData.longitude || '',
        formattedAddress: placeResultData.formatted_address || '',
        url: placeResultData.url || '',
        distance: this.commerce.form[1].value || '',
        duration: this.commerce.form[2].value || '',
        placeID: placeResultData.place_id || ''
      };
      var number = addressData.street_number || '';
      number = number ? ', ' + number : '';
      this.address.data.route += number;
      this.updateAreaOptions();
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    updateAreaOptions: function updateAreaOptions() {
      if (!this.address.data) {
        return;
      }
      if (this.address.data.postalCode !== '') {
        this.commerce.form[0].options[0].label = this.address.data.postalCode + ' (código postal)';
        this.commerce.form[0].options[0].hint = 'Todo el código postal ' + this.address.data.postalCode + '.';
        this.commerce.form[0].options[0].visible = true;
      } else {
        this.commerce.form[0].options[0].visible = false;
      }
      if (this.address.data.locality !== '') {
        this.commerce.form[0].options[1].label = this.address.data.locality + ' (localidad)';
        this.commerce.form[0].options[1].hint = 'Toda localidad de ' + this.address.data.locality + '.';
        this.commerce.form[0].options[1].visible = true;
      } else {
        this.commerce.form[0].options[1].visible = false;
      }
      if (this.address.data.province !== '') {
        this.commerce.form[0].options[2].label = this.address.data.province + ' (provincia)';
        this.commerce.form[0].options[2].hint = 'Toda la provincia de ' + this.address.data.province + '.';
        this.commerce.form[0].options[2].visible = true;
      } else {
        this.commerce.form[0].options[2].visible = false;
      }
      if (this.address.data.placeID !== '') {
        this.commerce.form[0].options[3].label = this.address.data.distance + ' Km (distancia)';
        this.commerce.form[0].options[3].hint = 'Trayectos a una distancia máxima de ' + this.commerce.form[1].value + ' Km conduciendo desde esta ubicación.';
        this.commerce.form[0].options[3].visible = true;
      } else {
        this.commerce.form[0].options[3].visible = false;
      }
      if (this.address.data.placeID !== '') {
        var time = this.humanizeDuration(this.address.data.duration, {
          language: 'es',
          round: true,
          units: ['d', 'h', 'm'],
          delimiter: ' y '
        });
        this.commerce.form[0].options[4].label = time + ' (duración)';
        this.commerce.form[0].options[4].hint = 'Trayectos de una duración máxima de ' + time + ' conduciendo desde la ubicación seleccionada.';
        this.commerce.form[0].options[4].visible = true;
      } else {
        this.commerce.form[0].options[4].visible = false;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deleteArea();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteArea: function deleteArea() {
      if (this.commerces.length > 1) {
        this.items.splice(this.currentIndex, 1);
        this.commerces.splice(this.currentIndex, 1);
        this.$emit('on-add-commerce', this.commerces);
      } else {
        this.$awn.warning('Al menos un comercio debe estar asignado a este encargado.');
      }
    }
  }
});

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// HumanizeDuration.js - http://git.io/j0HgmQ

;(function () {
  var languages = {
    ar: {
      y: function (c) { return c === 1 ? 'سنة' : 'سنوات' },
      mo: function (c) { return c === 1 ? 'شهر' : 'أشهر' },
      w: function (c) { return c === 1 ? 'أسبوع' : 'أسابيع' },
      d: function (c) { return c === 1 ? 'يوم' : 'أيام' },
      h: function (c) { return c === 1 ? 'ساعة' : 'ساعات' },
      m: function (c) { return c === 1 ? 'دقيقة' : 'دقائق' },
      s: function (c) { return c === 1 ? 'ثانية' : 'ثواني' },
      ms: function (c) { return c === 1 ? 'جزء من الثانية' : 'أجزاء من الثانية' },
      decimal: ','
    },
    bg: {
      y: function (c) { return ['години', 'година', 'години'][getSlavicForm(c)] },
      mo: function (c) { return ['месеца', 'месец', 'месеца'][getSlavicForm(c)] },
      w: function (c) { return ['седмици', 'седмица', 'седмици'][getSlavicForm(c)] },
      d: function (c) { return ['дни', 'ден', 'дни'][getSlavicForm(c)] },
      h: function (c) { return ['часа', 'час', 'часа'][getSlavicForm(c)] },
      m: function (c) { return ['минути', 'минута', 'минути'][getSlavicForm(c)] },
      s: function (c) { return ['секунди', 'секунда', 'секунди'][getSlavicForm(c)] },
      ms: function (c) { return ['милисекунди', 'милисекунда', 'милисекунди'][getSlavicForm(c)] },
      decimal: ','
    },
    ca: {
      y: function (c) { return 'any' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'mes' + (c === 1 ? '' : 'os') },
      w: function (c) { return 'setman' + (c === 1 ? 'a' : 'es') },
      d: function (c) { return 'di' + (c === 1 ? 'a' : 'es') },
      h: function (c) { return 'hor' + (c === 1 ? 'a' : 'es') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segon' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milisegon' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    cs: {
      y: function (c) { return ['rok', 'roku', 'roky', 'let'][getCzechOrSlovakForm(c)] },
      mo: function (c) { return ['měsíc', 'měsíce', 'měsíce', 'měsíců'][getCzechOrSlovakForm(c)] },
      w: function (c) { return ['týden', 'týdne', 'týdny', 'týdnů'][getCzechOrSlovakForm(c)] },
      d: function (c) { return ['den', 'dne', 'dny', 'dní'][getCzechOrSlovakForm(c)] },
      h: function (c) { return ['hodina', 'hodiny', 'hodiny', 'hodin'][getCzechOrSlovakForm(c)] },
      m: function (c) { return ['minuta', 'minuty', 'minuty', 'minut'][getCzechOrSlovakForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekund'][getCzechOrSlovakForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekund'][getCzechOrSlovakForm(c)] },
      decimal: ','
    },
    da: {
      y: 'år',
      mo: function (c) { return 'måned' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'uge' + (c === 1 ? '' : 'r') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'e') },
      h: function (c) { return 'time' + (c === 1 ? '' : 'r') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 'ter') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    de: {
      y: function (c) { return 'Jahr' + (c === 1 ? '' : 'e') },
      mo: function (c) { return 'Monat' + (c === 1 ? '' : 'e') },
      w: function (c) { return 'Woche' + (c === 1 ? '' : 'n') },
      d: function (c) { return 'Tag' + (c === 1 ? '' : 'e') },
      h: function (c) { return 'Stunde' + (c === 1 ? '' : 'n') },
      m: function (c) { return 'Minute' + (c === 1 ? '' : 'n') },
      s: function (c) { return 'Sekunde' + (c === 1 ? '' : 'n') },
      ms: function (c) { return 'Millisekunde' + (c === 1 ? '' : 'n') },
      decimal: ','
    },
    en: {
      y: function (c) { return 'year' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'month' + (c === 1 ? '' : 's') },
      w: function (c) { return 'week' + (c === 1 ? '' : 's') },
      d: function (c) { return 'day' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hour' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minute' + (c === 1 ? '' : 's') },
      s: function (c) { return 'second' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'millisecond' + (c === 1 ? '' : 's') },
      decimal: '.'
    },
    es: {
      y: function (c) { return 'año' + (c === 1 ? '' : 's') },
      mo: function (c) { return 'mes' + (c === 1 ? '' : 'es') },
      w: function (c) { return 'semana' + (c === 1 ? '' : 's') },
      d: function (c) { return 'día' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hora' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minuto' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segundo' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milisegundo' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    fa: {
      y: 'سال',
      mo: 'ماه',
      w: 'هفته',
      d: 'روز',
      h: 'ساعت',
      m: 'دقیقه',
      s: 'ثانیه',
      ms: 'میلی ثانیه',
      decimal: '.'
    },
    fi: {
      y: function (c) { return c === 1 ? 'vuosi' : 'vuotta' },
      mo: function (c) { return c === 1 ? 'kuukausi' : 'kuukautta' },
      w: function (c) { return 'viikko' + (c === 1 ? '' : 'a') },
      d: function (c) { return 'päivä' + (c === 1 ? '' : 'ä') },
      h: function (c) { return 'tunti' + (c === 1 ? '' : 'a') },
      m: function (c) { return 'minuutti' + (c === 1 ? '' : 'a') },
      s: function (c) { return 'sekunti' + (c === 1 ? '' : 'a') },
      ms: function (c) { return 'millisekunti' + (c === 1 ? '' : 'a') },
      decimal: ','
    },
    fr: {
      y: function (c) { return 'an' + (c >= 2 ? 's' : '') },
      mo: 'mois',
      w: function (c) { return 'semaine' + (c >= 2 ? 's' : '') },
      d: function (c) { return 'jour' + (c >= 2 ? 's' : '') },
      h: function (c) { return 'heure' + (c >= 2 ? 's' : '') },
      m: function (c) { return 'minute' + (c >= 2 ? 's' : '') },
      s: function (c) { return 'seconde' + (c >= 2 ? 's' : '') },
      ms: function (c) { return 'milliseconde' + (c >= 2 ? 's' : '') },
      decimal: ','
    },
    gr: {
      y: function (c) { return c === 1 ? 'χρόνος' : 'χρόνια' },
      mo: function (c) { return c === 1 ? 'μήνας' : 'μήνες' },
      w: function (c) { return c === 1 ? 'εβδομάδα' : 'εβδομάδες' },
      d: function (c) { return c === 1 ? 'μέρα' : 'μέρες' },
      h: function (c) { return c === 1 ? 'ώρα' : 'ώρες' },
      m: function (c) { return c === 1 ? 'λεπτό' : 'λεπτά' },
      s: function (c) { return c === 1 ? 'δευτερόλεπτο' : 'δευτερόλεπτα' },
      ms: function (c) { return c === 1 ? 'χιλιοστό του δευτερολέπτου' : 'χιλιοστά του δευτερολέπτου' },
      decimal: ','
    },
    hu: {
      y: 'év',
      mo: 'hónap',
      w: 'hét',
      d: 'nap',
      h: 'óra',
      m: 'perc',
      s: 'másodperc',
      ms: 'ezredmásodperc',
      decimal: ','
    },
    id: {
      y: 'tahun',
      mo: 'bulan',
      w: 'minggu',
      d: 'hari',
      h: 'jam',
      m: 'menit',
      s: 'detik',
      ms: 'milidetik',
      decimal: '.'
    },
    is: {
      y: 'ár',
      mo: function (c) { return 'mánuð' + (c === 1 ? 'ur' : 'ir') },
      w: function (c) { return 'vik' + (c === 1 ? 'a' : 'ur') },
      d: function (c) { return 'dag' + (c === 1 ? 'ur' : 'ar') },
      h: function (c) { return 'klukkutím' + (c === 1 ? 'i' : 'ar') },
      m: function (c) { return 'mínút' + (c === 1 ? 'a' : 'ur') },
      s: function (c) { return 'sekúnd' + (c === 1 ? 'a' : 'ur') },
      ms: function (c) { return 'millisekúnd' + (c === 1 ? 'a' : 'ur') },
      decimal: '.'
    },
    it: {
      y: function (c) { return 'ann' + (c === 1 ? 'o' : 'i') },
      mo: function (c) { return 'mes' + (c === 1 ? 'e' : 'i') },
      w: function (c) { return 'settiman' + (c === 1 ? 'a' : 'e') },
      d: function (c) { return 'giorn' + (c === 1 ? 'o' : 'i') },
      h: function (c) { return 'or' + (c === 1 ? 'a' : 'e') },
      m: function (c) { return 'minut' + (c === 1 ? 'o' : 'i') },
      s: function (c) { return 'second' + (c === 1 ? 'o' : 'i') },
      ms: function (c) { return 'millisecond' + (c === 1 ? 'o' : 'i') },
      decimal: ','
    },
    ja: {
      y: '年',
      mo: '月',
      w: '週',
      d: '日',
      h: '時間',
      m: '分',
      s: '秒',
      ms: 'ミリ秒',
      decimal: '.'
    },
    ko: {
      y: '년',
      mo: '개월',
      w: '주일',
      d: '일',
      h: '시간',
      m: '분',
      s: '초',
      ms: '밀리 초',
      decimal: '.'
    },
    lt: {
      y: function (c) { return ((c % 10 === 0) || (c % 100 >= 10 && c % 100 <= 20)) ? 'metų' : 'metai' },
      mo: function (c) { return ['mėnuo', 'mėnesiai', 'mėnesių'][getLithuanianForm(c)] },
      w: function (c) { return ['savaitė', 'savaitės', 'savaičių'][getLithuanianForm(c)] },
      d: function (c) { return ['diena', 'dienos', 'dienų'][getLithuanianForm(c)] },
      h: function (c) { return ['valanda', 'valandos', 'valandų'][getLithuanianForm(c)] },
      m: function (c) { return ['minutė', 'minutės', 'minučių'][getLithuanianForm(c)] },
      s: function (c) { return ['sekundė', 'sekundės', 'sekundžių'][getLithuanianForm(c)] },
      ms: function (c) { return ['milisekundė', 'milisekundės', 'milisekundžių'][getLithuanianForm(c)] },
      decimal: ','
    },
    ms: {
      y: 'tahun',
      mo: 'bulan',
      w: 'minggu',
      d: 'hari',
      h: 'jam',
      m: 'minit',
      s: 'saat',
      ms: 'milisaat',
      decimal: '.'
    },
    nl: {
      y: 'jaar',
      mo: function (c) { return c === 1 ? 'maand' : 'maanden' },
      w: function (c) { return c === 1 ? 'week' : 'weken' },
      d: function (c) { return c === 1 ? 'dag' : 'dagen' },
      h: 'uur',
      m: function (c) { return c === 1 ? 'minuut' : 'minuten' },
      s: function (c) { return c === 1 ? 'seconde' : 'seconden' },
      ms: function (c) { return c === 1 ? 'milliseconde' : 'milliseconden' },
      decimal: ','
    },
    no: {
      y: 'år',
      mo: function (c) { return 'måned' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'uke' + (c === 1 ? '' : 'r') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'er') },
      h: function (c) { return 'time' + (c === 1 ? '' : 'r') },
      m: function (c) { return 'minutt' + (c === 1 ? '' : 'er') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    pl: {
      y: function (c) { return ['rok', 'roku', 'lata', 'lat'][getPolishForm(c)] },
      mo: function (c) { return ['miesiąc', 'miesiąca', 'miesiące', 'miesięcy'][getPolishForm(c)] },
      w: function (c) { return ['tydzień', 'tygodnia', 'tygodnie', 'tygodni'][getPolishForm(c)] },
      d: function (c) { return ['dzień', 'dnia', 'dni', 'dni'][getPolishForm(c)] },
      h: function (c) { return ['godzina', 'godziny', 'godziny', 'godzin'][getPolishForm(c)] },
      m: function (c) { return ['minuta', 'minuty', 'minuty', 'minut'][getPolishForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekund'][getPolishForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekund'][getPolishForm(c)] },
      decimal: ','
    },
    pt: {
      y: function (c) { return 'ano' + (c === 1 ? '' : 's') },
      mo: function (c) { return c === 1 ? 'mês' : 'meses' },
      w: function (c) { return 'semana' + (c === 1 ? '' : 's') },
      d: function (c) { return 'dia' + (c === 1 ? '' : 's') },
      h: function (c) { return 'hora' + (c === 1 ? '' : 's') },
      m: function (c) { return 'minuto' + (c === 1 ? '' : 's') },
      s: function (c) { return 'segundo' + (c === 1 ? '' : 's') },
      ms: function (c) { return 'milissegundo' + (c === 1 ? '' : 's') },
      decimal: ','
    },
    ru: {
      y: function (c) { return ['лет', 'год', 'года'][getSlavicForm(c)] },
      mo: function (c) { return ['месяцев', 'месяц', 'месяца'][getSlavicForm(c)] },
      w: function (c) { return ['недель', 'неделя', 'недели'][getSlavicForm(c)] },
      d: function (c) { return ['дней', 'день', 'дня'][getSlavicForm(c)] },
      h: function (c) { return ['часов', 'час', 'часа'][getSlavicForm(c)] },
      m: function (c) { return ['минут', 'минута', 'минуты'][getSlavicForm(c)] },
      s: function (c) { return ['секунд', 'секунда', 'секунды'][getSlavicForm(c)] },
      ms: function (c) { return ['миллисекунд', 'миллисекунда', 'миллисекунды'][getSlavicForm(c)] },
      decimal: ','
    },
    uk: {
      y: function (c) { return ['років', 'рік', 'роки'][getSlavicForm(c)] },
      mo: function (c) { return ['місяців', 'місяць', 'місяці'][getSlavicForm(c)] },
      w: function (c) { return ['тижнів', 'тиждень', 'тижні'][getSlavicForm(c)] },
      d: function (c) { return ['днів', 'день', 'дні'][getSlavicForm(c)] },
      h: function (c) { return ['годин', 'година', 'години'][getSlavicForm(c)] },
      m: function (c) { return ['хвилин', 'хвилина', 'хвилини'][getSlavicForm(c)] },
      s: function (c) { return ['секунд', 'секунда', 'секунди'][getSlavicForm(c)] },
      ms: function (c) { return ['мілісекунд', 'мілісекунда', 'мілісекунди'][getSlavicForm(c)] },
      decimal: ','
    },
    ur: {
      y: 'سال',
      mo: function (c) { return c === 1 ? 'مہینہ' : 'مہینے' },
      w: function (c) { return c === 1 ? 'ہفتہ' : 'ہفتے' },
      d: 'دن',
      h: function (c) { return c === 1 ? 'گھنٹہ' : 'گھنٹے' },
      m: 'منٹ',
      s: 'سیکنڈ',
      ms: 'ملی سیکنڈ',
      decimal: '.'
    },
    sk: {
      y: function (c) { return ['rok', 'roky', 'roky', 'rokov'][getCzechOrSlovakForm(c)] },
      mo: function (c) { return ['mesiac', 'mesiace', 'mesiace', 'mesiacov'][getCzechOrSlovakForm(c)] },
      w: function (c) { return ['týždeň', 'týždne', 'týždne', 'týždňov'][getCzechOrSlovakForm(c)] },
      d: function (c) { return ['deň', 'dni', 'dni', 'dní'][getCzechOrSlovakForm(c)] },
      h: function (c) { return ['hodina', 'hodiny', 'hodiny', 'hodín'][getCzechOrSlovakForm(c)] },
      m: function (c) { return ['minúta', 'minúty', 'minúty', 'minút'][getCzechOrSlovakForm(c)] },
      s: function (c) { return ['sekunda', 'sekundy', 'sekundy', 'sekúnd'][getCzechOrSlovakForm(c)] },
      ms: function (c) { return ['milisekunda', 'milisekundy', 'milisekundy', 'milisekúnd'][getCzechOrSlovakForm(c)] },
      decimal: ','
    },
    sv: {
      y: 'år',
      mo: function (c) { return 'månad' + (c === 1 ? '' : 'er') },
      w: function (c) { return 'veck' + (c === 1 ? 'a' : 'or') },
      d: function (c) { return 'dag' + (c === 1 ? '' : 'ar') },
      h: function (c) { return 'timm' + (c === 1 ? 'e' : 'ar') },
      m: function (c) { return 'minut' + (c === 1 ? '' : 'er') },
      s: function (c) { return 'sekund' + (c === 1 ? '' : 'er') },
      ms: function (c) { return 'millisekund' + (c === 1 ? '' : 'er') },
      decimal: ','
    },
    tr: {
      y: 'yıl',
      mo: 'ay',
      w: 'hafta',
      d: 'gün',
      h: 'saat',
      m: 'dakika',
      s: 'saniye',
      ms: 'milisaniye',
      decimal: ','
    },
    vi: {
      y: 'năm',
      mo: 'tháng',
      w: 'tuần',
      d: 'ngày',
      h: 'giờ',
      m: 'phút',
      s: 'giây',
      ms: 'mili giây',
      decimal: ','
    },
    zh_CN: {
      y: '年',
      mo: '个月',
      w: '周',
      d: '天',
      h: '小时',
      m: '分钟',
      s: '秒',
      ms: '毫秒',
      decimal: '.'
    },
    zh_TW: {
      y: '年',
      mo: '個月',
      w: '周',
      d: '天',
      h: '小時',
      m: '分鐘',
      s: '秒',
      ms: '毫秒',
      decimal: '.'
    }
  }

  // You can create a humanizer, which returns a function with default
  // parameters.
  function humanizer (passedOptions) {
    var result = function humanizer (ms, humanizerOptions) {
      var options = extend({}, result, humanizerOptions || {})
      return doHumanization(ms, options)
    }

    return extend(result, {
      language: 'en',
      delimiter: ', ',
      spacer: ' ',
      conjunction: '',
      serialComma: true,
      units: ['y', 'mo', 'w', 'd', 'h', 'm', 's'],
      languages: {},
      round: false,
      unitMeasures: {
        y: 31557600000,
        mo: 2629800000,
        w: 604800000,
        d: 86400000,
        h: 3600000,
        m: 60000,
        s: 1000,
        ms: 1
      }
    }, passedOptions)
  }

  // The main function is just a wrapper around a default humanizer.
  var humanizeDuration = humanizer({})

  // doHumanization does the bulk of the work.
  function doHumanization (ms, options) {
    var i, len, piece

    // Make sure we have a positive number.
    // Has the nice sideffect of turning Number objects into primitives.
    ms = Math.abs(ms)

    var dictionary = options.languages[options.language] || languages[options.language]
    if (!dictionary) {
      throw new Error('No language ' + dictionary + '.')
    }

    var pieces = []

    // Start at the top and keep removing units, bit by bit.
    var unitName, unitMS, unitCount
    for (i = 0, len = options.units.length; i < len; i++) {
      unitName = options.units[i]
      unitMS = options.unitMeasures[unitName]

      // What's the number of full units we can fit?
      if (i + 1 === len) {
        unitCount = ms / unitMS
      } else {
        unitCount = Math.floor(ms / unitMS)
      }

      // Add the string.
      pieces.push({
        unitCount: unitCount,
        unitName: unitName
      })

      // Remove what we just figured out.
      ms -= unitCount * unitMS
    }

    var firstOccupiedUnitIndex = 0
    for (i = 0; i < pieces.length; i++) {
      if (pieces[i].unitCount) {
        firstOccupiedUnitIndex = i
        break
      }
    }

    if (options.round) {
      var ratioToLargerUnit, previousPiece
      for (i = pieces.length - 1; i >= 0; i--) {
        piece = pieces[i]
        piece.unitCount = Math.round(piece.unitCount)

        if (i === 0) { break }

        previousPiece = pieces[i - 1]

        ratioToLargerUnit = options.unitMeasures[previousPiece.unitName] / options.unitMeasures[piece.unitName]
        if ((piece.unitCount % ratioToLargerUnit) === 0 || (options.largest && ((options.largest - 1) < (i - firstOccupiedUnitIndex)))) {
          previousPiece.unitCount += piece.unitCount / ratioToLargerUnit
          piece.unitCount = 0
        }
      }
    }

    var result = []
    for (i = 0, pieces.length; i < len; i++) {
      piece = pieces[i]
      if (piece.unitCount) {
        result.push(render(piece.unitCount, piece.unitName, dictionary, options))
      }

      if (result.length === options.largest) { break }
    }

    if (result.length) {
      if (!options.conjunction || result.length === 1) {
        return result.join(options.delimiter)
      } else if (result.length === 2) {
        return result.join(options.conjunction)
      } else if (result.length > 2) {
        return result.slice(0, -1).join(options.delimiter) + (options.serialComma ? ',' : '') + options.conjunction + result.slice(-1)
      }
    } else {
      return render(0, options.units[options.units.length - 1], dictionary, options)
    }
  }

  function render (count, type, dictionary, options) {
    var decimal
    if (options.decimal === void 0) {
      decimal = dictionary.decimal
    } else {
      decimal = options.decimal
    }

    var countStr = count.toString().replace('.', decimal)

    var dictionaryValue = dictionary[type]
    var word
    if (typeof dictionaryValue === 'function') {
      word = dictionaryValue(count)
    } else {
      word = dictionaryValue
    }

    return countStr + options.spacer + word
  }

  function extend (destination) {
    var source
    for (var i = 1; i < arguments.length; i++) {
      source = arguments[i]
      for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
          destination[prop] = source[prop]
        }
      }
    }
    return destination
  }

  // Internal helper function for Polish language.
  function getPolishForm (c) {
    if (c === 1) {
      return 0
    } else if (Math.floor(c) !== c) {
      return 1
    } else if (c % 10 >= 2 && c % 10 <= 4 && !(c % 100 > 10 && c % 100 < 20)) {
      return 2
    } else {
      return 3
    }
  }

  // Internal helper function for Russian and Ukranian languages.
  function getSlavicForm (c) {
    if (Math.floor(c) !== c) {
      return 2
    } else if ((c % 100 >= 5 && c % 100 <= 20) || (c % 10 >= 5 && c % 10 <= 9) || c % 10 === 0) {
      return 0
    } else if (c % 10 === 1) {
      return 1
    } else if (c > 1) {
      return 2
    } else {
      return 0
    }
  }

    // Internal helper function for Slovak language.
  function getCzechOrSlovakForm (c) {
    if (c === 1) {
      return 0
    } else if (Math.floor(c) !== c) {
      return 1
    } else if (c % 10 >= 2 && c % 10 <= 4 && c % 100 < 10) {
      return 2
    } else {
      return 3
    }
  }

  // Internal helper function for Lithuanian language.
  function getLithuanianForm (c) {
    if (c === 1 || (c % 10 === 1 && c % 100 > 20)) {
      return 0
    } else if (Math.floor(c) !== c || (c % 10 >= 2 && c % 100 > 20) || (c % 10 >= 2 && c % 100 < 10)) {
      return 1
    } else {
      return 2
    }
  }

  humanizeDuration.getSupportedLanguages = function getSupportedLanguages () {
    var result = []
    for (var language in languages) {
      if (languages.hasOwnProperty(language)) {
        result.push(language)
      }
    }
    return result
  }

  humanizeDuration.humanizer = humanizer

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return humanizeDuration
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports = humanizeDuration
  } else {
    this.humanizeDuration = humanizeDuration
  }
})();  // eslint-disable-line semi


/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vuetify_form_creator_vuetify_form_creator__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_google_autocomplete__ = __webpack_require__(605);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyAreaAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_0__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_1__components_vuetify_dialog_confirm__["a" /* default */],
    VuetifyFormCreator: __WEBPACK_IMPORTED_MODULE_2__components_vuetify_form_creator_vuetify_form_creator__["a" /* default */],
    VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_3_vue_google_autocomplete__["a" /* default */]
  },

  props: {
    areas: {
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: '¿Delete area?',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    locationIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    value: {
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      dialog: false,
      valid: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: null,
      phoneType: null,
      phoneNumber: null,
      humanizeDuration: __webpack_require__(701),
      address: {
        dialog: false,
        data: null
      },
      area: {
        current: {
          id: 0,
          index: 0
        },
        dialog: false,
        iframe: {
          dialog: false
        },
        visible: false,
        form: [{
          ref: '',
          type: 'radio-group',
          label: 'Selecciona el área a habilitar:',
          columns: 'xs12 sm12 md12 lg12',
          value: '',
          class: 'area-radio-group',
          itemText: 'quantity_value',
          itemValue: 'quantity_id',
          avatars: false,
          options: [{
            value: 'area_postal_code',
            visible: false,
            label: '',
            hint: ''
          }, {
            value: 'area_locality',
            visible: false,
            label: '',
            hint: ''
          }, {
            value: 'area_province',
            visible: false,
            label: '',
            hint: ''
          }, {
            value: 'area_distance',
            visible: false,
            label: '',
            hint: ''
          }, {
            value: 'area_duration',
            visible: false,
            label: '',
            hint: ''
          }],
          rules: [],
          required: true,
          autocomplete: true,
          disabled: false,
          chips: true
        }, {
          ref: 'distance',
          type: 'slider',
          label: 'Distancia',
          columns: 'xs12 sm12 md12 lg12',
          visible: false,
          value: 10,
          min: 1,
          max: 1000
        }, {
          ref: 'duration',
          type: 'slider',
          label: 'Tiempo',
          columns: 'xs12 sm12 md12 lg12',
          visible: false,
          value: 3600000,
          step: 60000,
          min: 60000,
          max: 86400000
        }],
        distance: 0
      }
    };
  },

  created: function created() {
    if (this.areas.length > 0) {
      this.normalizeAreas(this.areas);
    }
  },


  watch: {
    areas: {
      handler: function handler(newVal, oldVal) {
        this.normalizeAreas(newVal);
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    },
    'area.form.0.value': {
      handler: function handler(newVal, oldVal) {
        console.log(newVal);
        this.area.form[1].visible = false;
        this.area.form[2].visible = false;
        if (newVal === 'area_distance') {
          this.area.form[1].visible = true;
        } else if (newVal === 'area_duration') {
          this.area.form[2].visible = true;
        }
      },
      deep: true
    },
    'area.form.1.value': {
      handler: function handler(newVal, oldVal) {
        this.address.data.distance = newVal;
      },
      deep: true
    },
    'area.form.2.value': {
      handler: function handler(newVal, oldVal) {
        this.address.data.duration = newVal;
      },
      deep: true
    }
  },

  methods: {

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChange: function onChange() {
      this.updateAreaOptions();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openExternalMap: function openExternalMap(url) {
      window.open(url, '_blank');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onFocusAutocomplete: function onFocusAutocomplete(ref) {
      // this.$refs[ref].clear()
      // this.address.data = null
      // this.area.form[0].value = null
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    normalizeAreas: function normalizeAreas(items) {
      var _this = this;

      items.map(function (obj, index) {
        if (obj.area_filter_name === 'area_postal_code') {
          obj.title = obj.area_postal_code || '';
          obj.subtitle = 'Todo el código postal';
        } else if (obj.area_filter_name === 'area_locality') {
          obj.title = obj.area_locality || '';
          obj.subtitle = 'Toda la localidad';
        } else if (obj.area_filter_name === 'area_province') {
          obj.title = obj.area_province || '';
          obj.subtitle = 'Toda la provincia';
        } else if (obj.area_filter_name === 'area_distance') {
          obj.title = obj.area_distance + ' Km';
          obj.subtitle = 'Distancia máxima del trayecto';
        } else if (obj.area_filter_name === 'area_duration') {
          var time = _this.humanizeDuration(obj.area_duration, {
            language: 'es',
            round: true,
            units: ['d', 'h', 'm'],
            delimiter: ' y '
          });
          obj.title = time || '';
          obj.subtitle = 'Duración máxima del trayecto';
        }
        return obj;
      });
      this.items = items;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addArea: function addArea() {
      var area = {
        user_id: 0,
        area_filter_id: 0,
        area_filter_name: this.area.form[0].value,
        area_address: this.address.data.address,
        area_postal_code: this.address.data.postalCode,
        area_locality: this.address.data.locality,
        area_province: this.address.data.province,
        area_country: this.address.data.country,
        area_longitude: this.address.data.longitude,
        area_latitude: this.address.data.latitude,
        area_place_id: this.address.data.placeID,
        area_formatted_address: this.address.data.formattedAddress,
        area_url: this.address.data.url,
        area_distance: this.address.data.distance,
        area_duration: this.address.data.duration
      };
      this.items.push(area);
      this.$emit('on-add-area', area);
      this.$refs.area.clear();
      this.area.form[0].value = null;
      this.$refs.aggregator.dialog = false;
      this.address.data = null;
    },


    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.address.data = {
        route: addressData.route || '',
        postalCode: addressData.postal_code || '',
        locality: addressData.locality || '',
        province: addressData.administrative_area_level_2 || '',
        country: addressData.country || '',
        latitude: addressData.latitude || '',
        longitude: addressData.longitude || '',
        formattedAddress: placeResultData.formatted_address || '',
        url: placeResultData.url || '',
        distance: this.area.form[1].value || '',
        duration: this.area.form[2].value || '',
        placeID: placeResultData.place_id || ''
      };
      var number = addressData.street_number || '';
      number = number ? ', ' + number : '';
      this.address.data.route += number;
      this.updateAreaOptions();
    },

    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    updateAreaOptions: function updateAreaOptions() {
      if (!this.address.data) {
        return;
      }
      if (this.address.data.postalCode !== '') {
        this.area.form[0].options[0].label = this.address.data.postalCode + ' (código postal)';
        this.area.form[0].options[0].hint = 'Todo el código postal ' + this.address.data.postalCode + '.';
        this.area.form[0].options[0].visible = true;
      } else {
        this.area.form[0].options[0].visible = false;
      }
      if (this.address.data.locality !== '') {
        this.area.form[0].options[1].label = this.address.data.locality + ' (localidad)';
        this.area.form[0].options[1].hint = 'Toda localidad de ' + this.address.data.locality + '.';
        this.area.form[0].options[1].visible = true;
      } else {
        this.area.form[0].options[1].visible = false;
      }
      if (this.address.data.province !== '') {
        this.area.form[0].options[2].label = this.address.data.province + ' (provincia)';
        this.area.form[0].options[2].hint = 'Toda la provincia de ' + this.address.data.province + '.';
        this.area.form[0].options[2].visible = true;
      } else {
        this.area.form[0].options[2].visible = false;
      }
      if (this.address.data.placeID !== '') {
        this.area.form[0].options[3].label = this.address.data.distance + ' Km (distancia)';
        this.area.form[0].options[3].hint = 'Trayectos a una distancia máxima de ' + this.area.form[1].value + ' Km conduciendo desde esta ubicación.';
        this.area.form[0].options[3].visible = true;
      } else {
        this.area.form[0].options[3].visible = false;
      }
      if (this.address.data.placeID !== '') {
        var time = this.humanizeDuration(this.address.data.duration, {
          language: 'es',
          round: true,
          units: ['d', 'h', 'm'],
          delimiter: ' y '
        });
        this.area.form[0].options[4].label = time + ' (duración)';
        this.area.form[0].options[4].hint = 'Trayectos de una duración máxima de ' + time + ' conduciendo desde la ubicación seleccionada.';
        this.area.form[0].options[4].visible = true;
      } else {
        this.area.form[0].options[4].visible = false;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deleteArea();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteArea: function deleteArea() {
      this.$emit('on-delete-area', this.items[this.currentIndex]);
      this.items.splice(this.currentIndex, 1);
    }
  }
});

/***/ }),

/***/ 703:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyScheduleSelector',

  props: {
    schedules: {
      type: Array,
      default: null,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    value: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      schedulesValue: null
    };
  },

  mounted: function mounted() {
    this.schedulesValue = '0';
  },


  watch: {

    schedules: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onChangeDisponibility: function onChangeDisponibility(item, selected) {
      var index = selected.indexOf(item.value);
      if (index > -1) {
        this.$emit('on-delete-schedule', index, item, selected);
      } else {
        this.$emit('on-add-schedule', item, selected);
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deletePhone();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deletePhone: function deletePhone() {
      this.items.splice(this.currentIndex, 1);
      this.$emit('on-delete-phone');
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addPhone: function addPhone() {
      this.$refs.aggregator.dialog = false;
      var item = {
        type: this.phoneType.text,
        value: this.phoneNumber
      };
      this.items.push(item);
      this.$refs.form.reset();
      this.$emit('on-add-phone');
    }
  }
});

/***/ }),

/***/ 704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_vuetify_aggregator_card__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_vuetify_dialog_confirm__ = __webpack_require__(553);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'VuetifyUserObservationAggregator',

  components: {
    VuetifyAggregatorCard: __WEBPACK_IMPORTED_MODULE_1__layouts_vuetify_aggregator_card__["a" /* default */],
    VuetifyDialogConfirm: __WEBPACK_IMPORTED_MODULE_2__components_vuetify_dialog_confirm__["a" /* default */]
  },

  props: {
    observations: {
      type: Array,
      default: null,
      required: true
    },
    addButton: {
      type: Boolean,
      default: true,
      required: false
    },
    deleteButton: {
      type: Boolean,
      default: true,
      required: false
    },
    theTitleDisabled: {
      type: Boolean,
      default: false,
      required: false
    },
    canEdit: {
      type: Boolean,
      default: true,
      required: false
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    },
    toolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    listTitle: {
      type: String,
      default: null,
      required: true
    },
    addButtonHoverText: {
      type: String,
      default: null,
      required: true
    },
    dialogMaxWidth: {
      type: Number,
      default: 450,
      required: false
    },
    dialogToolbarTitle: {
      type: String,
      default: null,
      required: true
    },
    textFieldLabel: {
      type: String,
      default: 'Phone',
      required: false
    },
    textFieldRules: {
      type: Array,
      default: null,
      required: false
    },
    selectLabel: {
      type: String,
      default: 'Type',
      required: false
    },
    observationTypes: {
      type: Array,
      default: null,
      required: false
    },
    dialogConfirmHeadline: {
      type: String,
      default: 'Delete area',
      required: false
    },
    dialogConfirmText: {
      type: String,
      default: 'Estás a punto de eliminar un área de trabajo',
      required: false
    },
    cancelButton: {
      type: String,
      default: 'Cancel',
      required: false
    },
    confirmButton: {
      type: String,
      default: 'Confirm',
      required: false
    },
    deleteIconHoverText: {
      type: String,
      default: 'Delete',
      required: false
    },
    value: {
      type: Array,
      default: null
    }
  },

  data: function data() {
    return {
      items: [],
      titleDisabled: false,
      dialog: false,
      valid: false,
      date: '',
      title: '',
      message: '',
      type: '',
      user: '',
      preview: false,
      showConfirmDialog: false,
      currentIndex: 0,
      types: [{
        text: 'Phone'
      }, {
        text: 'Mobile'
      }, {
        text: 'Fax'
      }],
      theObservationType: '1',
      observationType: null,
      observationTitle: null,
      observationMsg: null,
      observationRef: null
    };
  },

  created: function created() {
    this.items = this.observations;
  },


  watch: {
    theTitleDisabled: {
      handler: function handler(newVal, oldVal) {
        this.titleDisabled = this.theTitleDisabled;
      },
      deep: true
    },
    observationTypes: {
      handler: function handler(newVal, oldVal) {
        this.types = newVal;
        this.observationType = this.types[0];
      },
      deep: true
    },

    observations: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal;
      },
      deep: true
    },

    items: {
      handler: function handler(newVal, oldVal) {
        this.$emit('update:value', newVal);
      },
      deep: true
    }
  },

  methods: {
    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    askForConfirmation: function askForConfirmation(index) {
      this.currentIndex = index;
      this.showConfirmDialog = true;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    humanize: function humanize(date) {
      return 'Enviado por ' + this.user + ' el ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('DD-MM-YYYY') + ' a las ' + __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('HH:mm') + 'h.';
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onDiscardDeletion: function onDiscardDeletion(ref) {
      this.showConfirmDialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    onConfirmDeletion: function onConfirmDeletion() {
      this.showConfirmDialog = false;
      this.deleteObservation();
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    deleteObservation: function deleteObservation() {
      this.$emit('on-delete-observation', this.currentIndex, this.items[this.currentIndex]);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openMessage: function openMessage(index) {
      if (!this.showConfirmDialog) {
        this.message = this.items[index].user_observation_message;
        this.user = this.items[index].user_observation_user;
        this.title = this.items[index].user_observation_title;
        this.date = this.humanize(this.items[index].user_observation_created);
        this.type = this.items[index].user_observation_type;
        this.preview = true;
      }
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    closeAggregator: function closeAggregator() {
      this.$refs.aggregator.dialog = false;
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    openAggregator: function openAggregator(type, title, message, ref, dialog, titleDisabled) {
      this.titleDisabled = titleDisabled || false;
      this.observationTitle = title || '';
      this.observationRef = ref || '';
      this.theObservationType = type || '1';
      this.observationMsg = message || '';
      this.$refs.aggregator.dialog = !(dialog === false);
    },


    /**
     * Get theme style.
     *
     * @param {Object} obj
     * @param {String} index
     *
     * @return {*}
     */
    addObservation: function addObservation() {
      this.closeAggregator();
      var item = {
        to_user_id: 0,
        user_observation_message: this.observationMsg,
        from_user_id: 0,
        user_observation_id: 0,
        user_observation_ref: this.observationRef,
        user_observation_title: this.observationTitle,
        user_observation_type: this.theObservationType
      };
      this.$refs.form.reset();
      this.$emit('on-add-observation', item);
      this.theObservationType = '1';
      this.observationTitle = '';
    }
  }
});

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(741);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("af3f0734", content, true, {});

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".application{background:rgba(63,81,181,.0705882)!important}a{text-decoration:none}.avatar{cursor:pointer}.container.grid-list-xl :not(:only-child) .layout:first-child{margin-top:0}.jst-card{margin-bottom:20px}.carousel-actions{padding:18px}.carousel{height:250px;width:250px;margin:0 auto;-webkit-box-shadow:none;box-shadow:none}.input-file{display:none}.avatar-info{width:72%}.add-address{display:hidden}.address-autocomplete{max-width:435px;margin:0 auto;padding:32px 0}.list-item{display:inline-block;margin-right:10px}.list-enter-active,.list-leave-active{-webkit-transition:all 1s;transition:all 1s}.list-enter,.list-leave-to{opacity:0;-webkit-transform:translateY(30px);transform:translateY(30px)}html{overflow-y:visible!important}.profile-options{float:right;bottom:62px}.disable-area{opacity:.5;pointer-events:none;cursor:default;text-decoration:none;-webkit-transition:opacity 1s ease-in-out;transition:opacity 1s ease-in-out}.list__tile__sub-title{max-height:40px!important}.vc-chrome{width:350px!important}.account-color{width:93px;height:14px;border-radius:11px;cursor:pointer;margin:16px auto;border:1px solid hsla(230,4%,69%,.88)}.color-pick{height:20px!important;width:20px!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/pages/account.vue"],"names":[],"mappings":"AACA,aACE,6CAAoD,CACrD,AACD,EACE,oBAAsB,CACvB,AACD,QACE,cAAgB,CACjB,AAID,8DACE,YAAgB,CACjB,AACD,UACE,kBAAoB,CACrB,AACD,kBACE,YAAc,CACf,AACD,UACE,aAAc,AACd,YAAa,AACb,cAAe,AACf,wBAAyB,AACjB,eAAiB,CAC1B,AACD,YACE,YAAc,CACf,AACD,aACE,SAAW,CACZ,AACD,aACE,cAAgB,CACjB,AACD,sBACE,gBAAiB,AACjB,cAAe,AACf,cAAuB,CACxB,AACD,WACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,sCACE,0BAA2B,AAC3B,iBAAmB,CACpB,AACD,2BACE,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,KACE,4BAA+B,CAChC,AACD,iBACE,YAAa,AACb,WAAa,CACd,AACD,cACE,WAAa,AACb,oBAAqB,AACrB,eAAgB,AAChB,qBAAsB,AACtB,0CAA2C,AAC3C,iCAAmC,CACpC,AACD,uBACE,yBAA4B,CAC7B,AACD,WACE,qBAAwB,CACzB,AACD,eACE,WAAY,AACZ,YAAa,AACb,mBAAoB,AACpB,eAAgB,AAEhB,iBAAkB,AAElB,qCAAwC,CACzC,AACD,YACE,sBAAwB,AACxB,oBAAuB,CACxB","file":"account.vue","sourcesContent":["\n.application {\n  background: rgba(63, 81, 181, 0.0705882) !important;\n}\na {\n  text-decoration: none;\n}\n.avatar {\n  cursor: pointer;\n}\n.flex {\n  /* padding: 5px 12px */\n}\n.container.grid-list-xl *:not(:only-child) .layout:first-child {\n  margin-top: 0px;\n}\n.jst-card {\n  margin-bottom: 20px;\n}\n.carousel-actions {\n  padding: 18px;\n}\n.carousel {\n  height: 250px;\n  width: 250px;\n  margin: 0 auto;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.input-file {\n  display: none;\n}\n.avatar-info {\n  width: 72%;\n}\n.add-address {\n  display: hidden;\n}\n.address-autocomplete {\n  max-width: 435px;\n  margin: 0 auto;\n  padding: 32px 0 32px 0;\n}\n.list-item {\n  display: inline-block;\n  margin-right: 10px;\n}\n.list-enter-active, .list-leave-active {\n  -webkit-transition: all 1s;\n  transition: all 1s;\n}\n.list-enter, .list-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n}\nhtml {\n  overflow-y: visible !important;\n}\n.profile-options {\n  float: right;\n  bottom: 62px;\n}\n.disable-area {\n  opacity: 0.5;\n  pointer-events: none;\n  cursor: default;\n  text-decoration: none;\n  -webkit-transition: opacity 1s ease-in-out;\n  transition: opacity 1s ease-in-out;\n}\n.list__tile__sub-title {\n  max-height: 40px !important;\n}\n.vc-chrome {\n  width: 350px !important;\n}\n.account-color {\n  width: 93px;\n  height: 14px;\n  border-radius: 11px;\n  cursor: pointer;\n  border-style: solid;\n  margin: 16px auto;\n  border-width: 1px;\n  border-color: rgba(172, 173, 178, 0.88);\n}\n.color-pick {\n  height: 20px !important;\n  width: 20px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 742:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_user_aggregator_vue__ = __webpack_require__(699);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac94da6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_user_aggregator_vue__ = __webpack_require__(743);
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_user_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ac94da6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_user_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 743:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"list-title":_vm.listTitle,"navigation-menu":_vm.navigationMenu,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle}},[(_vm.items.length > 0)?_c('v-list',{attrs:{"slot":"card-text","two-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100)},[(item.avatar)?_c('v-list-tile-avatar',[_c('img',{attrs:{"src":item.avatar}})]):_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v(_vm._s(_vm.leftIcon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1),_vm._v(" "),(_vm.deleteButton)?_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":_vm.color},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1):_vm._e()],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"slot":"dialog-card-text","row":"","align-center":"","justify-center":""},slot:"dialog-card-text"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[(_vm.list && _vm.usersList.length > 0)?_c('vuetify-select',{ref:"select",attrs:{"item":_vm.select},on:{"on-add-item":_vm.onAddItem,"on-change":_vm.onChange,"on-keyup":_vm.onKeyup},model:{value:(_vm.select.value),callback:function ($$v) {_vm.$set(_vm.select, "value", $$v)},expression:"select.value"}}):_c('v-text-field',{attrs:{"label":_vm.textFieldLabel,"single-line":"","required":"","rules":_vm.textFieldRules || []},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('v-btn',{attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.$refs.aggregator.dialog = false}}},[_vm._v("\n      "+_vm._s(_vm.cancelButton)+"\n    ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid && _vm.showConfirmButton),expression:"valid && showConfirmButton"}],attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.addUser()}}},[_vm._v("\n      "+_vm._s(_vm.confirmButton)+"\n    ")])],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_commerce_aggregator_vue__ = __webpack_require__(700);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aab3f68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_commerce_aggregator_vue__ = __webpack_require__(747);
function injectStyle (ssrContext) {
  __webpack_require__(745)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_commerce_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aab3f68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_commerce_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(746);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("4c588b0d", content, true, {});

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".commerce-radio-group{margin-bottom:-49px;margin-top:7px!important}.commerce-actions{margin:15px 0 -65px}.commerce-actions-card{margin:15px 0 9px}.commerce-options{margin-top:-47px}.commerce-buttom{bottom:18px!important}.commerce-autocomplete{margin:0 auto;padding:16px 16px 32px}.fade-enter-active,.fade-leave-active,.fade-leave-to{-webkit-transition:.3s ease-out;transition:.3s ease-out;position:absolute;top:0;left:0}.fade-enter,.fade-leave,.fade-leave-to{opacity:0}.list-item{display:inline-block;margin-right:10px}.list-enter-active,.list-leave-active{-webkit-transition:all 1s;transition:all 1s}.list-enter,.list-leave-to{opacity:0;-webkit-transform:translateY(30px);transform:translateY(30px)}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-commerce-aggregator.vue"],"names":[],"mappings":"AACA,sBACE,oBAAqB,AACrB,wBAA2B,CAC5B,AACD,kBACE,mBAAuB,CACxB,AACD,uBACE,iBAAqB,CACtB,AACD,kBACE,gBAAkB,CACnB,AACD,iBACE,qBAAwB,CACzB,AACD,uBACE,cAAe,AACf,sBAA6B,CAC9B,AACD,qDACE,gCAAiC,AACjC,wBAAyB,AACzB,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACT,AACD,uCACE,SAAW,CACZ,AACD,WACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,sCACE,0BAA2B,AAC3B,iBAAmB,CACpB,AACD,2BACE,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC","file":"vuetify-commerce-aggregator.vue","sourcesContent":["\n.commerce-radio-group {\n  margin-bottom: -49px;\n  margin-top: 7px !important;\n}\n.commerce-actions {\n  margin: 15px 0 -65px 0;\n}\n.commerce-actions-card {\n  margin: 15px 0 9px 0;\n}\n.commerce-options {\n  margin-top: -47px;\n}\n.commerce-buttom {\n  bottom: 18px !important;\n}\n.commerce-autocomplete {\n  margin: 0 auto;\n  padding: 16px 16px 32px 16px;\n}\n.fade-enter-active, .fade-leave-active, .fade-leave-to {\n  -webkit-transition: .3s ease-out;\n  transition: .3s ease-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.fade-enter, .fade-leave, .fade-leave-to {\n  opacity: 0;\n}\n.list-item {\n  display: inline-block;\n  margin-right: 10px;\n}\n.list-enter-active, .list-leave-active {\n  -webkit-transition: all 1s;\n  transition: all 1s;\n}\n.list-enter, .list-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 747:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"list-title":_vm.listTitle,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle}},[(_vm.items.length > 0)?_c('v-list',{attrs:{"slot":"card-text","two-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100)},[_c('v-list-tile-action',[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":"primary"},slot:"activator"},[_c('v-icon',[_vm._v("store")])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.commerce_name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.company_name)+" - "+_vm._s(item.business_name))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":"primary"},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1)],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"select-commerce-card",attrs:{"slot":"dialog-card-text"},slot:"dialog-card-text"},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-select',{attrs:{"items":_vm.businessSelect,"label":"Grupo empresarial","disabled":_vm.businessSelect.length === 0},model:{value:(_vm.businessSelected),callback:function ($$v) {_vm.businessSelected=$$v},expression:"businessSelected"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.companiesSelect,"label":"Empresa","disabled":_vm.companiesSelect.length === 0},model:{value:(_vm.companySelected),callback:function ($$v) {_vm.companySelected=$$v},expression:"companySelected"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.commercesSelect,"label":"Comercio","disabled":_vm.commercesSelect.length === 0},model:{value:(_vm.commerceSelected),callback:function ($$v) {_vm.commerceSelected=$$v},expression:"commerceSelected"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('v-btn',{attrs:{"color":"indigo","flat":""},nativeOn:{"click":function($event){_vm.closeDialog()}}},[_vm._v("\n        Cancelar\n      ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"indigo","flat":"","disabled":!this.commerceSelected},nativeOn:{"click":function($event){_vm.addCommerce()}}},[_vm._v("\n        Aceptar\n      ")])],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}}),_vm._v(" "),_c('pre',[_vm._v("  "+_vm._s(_vm.items)+"\n")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_area_aggregator_vue__ = __webpack_require__(702);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7963dba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_area_aggregator_vue__ = __webpack_require__(751);
function injectStyle (ssrContext) {
  __webpack_require__(749)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_area_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7963dba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_area_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(750);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("4cfe4762", content, true, {});

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".area-radio-group{margin-bottom:-49px;margin-top:7px!important}.area-actions{margin:15px 0 -65px}.area-actions-card{margin:15px 0 9px}.area-options{margin-top:-47px}.area-buttom{bottom:18px!important}.select-area-card{min-height:536px}.area-autocomplete{margin:0 auto;padding:16px 16px 32px}.fade-enter-active,.fade-leave-active,.fade-leave-to{-webkit-transition:.3s ease-out;transition:.3s ease-out;position:absolute;top:0;left:0}.fade-enter,.fade-leave,.fade-leave-to{opacity:0}.list-item{display:inline-block;margin-right:10px}.list-enter-active,.list-leave-active{-webkit-transition:all 1s;transition:all 1s}.list-enter,.list-leave-to{opacity:0;-webkit-transform:translateY(30px);transform:translateY(30px)}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-area-aggregator.vue"],"names":[],"mappings":"AACA,kBACE,oBAAqB,AACrB,wBAA2B,CAC5B,AACD,cACE,mBAAuB,CACxB,AACD,mBACE,iBAAqB,CACtB,AACD,cACE,gBAAkB,CACnB,AACD,aACE,qBAAwB,CACzB,AACD,kBACE,gBAAkB,CACnB,AACD,mBACE,cAAe,AACf,sBAA6B,CAC9B,AACD,qDACE,gCAAiC,AACjC,wBAAyB,AACzB,kBAAmB,AACnB,MAAO,AACP,MAAQ,CACT,AACD,uCACE,SAAW,CACZ,AACD,WACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,sCACE,0BAA2B,AAC3B,iBAAmB,CACpB,AACD,2BACE,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC","file":"vuetify-area-aggregator.vue","sourcesContent":["\n.area-radio-group {\n  margin-bottom: -49px;\n  margin-top: 7px !important;\n}\n.area-actions {\n  margin: 15px 0 -65px 0;\n}\n.area-actions-card {\n  margin: 15px 0 9px 0;\n}\n.area-options {\n  margin-top: -47px;\n}\n.area-buttom {\n  bottom: 18px !important;\n}\n.select-area-card {\n  min-height: 536px;\n}\n.area-autocomplete {\n  margin: 0 auto;\n  padding: 16px 16px 32px 16px;\n}\n.fade-enter-active, .fade-leave-active, .fade-leave-to {\n  -webkit-transition: .3s ease-out;\n  transition: .3s ease-out;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.fade-enter, .fade-leave, .fade-leave-to {\n  opacity: 0;\n}\n.list-item {\n  display: inline-block;\n  margin-right: 10px;\n}\n.list-enter-active, .list-leave-active {\n  -webkit-transition: all 1s;\n  transition: all 1s;\n}\n.list-enter, .list-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(30px);\n          transform: translateY(30px);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 751:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"list-title":_vm.listTitle,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle}},[(_vm.items.length > 0)?_c('v-list',{attrs:{"slot":"card-text","two-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100)},[_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":"primary"},on:{"click":function($event){_vm.openExternalMap(item.area_url)}},slot:"activator"},[_c('v-icon',[_vm._v("location_on")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locationIconHoverText))])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.subtitle))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":"primary"},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1)],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"select-area-card",attrs:{"slot":"dialog-card-text"},slot:"dialog-card-text"},[_c('v-layout',{staticClass:"area-autocomplete",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"input-group input-group--dirty input-group--solo input-group--text-field input-group--single-line primary--text"},[_c('div',{staticClass:"input-group__input"},[_c('vue-google-autocomplete',{ref:"area",attrs:{"id":"area","classname":"form-control","placeholder":"Busca una ubicación","country":"es"},on:{"placechanged":_vm.getAddressData,"focus":function($event){_vm.onFocusAutocomplete('area')}}})],1)])]),_vm._v(" "),_c('v-scale-transition',{attrs:{"origin":"left center"}},[_c('vuetify-form-creator',{directives:[{name:"show",rawName:"v-show",value:(this.address.data),expression:"this.address.data"}],ref:"form",staticClass:"area-options",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.area.form},on:{"on-change":_vm.onChange}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(this.address.data && this.area.form[0].value),expression:"this.address.data && this.area.form[0].value"}],staticClass:"area-buttom",attrs:{"absolute":"","dark":"","fab":"","bottom":"","right":"","color":"primary"},on:{"click":function($event){_vm.addArea()}}},[_c('v-icon',[_vm._v("check")])],1)],1)],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}}),_vm._v(" "),_c('pre',[_vm._v("  "+_vm._s(_vm.items)+"\n")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 752:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_schedule_selector_vue__ = __webpack_require__(703);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87e4241a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_schedule_selector_vue__ = __webpack_require__(755);
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_schedule_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87e4241a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_schedule_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(754);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("cca95864", content, true, {});

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".vuetify-schedule-card{margin-bottom:20px;min-height:298px!important}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-schedule-selector.vue"],"names":[],"mappings":"AACA,uBACE,mBAAoB,AACpB,0BAA6B,CAC9B","file":"vuetify-schedule-selector.vue","sourcesContent":["\n.vuetify-schedule-card {\n  margin-bottom: 20px;\n  min-height: 298px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"vuetify-schedule-card",attrs:{"tile":"","color":"error"}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.toolbarTitle))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-tabs',{attrs:{"slider-color":"primary","centered":""},model:{value:(_vm.schedulesValue),callback:function ($$v) {_vm.schedulesValue=$$v},expression:"schedulesValue"}},[_vm._l((_vm.items),function(element,index){return _c('v-tab',{key:index,attrs:{"ripple":""}},[_vm._v("\n      "+_vm._s(element.category_name)+"\n    ")])}),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.schedulesValue),callback:function ($$v) {_vm.schedulesValue=$$v},expression:"schedulesValue"}},_vm._l((_vm.items),function(element,index){return _c('v-tab-item',{key:index},[_c('v-card',{attrs:{"flat":""}},[_c('v-list',[_vm._l((element.items),function(item,index){return [_c('v-list-tile',{key:item.text,attrs:{"avatar":"","ripple":""},on:{"click":function($event){_vm.onChangeDisponibility(item, element.selected)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("access_time")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1),_vm._v(" "),_c('v-list-tile-action',[(element.selected.indexOf(item.value) < 0)?_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("pause_circle_filled")]):_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("check_circle")])],1)],1),_vm._v(" "),(index + 1 < element.items.length)?_c('v-divider',{key:index}):_vm._e()]})],2)],1)],1)}))],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 756:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_user_observation_aggregator_vue__ = __webpack_require__(704);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a677179e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_user_observation_aggregator_vue__ = __webpack_require__(759);
function injectStyle (ssrContext) {
  __webpack_require__(757)
}
var normalizeComponent = __webpack_require__(241)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vuetify_user_observation_aggregator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a677179e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vuetify_user_observation_aggregator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(758);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(495)("62b5f972", content, true, {});

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(494)(true);
// imports


// module
exports.push([module.i, ".types{margin:0 auto;text-align:center;display:table}.headlines{font-size:18px!important;font-weight:500;letter-spacing:normal!important;font-family:Roboto,sans-serif;padding:34px}.card-texts{padding:34px;margin-top:-38px;width:100%}.card-date{margin-top:25px;width:100%;font-weight:100;margin-bottom:-10px;padding-left:32px;font-size:14px;color:#49585f;text-decoration:underline}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/components/vuetify-user-observation-aggregator.vue"],"names":[],"mappings":"AACA,OACE,cAAe,AACf,kBAAmB,AACnB,aAAe,CAChB,AACD,WACE,yBAA2B,AAC3B,gBAAiB,AACjB,gCAAkC,AAClC,8BAAkC,AAClC,YAAc,CACf,AACD,YACE,aAAc,AACd,iBAAkB,AAClB,UAAY,CACb,AACD,WACE,gBAAiB,AACjB,WAAY,AACZ,gBAAiB,AACjB,oBAAqB,AACrB,kBAAmB,AACnB,eAAgB,AAChB,cAAe,AACf,yBAA2B,CAC5B","file":"vuetify-user-observation-aggregator.vue","sourcesContent":["\n.types {\n  margin: 0 auto;\n  text-align: center;\n  display: table;\n}\n.headlines {\n  font-size: 18px !important;\n  font-weight: 500;\n  letter-spacing: normal !important;\n  font-family: 'Roboto', sans-serif;\n  padding: 34px;\n}\n.card-texts {\n  padding: 34px;\n  margin-top: -38px;\n  width: 100%;\n}\n.card-date {\n  margin-top: 25px;\n  width: 100%;\n  font-weight: 100;\n  margin-bottom: -10px;\n  padding-left: 32px;\n  font-size: 14px;\n  color: #49585f;\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuetify-aggregator-card',{ref:"aggregator",attrs:{"color":_vm.color,"toolbar-title":_vm.toolbarTitle,"persistent":true,"can-edit":_vm.canEdit,"list-title":_vm.listTitle,"add-button":_vm.addButton,"add-button-hover-text":_vm.addButtonHoverText,"dialog-max-width":_vm.dialogMaxWidth,"dialog-toolbar-title":_vm.dialogToolbarTitle + (_vm.theObservationType === '1' ? 'observación' : (_vm.theObservationType === '2' ? 'incidencia' : 'Felicitación'))}},[(_vm.items.length > 0)?_c('v-list',{staticClass:"scroll-y",staticStyle:{"max-height":"282px"},attrs:{"slot":"card-text","three-line":""},slot:"card-text"},[_c('transition-group',{attrs:{"name":"list","tag":"span"}},[_vm._l((_vm.items),function(item,index){return [_c('v-list-tile',{key:(index + 2 * 100),attrs:{"ripple":"","avatar":""},on:{"click":function($event){_vm.openMessage(index)}}},[_c('v-list-tile-action',[(parseInt(item.user_observation_type) === 1)?_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("chat_bubble")]):(parseInt(item.user_observation_type) === 2)?_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("notification_important")]):(parseInt(item.user_observation_type) === 3)?_c('v-icon',{attrs:{"color":_vm.color}},[_vm._v("thumb_up_alt")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.user_observation_title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s('<span class=\'text--primary\'>' + item.user_observation_user + '</span> &mdash; ' + item.user_observation_message)}})],1),_vm._v(" "),(_vm.deleteButton)?_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":"","color":_vm.color},on:{"click":function($event){_vm.askForConfirmation(index)}},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.deleteIconHoverText))])],1)],1):_vm._e()],1),_vm._v(" "),(index + 1 !== _vm.items.length)?_c('v-divider',{key:(index + 1 * 100),attrs:{"inset":false}}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"slot":"dialog-card-text","row":"","align-center":"","justify-center":""},slot:"dialog-card-text"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":""}},[_c('v-text-field',{attrs:{"label":_vm.textFieldLabel,"single-line":"","disabled":_vm.theTitleDisabled,"required":"","rules":_vm.textFieldRules || []},model:{value:(_vm.observationTitle),callback:function ($$v) {_vm.observationTitle=$$v},expression:"observationTitle"}}),_vm._v(" "),_c('v-text-field',{attrs:{"color":"primary","required":"","multi-line":"","rows":5},model:{value:(_vm.observationMsg),callback:function ($$v) {_vm.observationMsg=$$v},expression:"observationMsg"}},[_c('div',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              Mensaje\n            ")])]),_vm._v(" "),(false)?_c('v-btn-toggle',{staticClass:"types",model:{value:(_vm.theObservationType),callback:function ($$v) {_vm.theObservationType=$$v},expression:"theObservationType"}},[_c('v-btn',{attrs:{"flat":"","value":"1"}},[_vm._v("\n                Observación\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":"2"}},[_vm._v("\n                Incidencia\n              ")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"dialog-card-actions"},slot:"dialog-card-actions"},[_c('v-btn',{attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.$refs.aggregator.dialog = false}}},[_vm._v("\n      "+_vm._s(_vm.cancelButton)+"\n    ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid),expression:"valid"}],attrs:{"color":_vm.color,"flat":""},nativeOn:{"click":function($event){_vm.addObservation()}}},[_vm._v("\n      "+_vm._s(_vm.confirmButton)+"\n    ")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"slot":"extras","max-width":"650"},slot:"extras",model:{value:(_vm.preview),callback:function ($$v) {_vm.preview=$$v},expression:"preview"}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[(parseInt(_vm.type) === 1)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("chat_bubble")]):(parseInt(_vm.type) === 2)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("notification_important")]):(parseInt(_vm.type) === 3)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("thumb_up_alt")]):_vm._e(),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(parseInt(_vm.type) === 1 ? 'OBSERVACÍÓN' : 'INCIDENCIA'))])],1),_vm._v(" "),_c('div',{staticClass:"card-date"},[_vm._v(_vm._s(_vm.date))]),_vm._v(" "),_c('v-card-title',{staticClass:"headlines"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-card-text',{staticClass:"card-texts"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.preview = false}}},[_vm._v("Cerrar")])],1)],1)],1),_vm._v(" "),_c('vuetify-dialog-confirm',{attrs:{"slot":"extras","headline":_vm.dialogConfirmHeadline,"text":_vm.dialogConfirmText,"cancel":_vm.cancelButton,"confirm":_vm.confirmButton},on:{"on-cancel-dialog":_vm.onDiscardDeletion,"on-confirm-dialog":_vm.onConfirmDeletion},slot:"extras",model:{value:(_vm.showConfirmDialog),callback:function ($$v) {_vm.showConfirmDialog=$$v},expression:"showConfirmDialog"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueColor=t():e.VueColor=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=22)}([function(e,t){function n(e,t){var n=e[1]||"",a=e[3];if(!a)return n;if(t&&"function"==typeof btoa){var i=r(a);return[n].concat(a.sources.map(function(e){return"/*# sourceURL="+a.sourceRoot+e+" */"})).concat([i]).join("\n")}return[n].join("\n")}function r(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var r=n(t,e);return t[2]?"@media "+t[2]+"{"+r+"}":r}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},a=0;a<this.length;a++){var i=this[a][0];"number"==typeof i&&(r[i]=!0)}for(a=0;a<e.length;a++){var o=e[a];"number"==typeof o[0]&&r[o[0]]||(n&&!o[2]?o[2]=n:n&&(o[2]="("+o[2]+") and ("+n+")"),t.push(o))}},t}},function(e,t,n){function r(e){for(var t=0;t<e.length;t++){var n=e[t],r=u[n.id];if(r){r.refs++;for(var a=0;a<r.parts.length;a++)r.parts[a](n.parts[a]);for(;a<n.parts.length;a++)r.parts.push(i(n.parts[a]));r.parts.length>n.parts.length&&(r.parts.length=n.parts.length)}else{for(var o=[],a=0;a<n.parts.length;a++)o.push(i(n.parts[a]));u[n.id]={id:n.id,refs:1,parts:o}}}}function a(){var e=document.createElement("style");return e.type="text/css",d.appendChild(e),e}function i(e){var t,n,r=document.querySelector("style["+b+'~="'+e.id+'"]');if(r){if(p)return v;r.parentNode.removeChild(r)}if(x){var i=f++;r=h||(h=a()),t=o.bind(null,r,i,!1),n=o.bind(null,r,i,!0)}else r=a(),t=s.bind(null,r),n=function(){r.parentNode.removeChild(r)};return t(e),function(r){if(r){if(r.css===e.css&&r.media===e.media&&r.sourceMap===e.sourceMap)return;t(e=r)}else n()}}function o(e,t,n,r){var a=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=m(t,a);else{var i=document.createTextNode(a),o=e.childNodes;o[t]&&e.removeChild(o[t]),o.length?e.insertBefore(i,o[t]):e.appendChild(i)}}function s(e,t){var n=t.css,r=t.media,a=t.sourceMap;if(r&&e.setAttribute("media",r),g.ssrId&&e.setAttribute(b,t.id),a&&(n+="\n/*# sourceURL="+a.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */"),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}var c="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!c)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var l=n(26),u={},d=c&&(document.head||document.getElementsByTagName("head")[0]),h=null,f=0,p=!1,v=function(){},g=null,b="data-vue-ssr-id",x="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());e.exports=function(e,t,n,a){p=n,g=a||{};var i=l(e,t);return r(i),function(t){for(var n=[],a=0;a<i.length;a++){var o=i[a],s=u[o.id];s.refs--,n.push(s)}t?(i=l(e,t),r(i)):i=[];for(var a=0;a<n.length;a++){var s=n[a];if(0===s.refs){for(var c=0;c<s.parts.length;c++)s.parts[c]();delete u[s.id]}}}};var m=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e,t,n,r,a,i){var o,s=e=e||{},c=typeof e.default;"object"!==c&&"function"!==c||(o=e,s=e.default);var l="function"==typeof s?s.options:s;t&&(l.render=t.render,l.staticRenderFns=t.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),a&&(l._scopeId=a);var u;if(i?(u=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i)},l._ssrRegister=u):r&&(u=r),u){var d=l.functional,h=d?l.render:l.beforeCreate;d?(l._injectStyles=u,l.render=function(e,t){return u.call(t),h(e,t)}):l.beforeCreate=h?[].concat(h,u):[u]}return{esModule:o,exports:s,options:l}}},function(e,t,n){"use strict";function r(e,t){var n,r=e&&e.a;!(n=e&&e.hsl?(0,i.default)(e.hsl):e&&e.hex&&e.hex.length>0?(0,i.default)(e.hex):(0,i.default)(e))||void 0!==n._a&&null!==n._a||n.setAlpha(r||1);var a=n.toHsl(),o=n.toHsv();return 0===a.s&&(o.h=a.h=e.h||e.hsl&&e.hsl.h||t||0),{hsl:a,hex:n.toHexString().toUpperCase(),hex8:n.toHex8String().toUpperCase(),rgba:n.toRgb(),hsv:o,oldHue:e.h||t||a.h,source:e.source,a:e.a||n.getAlpha()}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(27),i=function(e){return e&&e.__esModule?e:{default:e}}(a);t.default={props:["value"],data:function(){return{val:r(this.value)}},computed:{colors:{get:function(){return this.val},set:function(e){this.val=e,this.$emit("input",e)}}},watch:{value:function(e){this.val=r(e)}},methods:{colorChange:function(e,t){this.oldHue=this.colors.hsl.h,this.colors=r(e,t||this.oldHue)},isValidHex:function(e){return(0,i.default)(e).isValid()},simpleCheckForValidColor:function(e){for(var t=["r","g","b","a","h","s","l","v"],n=0,r=0,a=0;a<t.length;a++){var i=t[a];e[i]&&(n++,isNaN(e[i])||r++)}if(n===r)return e},paletteUpperCase:function(e){return e.map(function(e){return e.toUpperCase()})},isTransparent:function(e){return 0===(0,i.default)(e).getAlpha()}}}},function(e,t,n){"use strict";function r(e){c||n(28)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(10),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(30),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/EditableInput.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){c||n(43)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(14),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(45),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/Hue.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){c||n(55)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(17),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(60),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/Saturation.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){c||n(61)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(18),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(66),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/Alpha.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){c||n(63)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(19),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(65),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/common/Checkboard.vue",t.default=d.exports},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(4),s=r(o),c=["#4D4D4D","#999999","#FFFFFF","#F44E3B","#FE9200","#FCDC00","#DBDF00","#A4DD00","#68CCCA","#73D8FF","#AEA1FF","#FDA1FF","#333333","#808080","#CCCCCC","#D33115","#E27300","#FCC400","#B0BC00","#68BC00","#16A5A5","#009CE0","#7B64FF","#FA28FF","#000000","#666666","#B3B3B3","#9F0500","#C45100","#FB9E00","#808900","#194D33","#0C797D","#0062B1","#653294","#AB149E"];t.default={name:"Compact",mixins:[i.default],props:{palette:{type:Array,default:function(){return c}}},components:{"ed-in":s.default},computed:{pick:function(){return this.colors.hex.toUpperCase()}},methods:{handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"editableInput",props:{label:String,labelText:String,desc:String,value:[String,Number],max:Number,min:Number,arrowOffset:{type:Number,default:1}},computed:{val:{get:function(){return this.value},set:function(e){if(!(void 0!==this.max&&+e>this.max))return e;this.$refs.input.value=this.max}},labelId:function(){return"input__label__"+this.label+"__"+Math.random().toString().slice(2,5)},labelSpanText:function(){return this.labelText||this.label}},methods:{update:function(e){this.handleChange(e.target.value)},handleChange:function(e){var t={};t[this.label]=e,void 0===t.hex&&void 0===t["#"]?this.$emit("change",t):e.length>5&&this.$emit("change",t)},handleKeyDown:function(e){var t=this.val,n=Number(t);if(n){var r=this.arrowOffset||1;38===e.keyCode&&(t=n+r,this.handleChange(t),e.preventDefault()),40===e.keyCode&&(t=n-r,this.handleChange(t),e.preventDefault())}}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),a=function(e){return e&&e.__esModule?e:{default:e}}(r),i=["#FFFFFF","#F2F2F2","#E6E6E6","#D9D9D9","#CCCCCC","#BFBFBF","#B3B3B3","#A6A6A6","#999999","#8C8C8C","#808080","#737373","#666666","#595959","#4D4D4D","#404040","#333333","#262626","#0D0D0D","#000000"];t.default={name:"Grayscale",mixins:[a.default],props:{palette:{type:Array,default:function(){return i}}},components:{},computed:{pick:function(){return this.colors.hex.toUpperCase()}},methods:{handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(4),i=r(a),o=n(3),s=r(o);t.default={name:"Material",mixins:[s.default],components:{"ed-in":i.default},methods:{onChange:function(e){e&&(e.hex?this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"}):(e.r||e.g||e.b)&&this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(5),s=r(o);t.default={name:"Slider",mixins:[i.default],props:{swatches:{type:Array,default:function(){return[".80",".65",".50",".35",".20"]}}},components:{hue:s.default},computed:{activeOffset:function(){var e=this.swatches.includes("0"),t=this.swatches.includes("1"),n=this.colors.hsl;return Math.round(100*n.s)/100==.5?Math.round(100*n.l)/100:e&&0===n.l?0:t&&1===n.l?1:-1}},methods:{hueChange:function(e){this.colorChange(e)},handleSwClick:function(e,t){this.colorChange({h:this.colors.hsl.h,s:.5,l:t,source:"hsl"})}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={name:"Hue",props:{value:Object,direction:{type:String,default:"horizontal"}},data:function(){return{oldHue:0,pullDirection:""}},computed:{colors:function(){var e=this.value.hsl.h;return 0!==e&&e-this.oldHue>0&&(this.pullDirection="right"),0!==e&&e-this.oldHue<0&&(this.pullDirection="left"),this.oldHue=e,this.value},directionClass:function(){return{"vc-hue--horizontal":"horizontal"===this.direction,"vc-hue--vertical":"vertical"===this.direction}},pointerTop:function(){return"vertical"===this.direction?0===this.colors.hsl.h&&"right"===this.pullDirection?0:-100*this.colors.hsl.h/360+100+"%":0},pointerLeft:function(){return"vertical"===this.direction?0:0===this.colors.hsl.h&&"right"===this.pullDirection?"100%":100*this.colors.hsl.h/360+"%"}},methods:{handleChange:function(e,t){!t&&e.preventDefault();var n,r,a=this.$refs.container,i=a.clientWidth,o=a.clientHeight,s=a.getBoundingClientRect().left+window.pageXOffset,c=a.getBoundingClientRect().top+window.pageYOffset,l=e.pageX||(e.touches?e.touches[0].pageX:0),u=e.pageY||(e.touches?e.touches[0].pageY:0),d=l-s,h=u-c;"vertical"===this.direction?(h<0?n=360:h>o?n=0:(r=-100*h/o+100,n=360*r/100),this.colors.hsl.h!==n&&this.$emit("change",{h:n,s:this.colors.hsl.s,l:this.colors.hsl.l,a:this.colors.hsl.a,source:"hsl"})):(d<0?n=0:d>i?n=360:(r=100*d/i,n=360*r/100),this.colors.hsl.h!==n&&this.$emit("change",{h:n,s:this.colors.hsl.s,l:this.colors.hsl.l,a:this.colors.hsl.a,source:"hsl"}))},handleMouseDown:function(e){this.handleChange(e,!0),window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(50),i=r(a),o=n(3),s=r(o),c=["red","pink","purple","deepPurple","indigo","blue","lightBlue","cyan","teal","green","lightGreen","lime","yellow","amber","orange","deepOrange","brown","blueGrey","black"],l=["900","700","500","300","100"],u=function(){var e=[];return c.forEach(function(t){var n=[];"black"===t.toLowerCase()||"white"===t.toLowerCase()?n=n.concat(["#000000","#FFFFFF"]):l.forEach(function(e){var r=i.default[t][e];n.push(r.toUpperCase())}),e.push(n)}),e}();t.default={name:"Swatches",mixins:[s.default],props:{palette:{type:Array,default:function(){return u}}},computed:{pick:function(){return this.colors.hex}},methods:{equal:function(e){return e.toLowerCase()===this.colors.hex.toLowerCase()},handlerClick:function(e){this.colorChange({hex:e,source:"hex"})}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(4),s=r(o),c=n(6),l=r(c),u=n(5),d=r(u),h=n(7),f=r(h);t.default={name:"Photoshop",mixins:[i.default],props:{head:{type:String,default:"Color Picker"},disableFields:{type:Boolean,default:!1},hasResetButton:{type:Boolean,default:!1},acceptLabel:{type:String,default:"OK"},cancelLabel:{type:String,default:"Cancel"},resetLabel:{type:String,default:"Reset"},newLabel:{type:String,default:"new"},currentLabel:{type:String,default:"current"}},components:{saturation:l.default,hue:d.default,alpha:f.default,"ed-in":s.default},data:function(){return{currentColor:"#FFF"}},computed:{hsv:function(){var e=this.colors.hsv;return{h:e.h.toFixed(),s:(100*e.s).toFixed(),v:(100*e.v).toFixed()}},hex:function(){var e=this.colors.hex;return e&&e.replace("#","")}},created:function(){this.currentColor=this.colors.hex},methods:{childChange:function(e){this.colorChange(e)},inputChange:function(e){e&&(e["#"]?this.isValidHex(e["#"])&&this.colorChange({hex:e["#"],source:"hex"}):e.r||e.g||e.b||e.a?this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}):(e.h||e.s||e.v)&&this.colorChange({h:e.h||this.colors.hsv.h,s:e.s/100||this.colors.hsv.s,v:e.v/100||this.colors.hsv.v,source:"hsv"}))},clickCurrentColor:function(){this.colorChange({hex:this.currentColor,source:"hex"})},handleAccept:function(){this.$emit("ok")},handleCancel:function(){this.$emit("cancel")},handleReset:function(){this.$emit("reset")}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(57),i=r(a),o=n(58),s=r(o);t.default={name:"Saturation",props:{value:Object},computed:{colors:function(){return this.value},bgColor:function(){return"hsl("+this.colors.hsv.h+", 100%, 50%)"},pointerTop:function(){return-100*this.colors.hsv.v+1+100+"%"},pointerLeft:function(){return 100*this.colors.hsv.s+"%"}},methods:{throttle:(0,s.default)(function(e,t){e(t)},20,{leading:!0,trailing:!1}),handleChange:function(e,t){!t&&e.preventDefault();var n=this.$refs.container,r=n.clientWidth,a=n.clientHeight,o=n.getBoundingClientRect().left+window.pageXOffset,s=n.getBoundingClientRect().top+window.pageYOffset,c=e.pageX||(e.touches?e.touches[0].pageX:0),l=e.pageY||(e.touches?e.touches[0].pageY:0),u=(0,i.default)(c-o,0,r),d=(0,i.default)(l-s,0,a),h=u/r,f=(0,i.default)(-d/a+1,0,1);this.throttle(this.onChange,{h:this.colors.hsv.h,s:h,v:f,a:this.colors.hsv.a,source:"hsva"})},onChange:function(e){this.$emit("change",e)},handleMouseDown:function(e){window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(e){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(8),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default={name:"Alpha",props:{value:Object,onChange:Function},components:{checkboard:a.default},computed:{colors:function(){return this.value},gradientColor:function(){var e=this.colors.rgba,t=[e.r,e.g,e.b].join(",");return"linear-gradient(to right, rgba("+t+", 0) 0%, rgba("+t+", 1) 100%)"}},methods:{handleChange:function(e,t){!t&&e.preventDefault();var n,r=this.$refs.container,a=r.clientWidth,i=r.getBoundingClientRect().left+window.pageXOffset,o=e.pageX||(e.touches?e.touches[0].pageX:0),s=o-i;n=s<0?0:s>a?1:Math.round(100*s/a)/100,this.colors.a!==n&&this.$emit("change",{h:this.colors.hsl.h,s:this.colors.hsl.s,l:this.colors.hsl.l,a:n,source:"rgba"})},handleMouseDown:function(e){this.handleChange(e,!0),window.addEventListener("mousemove",this.handleChange),window.addEventListener("mouseup",this.handleMouseUp)},handleMouseUp:function(){this.unbindEventListeners()},unbindEventListeners:function(){window.removeEventListener("mousemove",this.handleChange),window.removeEventListener("mouseup",this.handleMouseUp)}}}},function(e,t,n){"use strict";function r(e,t,n){if("undefined"==typeof document)return null;var r=document.createElement("canvas");r.width=r.height=2*n;var a=r.getContext("2d");return a?(a.fillStyle=e,a.fillRect(0,0,r.width,r.height),a.fillStyle=t,a.fillRect(0,0,n,n),a.translate(n,n),a.fillRect(0,0,n,n),r.toDataURL()):null}function a(e,t,n){var a=e+","+t+","+n;if(i[a])return i[a];var o=r(e,t,n);return i[a]=o,o}Object.defineProperty(t,"__esModule",{value:!0});var i={};t.default={name:"Checkboard",props:{size:{type:[Number,String],default:8},white:{type:String,default:"#fff"},grey:{type:String,default:"#e6e6e6"}},computed:{bgStyle:function(){return{"background-image":"url("+a(this.white,this.grey,this.size)+")"}}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(4),s=r(o),c=n(6),l=r(c),u=n(5),d=r(u),h=n(7),f=r(h),p=n(8),v=r(p),g=["#D0021B","#F5A623","#F8E71C","#8B572A","#7ED321","#417505","#BD10E0","#9013FE","#4A90E2","#50E3C2","#B8E986","#000000","#4A4A4A","#9B9B9B","#FFFFFF","rgba(0,0,0,0)"];t.default={name:"Sketch",mixins:[i.default],components:{saturation:l.default,hue:d.default,alpha:f.default,"ed-in":s.default,checkboard:v.default},props:{presetColors:{type:Array,default:function(){return g}},disableAlpha:{type:Boolean,default:!1},disableFields:{type:Boolean,default:!1}},computed:{hex:function(){var e=void 0;return e=this.colors.a<1?this.colors.hex8:this.colors.hex,e.replace("#","")},activeColor:function(){var e=this.colors.rgba;return"rgba("+[e.r,e.g,e.b,e.a].join(",")+")"}},methods:{handlePreset:function(e){this.colorChange({hex:e,source:"hex"})},childChange:function(e){this.colorChange(e)},inputChange:function(e){e&&(e.hex?this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"}):(e.r||e.g||e.b||e.a)&&this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"}))}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(3),i=r(a),o=n(4),s=r(o),c=n(6),l=r(c),u=n(5),d=r(u),h=n(7),f=r(h),p=n(8),v=r(p);t.default={name:"Chrome",mixins:[i.default],props:{disableAlpha:{type:Boolean,default:!1},disableFields:{type:Boolean,default:!1}},components:{saturation:l.default,hue:d.default,alpha:f.default,"ed-in":s.default,checkboard:v.default},data:function(){return{fieldsIndex:0,highlight:!1}},computed:{hsl:function(){var e=this.colors.hsl,t=e.h,n=e.s,r=e.l;return{h:t.toFixed(),s:(100*n).toFixed()+"%",l:(100*r).toFixed()+"%"}},activeColor:function(){var e=this.colors.rgba;return"rgba("+[e.r,e.g,e.b,e.a].join(",")+")"},hasAlpha:function(){return this.colors.a<1}},methods:{childChange:function(e){this.colorChange(e)},inputChange:function(e){if(e)if(e.hex)this.isValidHex(e.hex)&&this.colorChange({hex:e.hex,source:"hex"});else if(e.r||e.g||e.b||e.a)this.colorChange({r:e.r||this.colors.rgba.r,g:e.g||this.colors.rgba.g,b:e.b||this.colors.rgba.b,a:e.a||this.colors.rgba.a,source:"rgba"});else if(e.h||e.s||e.l){var t=e.s?e.s.replace("%","")/100:this.colors.hsl.s,n=e.l?e.l.replace("%","")/100:this.colors.hsl.l;this.colorChange({h:e.h||this.colors.hsl.h,s:t,l:n,source:"hsl"})}},toggleViews:function(){if(this.fieldsIndex>=2)return void(this.fieldsIndex=0);this.fieldsIndex++},showHighlight:function(){this.highlight=!0},hideHighlight:function(){this.highlight=!1}}}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}var a=n(23),i=r(a),o=n(32),s=r(o),c=n(36),l=r(c),u=n(40),d=r(u),h=n(47),f=r(h),p=n(52),v=r(p),g=n(68),b=r(g),x=n(72),m=r(x),_=n(7),w=r(_),C=n(8),y=r(C),k=n(4),F=r(k),A=n(5),S=r(A),M=n(6),E=r(M),L=n(3),R=r(L),j={version:"2.7.0",Compact:i.default,Grayscale:s.default,Material:l.default,Slider:d.default,Swatches:f.default,Photoshop:v.default,Sketch:b.default,Chrome:m.default,Alpha:w.default,Checkboard:y.default,EditableInput:F.default,Hue:S.default,Saturation:E.default,ColorMixin:R.default};e.exports=j},function(e,t,n){"use strict";function r(e){c||n(24)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(9),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(31),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Compact.vue",t.default=d.exports},function(e,t,n){var r=n(25);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("6ce8a5a8",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-compact {\n  padding-top: 5px;\n  padding-left: 5px;\n  width: 240px;\n  border-radius: 2px;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-compact-colors {\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-compact-color-item {\n  list-style: none;\n  width: 15px;\n  height: 15px;\n  float: left;\n  margin-right: 5px;\n  margin-bottom: 5px;\n  position: relative;\n  cursor: pointer;\n}\n.vc-compact-color-item--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-compact-color-item--white .vc-compact-dot {\n  background: #000;\n}\n.vc-compact-dot {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  bottom: 5px;\n  left: 5px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n",""])},function(e,t){e.exports=function(e,t){for(var n=[],r={},a=0;a<t.length;a++){var i=t[a],o=i[0],s=i[1],c=i[2],l=i[3],u={id:e+":"+a,css:s,media:c,sourceMap:l};r[o]?r[o].parts.push(u):n.push(r[o]={id:o,parts:[u]})}return n}},function(e,t,n){var r;!function(a){function i(e,t){if(e=e||"",t=t||{},e instanceof i)return e;if(!(this instanceof i))return new i(e,t);var n=o(e);this._originalInput=e,this._r=n.r,this._g=n.g,this._b=n.b,this._a=n.a,this._roundA=q(100*this._a)/100,this._format=t.format||n.format,this._gradientType=t.gradientType,this._r<1&&(this._r=q(this._r)),this._g<1&&(this._g=q(this._g)),this._b<1&&(this._b=q(this._b)),this._ok=n.ok,this._tc_id=U++}function o(e){var t={r:0,g:0,b:0},n=1,r=null,a=null,i=null,o=!1,c=!1;return"string"==typeof e&&(e=z(e)),"object"==typeof e&&($(e.r)&&$(e.g)&&$(e.b)?(t=s(e.r,e.g,e.b),o=!0,c="%"===String(e.r).substr(-1)?"prgb":"rgb"):$(e.h)&&$(e.s)&&$(e.v)?(r=D(e.s),a=D(e.v),t=d(e.h,r,a),o=!0,c="hsv"):$(e.h)&&$(e.s)&&$(e.l)&&(r=D(e.s),i=D(e.l),t=l(e.h,r,i),o=!0,c="hsl"),e.hasOwnProperty("a")&&(n=e.a)),n=M(n),{ok:o,format:e.format||c,r:V(255,X(t.r,0)),g:V(255,X(t.g,0)),b:V(255,X(t.b,0)),a:n}}function s(e,t,n){return{r:255*E(e,255),g:255*E(t,255),b:255*E(n,255)}}function c(e,t,n){e=E(e,255),t=E(t,255),n=E(n,255);var r,a,i=X(e,t,n),o=V(e,t,n),s=(i+o)/2;if(i==o)r=a=0;else{var c=i-o;switch(a=s>.5?c/(2-i-o):c/(i+o),i){case e:r=(t-n)/c+(t<n?6:0);break;case t:r=(n-e)/c+2;break;case n:r=(e-t)/c+4}r/=6}return{h:r,s:a,l:s}}function l(e,t,n){function r(e,t,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?e+6*(t-e)*n:n<.5?t:n<2/3?e+(t-e)*(2/3-n)*6:e}var a,i,o;if(e=E(e,360),t=E(t,100),n=E(n,100),0===t)a=i=o=n;else{var s=n<.5?n*(1+t):n+t-n*t,c=2*n-s;a=r(c,s,e+1/3),i=r(c,s,e),o=r(c,s,e-1/3)}return{r:255*a,g:255*i,b:255*o}}function u(e,t,n){e=E(e,255),t=E(t,255),n=E(n,255);var r,a,i=X(e,t,n),o=V(e,t,n),s=i,c=i-o;if(a=0===i?0:c/i,i==o)r=0;else{switch(i){case e:r=(t-n)/c+(t<n?6:0);break;case t:r=(n-e)/c+2;break;case n:r=(e-t)/c+4}r/=6}return{h:r,s:a,v:s}}function d(e,t,n){e=6*E(e,360),t=E(t,100),n=E(n,100);var r=a.floor(e),i=e-r,o=n*(1-t),s=n*(1-i*t),c=n*(1-(1-i)*t),l=r%6;return{r:255*[n,s,o,o,c,n][l],g:255*[c,n,n,s,o,o][l],b:255*[o,o,c,n,n,s][l]}}function h(e,t,n,r){var a=[B(q(e).toString(16)),B(q(t).toString(16)),B(q(n).toString(16))];return r&&a[0].charAt(0)==a[0].charAt(1)&&a[1].charAt(0)==a[1].charAt(1)&&a[2].charAt(0)==a[2].charAt(1)?a[0].charAt(0)+a[1].charAt(0)+a[2].charAt(0):a.join("")}function f(e,t,n,r,a){var i=[B(q(e).toString(16)),B(q(t).toString(16)),B(q(n).toString(16)),B(H(r))];return a&&i[0].charAt(0)==i[0].charAt(1)&&i[1].charAt(0)==i[1].charAt(1)&&i[2].charAt(0)==i[2].charAt(1)&&i[3].charAt(0)==i[3].charAt(1)?i[0].charAt(0)+i[1].charAt(0)+i[2].charAt(0)+i[3].charAt(0):i.join("")}function p(e,t,n,r){return[B(H(r)),B(q(e).toString(16)),B(q(t).toString(16)),B(q(n).toString(16))].join("")}function v(e,t){t=0===t?0:t||10;var n=i(e).toHsl();return n.s-=t/100,n.s=L(n.s),i(n)}function g(e,t){t=0===t?0:t||10;var n=i(e).toHsl();return n.s+=t/100,n.s=L(n.s),i(n)}function b(e){return i(e).desaturate(100)}function x(e,t){t=0===t?0:t||10;var n=i(e).toHsl();return n.l+=t/100,n.l=L(n.l),i(n)}function m(e,t){t=0===t?0:t||10;var n=i(e).toRgb();return n.r=X(0,V(255,n.r-q(-t/100*255))),n.g=X(0,V(255,n.g-q(-t/100*255))),n.b=X(0,V(255,n.b-q(-t/100*255))),i(n)}function _(e,t){t=0===t?0:t||10;var n=i(e).toHsl();return n.l-=t/100,n.l=L(n.l),i(n)}function w(e,t){var n=i(e).toHsl(),r=(n.h+t)%360;return n.h=r<0?360+r:r,i(n)}function C(e){var t=i(e).toHsl();return t.h=(t.h+180)%360,i(t)}function y(e){var t=i(e).toHsl(),n=t.h;return[i(e),i({h:(n+120)%360,s:t.s,l:t.l}),i({h:(n+240)%360,s:t.s,l:t.l})]}function k(e){var t=i(e).toHsl(),n=t.h;return[i(e),i({h:(n+90)%360,s:t.s,l:t.l}),i({h:(n+180)%360,s:t.s,l:t.l}),i({h:(n+270)%360,s:t.s,l:t.l})]}function F(e){var t=i(e).toHsl(),n=t.h;return[i(e),i({h:(n+72)%360,s:t.s,l:t.l}),i({h:(n+216)%360,s:t.s,l:t.l})]}function A(e,t,n){t=t||6,n=n||30;var r=i(e).toHsl(),a=360/n,o=[i(e)];for(r.h=(r.h-(a*t>>1)+720)%360;--t;)r.h=(r.h+a)%360,o.push(i(r));return o}function S(e,t){t=t||6;for(var n=i(e).toHsv(),r=n.h,a=n.s,o=n.v,s=[],c=1/t;t--;)s.push(i({h:r,s:a,v:o})),o=(o+c)%1;return s}function M(e){return e=parseFloat(e),(isNaN(e)||e<0||e>1)&&(e=1),e}function E(e,t){j(e)&&(e="100%");var n=O(e);return e=V(t,X(0,parseFloat(e))),n&&(e=parseInt(e*t,10)/100),a.abs(e-t)<1e-6?1:e%t/parseFloat(t)}function L(e){return V(1,X(0,e))}function R(e){return parseInt(e,16)}function j(e){return"string"==typeof e&&-1!=e.indexOf(".")&&1===parseFloat(e)}function O(e){return"string"==typeof e&&-1!=e.indexOf("%")}function B(e){return 1==e.length?"0"+e:""+e}function D(e){return e<=1&&(e=100*e+"%"),e}function H(e){return a.round(255*parseFloat(e)).toString(16)}function P(e){return R(e)/255}function $(e){return!!K.CSS_UNIT.exec(e)}function z(e){e=e.replace(T,"").replace(I,"").toLowerCase();var t=!1;if(W[e])e=W[e],t=!0;else if("transparent"==e)return{r:0,g:0,b:0,a:0,format:"name"};var n;return(n=K.rgb.exec(e))?{r:n[1],g:n[2],b:n[3]}:(n=K.rgba.exec(e))?{r:n[1],g:n[2],b:n[3],a:n[4]}:(n=K.hsl.exec(e))?{h:n[1],s:n[2],l:n[3]}:(n=K.hsla.exec(e))?{h:n[1],s:n[2],l:n[3],a:n[4]}:(n=K.hsv.exec(e))?{h:n[1],s:n[2],v:n[3]}:(n=K.hsva.exec(e))?{h:n[1],s:n[2],v:n[3],a:n[4]}:(n=K.hex8.exec(e))?{r:R(n[1]),g:R(n[2]),b:R(n[3]),a:P(n[4]),format:t?"name":"hex8"}:(n=K.hex6.exec(e))?{r:R(n[1]),g:R(n[2]),b:R(n[3]),format:t?"name":"hex"}:(n=K.hex4.exec(e))?{r:R(n[1]+""+n[1]),g:R(n[2]+""+n[2]),b:R(n[3]+""+n[3]),a:P(n[4]+""+n[4]),format:t?"name":"hex8"}:!!(n=K.hex3.exec(e))&&{r:R(n[1]+""+n[1]),g:R(n[2]+""+n[2]),b:R(n[3]+""+n[3]),format:t?"name":"hex"}}function N(e){var t,n;return e=e||{level:"AA",size:"small"},t=(e.level||"AA").toUpperCase(),n=(e.size||"small").toLowerCase(),"AA"!==t&&"AAA"!==t&&(t="AA"),"small"!==n&&"large"!==n&&(n="small"),{level:t,size:n}}var T=/^\s+/,I=/\s+$/,U=0,q=a.round,V=a.min,X=a.max,G=a.random;i.prototype={isDark:function(){return this.getBrightness()<128},isLight:function(){return!this.isDark()},isValid:function(){return this._ok},getOriginalInput:function(){return this._originalInput},getFormat:function(){return this._format},getAlpha:function(){return this._a},getBrightness:function(){var e=this.toRgb();return(299*e.r+587*e.g+114*e.b)/1e3},getLuminance:function(){var e,t,n,r,i,o,s=this.toRgb();return e=s.r/255,t=s.g/255,n=s.b/255,r=e<=.03928?e/12.92:a.pow((e+.055)/1.055,2.4),i=t<=.03928?t/12.92:a.pow((t+.055)/1.055,2.4),o=n<=.03928?n/12.92:a.pow((n+.055)/1.055,2.4),.2126*r+.7152*i+.0722*o},setAlpha:function(e){return this._a=M(e),this._roundA=q(100*this._a)/100,this},toHsv:function(){var e=u(this._r,this._g,this._b);return{h:360*e.h,s:e.s,v:e.v,a:this._a}},toHsvString:function(){var e=u(this._r,this._g,this._b),t=q(360*e.h),n=q(100*e.s),r=q(100*e.v);return 1==this._a?"hsv("+t+", "+n+"%, "+r+"%)":"hsva("+t+", "+n+"%, "+r+"%, "+this._roundA+")"},toHsl:function(){var e=c(this._r,this._g,this._b);return{h:360*e.h,s:e.s,l:e.l,a:this._a}},toHslString:function(){var e=c(this._r,this._g,this._b),t=q(360*e.h),n=q(100*e.s),r=q(100*e.l);return 1==this._a?"hsl("+t+", "+n+"%, "+r+"%)":"hsla("+t+", "+n+"%, "+r+"%, "+this._roundA+")"},toHex:function(e){return h(this._r,this._g,this._b,e)},toHexString:function(e){return"#"+this.toHex(e)},toHex8:function(e){return f(this._r,this._g,this._b,this._a,e)},toHex8String:function(e){return"#"+this.toHex8(e)},toRgb:function(){return{r:q(this._r),g:q(this._g),b:q(this._b),a:this._a}},toRgbString:function(){return 1==this._a?"rgb("+q(this._r)+", "+q(this._g)+", "+q(this._b)+")":"rgba("+q(this._r)+", "+q(this._g)+", "+q(this._b)+", "+this._roundA+")"},toPercentageRgb:function(){return{r:q(100*E(this._r,255))+"%",g:q(100*E(this._g,255))+"%",b:q(100*E(this._b,255))+"%",a:this._a}},toPercentageRgbString:function(){return 1==this._a?"rgb("+q(100*E(this._r,255))+"%, "+q(100*E(this._g,255))+"%, "+q(100*E(this._b,255))+"%)":"rgba("+q(100*E(this._r,255))+"%, "+q(100*E(this._g,255))+"%, "+q(100*E(this._b,255))+"%, "+this._roundA+")"},toName:function(){return 0===this._a?"transparent":!(this._a<1)&&(Y[h(this._r,this._g,this._b,!0)]||!1)},toFilter:function(e){var t="#"+p(this._r,this._g,this._b,this._a),n=t,r=this._gradientType?"GradientType = 1, ":"";if(e){var a=i(e);n="#"+p(a._r,a._g,a._b,a._a)}return"progid:DXImageTransform.Microsoft.gradient("+r+"startColorstr="+t+",endColorstr="+n+")"},toString:function(e){var t=!!e;e=e||this._format;var n=!1,r=this._a<1&&this._a>=0;return t||!r||"hex"!==e&&"hex6"!==e&&"hex3"!==e&&"hex4"!==e&&"hex8"!==e&&"name"!==e?("rgb"===e&&(n=this.toRgbString()),"prgb"===e&&(n=this.toPercentageRgbString()),"hex"!==e&&"hex6"!==e||(n=this.toHexString()),"hex3"===e&&(n=this.toHexString(!0)),"hex4"===e&&(n=this.toHex8String(!0)),"hex8"===e&&(n=this.toHex8String()),"name"===e&&(n=this.toName()),"hsl"===e&&(n=this.toHslString()),"hsv"===e&&(n=this.toHsvString()),n||this.toHexString()):"name"===e&&0===this._a?this.toName():this.toRgbString()},clone:function(){return i(this.toString())},_applyModification:function(e,t){var n=e.apply(null,[this].concat([].slice.call(t)));return this._r=n._r,this._g=n._g,this._b=n._b,this.setAlpha(n._a),this},lighten:function(){return this._applyModification(x,arguments)},brighten:function(){return this._applyModification(m,arguments)},darken:function(){return this._applyModification(_,arguments)},desaturate:function(){return this._applyModification(v,arguments)},saturate:function(){return this._applyModification(g,arguments)},greyscale:function(){return this._applyModification(b,arguments)},spin:function(){return this._applyModification(w,arguments)},_applyCombination:function(e,t){return e.apply(null,[this].concat([].slice.call(t)))},analogous:function(){return this._applyCombination(A,arguments)},complement:function(){return this._applyCombination(C,arguments)},monochromatic:function(){return this._applyCombination(S,arguments)},splitcomplement:function(){return this._applyCombination(F,arguments)},triad:function(){return this._applyCombination(y,arguments)},tetrad:function(){return this._applyCombination(k,arguments)}},i.fromRatio=function(e,t){if("object"==typeof e){var n={};for(var r in e)e.hasOwnProperty(r)&&(n[r]="a"===r?e[r]:D(e[r]));e=n}return i(e,t)},i.equals=function(e,t){return!(!e||!t)&&i(e).toRgbString()==i(t).toRgbString()},i.random=function(){return i.fromRatio({r:G(),g:G(),b:G()})},i.mix=function(e,t,n){n=0===n?0:n||50;var r=i(e).toRgb(),a=i(t).toRgb(),o=n/100;return i({r:(a.r-r.r)*o+r.r,g:(a.g-r.g)*o+r.g,b:(a.b-r.b)*o+r.b,a:(a.a-r.a)*o+r.a})},i.readability=function(e,t){var n=i(e),r=i(t);return(a.max(n.getLuminance(),r.getLuminance())+.05)/(a.min(n.getLuminance(),r.getLuminance())+.05)},i.isReadable=function(e,t,n){var r,a,o=i.readability(e,t);switch(a=!1,r=N(n),r.level+r.size){case"AAsmall":case"AAAlarge":a=o>=4.5;break;case"AAlarge":a=o>=3;break;case"AAAsmall":a=o>=7}return a},i.mostReadable=function(e,t,n){var r,a,o,s,c=null,l=0;n=n||{},a=n.includeFallbackColors,o=n.level,s=n.size;for(var u=0;u<t.length;u++)(r=i.readability(e,t[u]))>l&&(l=r,c=i(t[u]));return i.isReadable(e,c,{level:o,size:s})||!a?c:(n.includeFallbackColors=!1,i.mostReadable(e,["#fff","#000"],n))};var W=i.names={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"0ff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000",blanchedalmond:"ffebcd",blue:"00f",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",burntsienna:"ea7e5d",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"0ff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkgrey:"a9a9a9",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkslategrey:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dimgrey:"696969",dodgerblue:"1e90ff",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"f0f",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",grey:"808080",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgray:"d3d3d3",lightgreen:"90ee90",lightgrey:"d3d3d3",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslategray:"789",lightslategrey:"789",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"0f0",limegreen:"32cd32",linen:"faf0e6",magenta:"f0f",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370db",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"db7093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",rebeccapurple:"663399",red:"f00",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",slategrey:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",wheat:"f5deb3",white:"fff",whitesmoke:"f5f5f5",yellow:"ff0",yellowgreen:"9acd32"},Y=i.hexNames=function(e){var t={};for(var n in e)e.hasOwnProperty(n)&&(t[e[n]]=n);return t}(W),K=function(){var e="(?:[-\\+]?\\d*\\.\\d+%?)|(?:[-\\+]?\\d+%?)",t="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?",n="[\\s|\\(]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")[,|\\s]+("+e+")\\s*\\)?";return{CSS_UNIT:new RegExp(e),rgb:new RegExp("rgb"+t),rgba:new RegExp("rgba"+n),hsl:new RegExp("hsl"+t),hsla:new RegExp("hsla"+n),hsv:new RegExp("hsv"+t),hsva:new RegExp("hsva"+n),hex3:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex6:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,hex4:/^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,hex8:/^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/}}();void 0!==e&&e.exports?e.exports=i:void 0!==(r=function(){return i}.call(t,n,t,e))&&(e.exports=r)}(Math)},function(e,t,n){var r=n(29);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("0f73e73c",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-editable-input {\n  position: relative;\n}\n.vc-input__input {\n  padding: 0;\n  border: 0;\n  outline: none;\n}\n.vc-input__label {\n  text-transform: capitalize;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-editable-input"},[n("input",{directives:[{name:"model",rawName:"v-model",value:e.val,expression:"val"}],ref:"input",staticClass:"vc-input__input",attrs:{"aria-labelledby":e.labelId},domProps:{value:e.val},on:{keydown:e.handleKeyDown,input:[function(t){t.target.composing||(e.val=t.target.value)},e.update]}}),e._v(" "),n("span",{staticClass:"vc-input__label",attrs:{for:e.label,id:e.labelId}},[e._v(e._s(e.labelSpanText))]),e._v(" "),n("span",{staticClass:"vc-input__desc"},[e._v(e._s(e.desc))])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-compact",attrs:{role:"application","aria-label":"Compact color picker"}},[n("ul",{staticClass:"vc-compact-colors",attrs:{role:"listbox"}},e._l(e.paletteUpperCase(e.palette),function(t){return n("li",{key:t,staticClass:"vc-compact-color-item",class:{"vc-compact-color-item--white":"#FFFFFF"===t},style:{background:t},attrs:{role:"option","aria-label":"color:"+t,"aria-selected":t===e.pick},on:{click:function(n){e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t===e.pick,expression:"c === pick"}],staticClass:"vc-compact-dot"})])}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(33)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(11),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(35),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Grayscale.vue",t.default=d.exports},function(e,t,n){var r=n(34);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("21ddbb74",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-grayscale {\n  width: 125px;\n  border-radius: 2px;\n  box-shadow: 0 2px 15px rgba(0,0,0,.12), 0 2px 10px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-grayscale-colors {\n  border-radius: 2px;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n}\n.vc-grayscale-color-item {\n  list-style: none;\n  width: 25px;\n  height: 25px;\n  float: left;\n  position: relative;\n  cursor: pointer;\n}\n.vc-grayscale-color-item--white .vc-grayscale-dot {\n  background: #000;\n}\n.vc-grayscale-dot {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 6px;\n  height: 6px;\n  margin: -3px 0 0 -2px;\n  border-radius: 50%;\n  opacity: 1;\n  background: #fff;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-grayscale",attrs:{role:"application","aria-label":"Grayscale color picker"}},[n("ul",{staticClass:"vc-grayscale-colors",attrs:{role:"listbox"}},e._l(e.paletteUpperCase(e.palette),function(t){return n("li",{key:t,staticClass:"vc-grayscale-color-item",class:{"vc-grayscale-color-item--white":"#FFFFFF"==t},style:{background:t},attrs:{role:"option","aria-label":"Color:"+t,"aria-selected":t===e.pick},on:{click:function(n){e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t===e.pick,expression:"c === pick"}],staticClass:"vc-grayscale-dot"})])}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(37)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(12),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(39),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Material.vue",t.default=d.exports},function(e,t,n){var r=n(38);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("1ff3af73",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,'\n.vc-material {\n  width: 98px;\n  height: 98px;\n  padding: 16px;\n  font-family: "Roboto";\n  position: relative;\n  border-radius: 2px;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n  background-color: #fff;\n}\n.vc-material .vc-input__input {\n  width: 100%;\n  margin-top: 12px;\n  font-size: 15px;\n  color: #333;\n  height: 30px;\n}\n.vc-material .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 11px;\n  color: #999;\n  text-transform: capitalize;\n}\n.vc-material-hex {\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n}\n.vc-material-split {\n  display: flex;\n  margin-right: -10px;\n  padding-top: 11px;\n}\n.vc-material-third {\n  flex: 1;\n  padding-right: 10px;\n}\n',""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-material",attrs:{role:"application","aria-label":"Material color picker"}},[n("ed-in",{staticClass:"vc-material-hex",style:{borderColor:e.colors.hex},attrs:{label:"hex"},on:{change:e.onChange},model:{value:e.colors.hex,callback:function(t){e.$set(e.colors,"hex",t)},expression:"colors.hex"}}),e._v(" "),n("div",{staticClass:"vc-material-split"},[n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"r"},on:{change:e.onChange},model:{value:e.colors.rgba.r,callback:function(t){e.$set(e.colors.rgba,"r",t)},expression:"colors.rgba.r"}})],1),e._v(" "),n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"g"},on:{change:e.onChange},model:{value:e.colors.rgba.g,callback:function(t){e.$set(e.colors.rgba,"g",t)},expression:"colors.rgba.g"}})],1),e._v(" "),n("div",{staticClass:"vc-material-third"},[n("ed-in",{attrs:{label:"b"},on:{change:e.onChange},model:{value:e.colors.rgba.b,callback:function(t){e.$set(e.colors.rgba,"b",t)},expression:"colors.rgba.b"}})],1)])],1)},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(41)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(13),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(46),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Slider.vue",t.default=d.exports},function(e,t,n){var r=n(42);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7982aa43",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-slider {\n  position: relative;\n  width: 410px;\n}\n.vc-slider-hue-warp {\n  height: 12px;\n  position: relative;\n}\n.vc-slider-hue-warp .vc-hue-picker {\n  width: 14px;\n  height: 14px;\n  border-radius: 6px;\n  transform: translate(-7px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-slider-swatches {\n  display: flex;\n  margin-top: 20px;\n}\n.vc-slider-swatch {\n  margin-right: 1px;\n  flex: 1;\n  width: 20%;\n}\n.vc-slider-swatch:first-child {\n  margin-right: 1px;\n}\n.vc-slider-swatch:first-child .vc-slider-swatch-picker {\n  border-radius: 2px 0px 0px 2px;\n}\n.vc-slider-swatch:last-child {\n  margin-right: 0;\n}\n.vc-slider-swatch:last-child .vc-slider-swatch-picker {\n  border-radius: 0px 2px 2px 0px;\n}\n.vc-slider-swatch-picker {\n  cursor: pointer;\n  height: 12px;\n}\n.vc-slider-swatch-picker--active {\n  transform: scaleY(1.8);\n  border-radius: 3.6px/2px;\n}\n.vc-slider-swatch-picker--white {\n  box-shadow: inset 0 0 0 1px #ddd;\n}\n.vc-slider-swatch-picker--active.vc-slider-swatch-picker--white {\n  box-shadow: inset 0 0 0 0.6px #ddd;\n}\n",""])},function(e,t,n){var r=n(44);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7c5f1a1c",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-hue {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  border-radius: 2px;\n}\n.vc-hue--horizontal {\n  background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue--vertical {\n  background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n}\n.vc-hue-container {\n  cursor: pointer;\n  margin: 0 2px;\n  position: relative;\n  height: 100%;\n}\n.vc-hue-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-hue-picker {\n  cursor: pointer;\n  margin-top: 1px;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  transform: translateX(-2px) ;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-hue",e.directionClass]},[n("div",{ref:"container",staticClass:"vc-hue-container",attrs:{role:"slider","aria-valuenow":e.colors.hsl.h,"aria-valuemin":"0","aria-valuemax":"360"},on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-hue-pointer",style:{top:e.pointerTop,left:e.pointerLeft},attrs:{role:"presentation"}},[n("div",{staticClass:"vc-hue-picker"})])])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-slider",attrs:{role:"application","aria-label":"Slider color picker"}},[n("div",{staticClass:"vc-slider-hue-warp"},[n("hue",{on:{change:e.hueChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-slider-swatches",attrs:{role:"group"}},e._l(e.swatches,function(t,r){return n("div",{key:r,staticClass:"vc-slider-swatch",attrs:{"data-index":r,"aria-label":"color:"+e.colors.hex,role:"button"},on:{click:function(n){e.handleSwClick(r,t)}}},[n("div",{staticClass:"vc-slider-swatch-picker",class:{"vc-slider-swatch-picker--active":t==e.activeOffset,"vc-slider-swatch-picker--white":"1"===t},style:{background:"hsl("+e.colors.hsl.h+", 50%, "+100*t+"%)"}})])}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(48)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(15),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(51),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Swatches.vue",t.default=d.exports},function(e,t,n){var r=n(49);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("10f839a2",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-swatches {\n  width: 320px;\n  height: 240px;\n  overflow-y: scroll;\n  background-color: #fff;\n  box-shadow: 0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16);\n}\n.vc-swatches-box {\n  padding: 16px 0 6px 16px;\n  overflow: hidden;\n}\n.vc-swatches-color-group {\n  padding-bottom: 10px;\n  width: 40px;\n  float: left;\n  margin-right: 10px;\n}\n.vc-swatches-color-it {\n  box-sizing: border-box;\n  width: 40px;\n  height: 24px;\n  cursor: pointer;\n  background: #880e4f;\n  margin-bottom: 1px;\n  overflow: hidden;\n  -ms-border-radius: 2px 2px 0 0;\n  -moz-border-radius: 2px 2px 0 0;\n  -o-border-radius: 2px 2px 0 0;\n  -webkit-border-radius: 2px 2px 0 0;\n  border-radius: 2px 2px 0 0;\n}\n.vc-swatches-color--white {\n  border: 1px solid #DDD;\n}\n.vc-swatches-pick {\n  fill: rgb(255, 255, 255);\n  margin-left: 8px;\n  display: block;\n}\n.vc-swatches-color--white .vc-swatches-pick {\n  fill: rgb(51, 51, 51);\n}\n",""])},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),n.d(t,"red",function(){return r}),n.d(t,"pink",function(){return a}),n.d(t,"purple",function(){return i}),n.d(t,"deepPurple",function(){return o}),n.d(t,"indigo",function(){return s}),n.d(t,"blue",function(){return c}),n.d(t,"lightBlue",function(){return l}),n.d(t,"cyan",function(){return u}),n.d(t,"teal",function(){return d}),n.d(t,"green",function(){return h}),n.d(t,"lightGreen",function(){return f}),n.d(t,"lime",function(){return p}),n.d(t,"yellow",function(){return v}),n.d(t,"amber",function(){return g}),n.d(t,"orange",function(){return b}),n.d(t,"deepOrange",function(){return x}),n.d(t,"brown",function(){return m}),n.d(t,"grey",function(){return _}),n.d(t,"blueGrey",function(){return w}),n.d(t,"darkText",function(){return C}),n.d(t,"lightText",function(){return y}),n.d(t,"darkIcons",function(){return k}),n.d(t,"lightIcons",function(){return F}),n.d(t,"white",function(){return A}),n.d(t,"black",function(){return S});var r={50:"#ffebee",100:"#ffcdd2",200:"#ef9a9a",300:"#e57373",400:"#ef5350",500:"#f44336",600:"#e53935",700:"#d32f2f",800:"#c62828",900:"#b71c1c",a100:"#ff8a80",a200:"#ff5252",a400:"#ff1744",a700:"#d50000"},a={50:"#fce4ec",100:"#f8bbd0",200:"#f48fb1",300:"#f06292",400:"#ec407a",500:"#e91e63",600:"#d81b60",700:"#c2185b",800:"#ad1457",900:"#880e4f",a100:"#ff80ab",a200:"#ff4081",a400:"#f50057",a700:"#c51162"},i={50:"#f3e5f5",100:"#e1bee7",200:"#ce93d8",300:"#ba68c8",400:"#ab47bc",500:"#9c27b0",600:"#8e24aa",700:"#7b1fa2",800:"#6a1b9a",900:"#4a148c",a100:"#ea80fc",a200:"#e040fb",a400:"#d500f9",a700:"#aa00ff"},o={50:"#ede7f6",100:"#d1c4e9",200:"#b39ddb",300:"#9575cd",400:"#7e57c2",500:"#673ab7",600:"#5e35b1",700:"#512da8",800:"#4527a0",900:"#311b92",a100:"#b388ff",a200:"#7c4dff",a400:"#651fff",a700:"#6200ea"},s={50:"#e8eaf6",100:"#c5cae9",200:"#9fa8da",300:"#7986cb",400:"#5c6bc0",500:"#3f51b5",600:"#3949ab",700:"#303f9f",800:"#283593",900:"#1a237e",a100:"#8c9eff",a200:"#536dfe",a400:"#3d5afe",a700:"#304ffe"},c={50:"#e3f2fd",100:"#bbdefb",200:"#90caf9",300:"#64b5f6",400:"#42a5f5",500:"#2196f3",600:"#1e88e5",700:"#1976d2",800:"#1565c0",900:"#0d47a1",a100:"#82b1ff",a200:"#448aff",a400:"#2979ff",a700:"#2962ff"},l={50:"#e1f5fe",100:"#b3e5fc",200:"#81d4fa",300:"#4fc3f7",400:"#29b6f6",500:"#03a9f4",600:"#039be5",700:"#0288d1",800:"#0277bd",900:"#01579b",a100:"#80d8ff",a200:"#40c4ff",a400:"#00b0ff",a700:"#0091ea"},u={50:"#e0f7fa",100:"#b2ebf2",200:"#80deea",300:"#4dd0e1",400:"#26c6da",500:"#00bcd4",600:"#00acc1",700:"#0097a7",800:"#00838f",900:"#006064",a100:"#84ffff",a200:"#18ffff",a400:"#00e5ff",a700:"#00b8d4"},d={50:"#e0f2f1",100:"#b2dfdb",200:"#80cbc4",300:"#4db6ac",400:"#26a69a",500:"#009688",600:"#00897b",700:"#00796b",800:"#00695c",900:"#004d40",a100:"#a7ffeb",a200:"#64ffda",a400:"#1de9b6",a700:"#00bfa5"},h={50:"#e8f5e9",100:"#c8e6c9",200:"#a5d6a7",300:"#81c784",400:"#66bb6a",500:"#4caf50",600:"#43a047",700:"#388e3c",800:"#2e7d32",900:"#1b5e20",a100:"#b9f6ca",a200:"#69f0ae",a400:"#00e676",a700:"#00c853"},f={50:"#f1f8e9",100:"#dcedc8",200:"#c5e1a5",300:"#aed581",400:"#9ccc65",500:"#8bc34a",600:"#7cb342",700:"#689f38",800:"#558b2f",900:"#33691e",a100:"#ccff90",a200:"#b2ff59",a400:"#76ff03",a700:"#64dd17"},p={50:"#f9fbe7",100:"#f0f4c3",200:"#e6ee9c",300:"#dce775",400:"#d4e157",500:"#cddc39",600:"#c0ca33",700:"#afb42b",800:"#9e9d24",900:"#827717",a100:"#f4ff81",a200:"#eeff41",a400:"#c6ff00",a700:"#aeea00"},v={50:"#fffde7",100:"#fff9c4",200:"#fff59d",300:"#fff176",400:"#ffee58",500:"#ffeb3b",600:"#fdd835",700:"#fbc02d",800:"#f9a825",900:"#f57f17",a100:"#ffff8d",a200:"#ffff00",a400:"#ffea00",a700:"#ffd600"},g={50:"#fff8e1",100:"#ffecb3",200:"#ffe082",300:"#ffd54f",400:"#ffca28",500:"#ffc107",600:"#ffb300",700:"#ffa000",800:"#ff8f00",900:"#ff6f00",a100:"#ffe57f",a200:"#ffd740",a400:"#ffc400",a700:"#ffab00"},b={50:"#fff3e0",100:"#ffe0b2",200:"#ffcc80",300:"#ffb74d",400:"#ffa726",500:"#ff9800",600:"#fb8c00",700:"#f57c00",800:"#ef6c00",900:"#e65100",a100:"#ffd180",a200:"#ffab40",a400:"#ff9100",a700:"#ff6d00"},x={50:"#fbe9e7",100:"#ffccbc",200:"#ffab91",300:"#ff8a65",400:"#ff7043",500:"#ff5722",600:"#f4511e",700:"#e64a19",800:"#d84315",900:"#bf360c",a100:"#ff9e80",a200:"#ff6e40",a400:"#ff3d00",a700:"#dd2c00"},m={50:"#efebe9",100:"#d7ccc8",200:"#bcaaa4",300:"#a1887f",400:"#8d6e63",500:"#795548",600:"#6d4c41",700:"#5d4037",800:"#4e342e",900:"#3e2723"},_={50:"#fafafa",100:"#f5f5f5",200:"#eeeeee",300:"#e0e0e0",400:"#bdbdbd",500:"#9e9e9e",600:"#757575",700:"#616161",800:"#424242",900:"#212121"},w={50:"#eceff1",100:"#cfd8dc",200:"#b0bec5",300:"#90a4ae",400:"#78909c",500:"#607d8b",600:"#546e7a",700:"#455a64",800:"#37474f",900:"#263238"},C={primary:"rgba(0, 0, 0, 0.87)",secondary:"rgba(0, 0, 0, 0.54)",disabled:"rgba(0, 0, 0, 0.38)",dividers:"rgba(0, 0, 0, 0.12)"},y={primary:"rgba(255, 255, 255, 1)",secondary:"rgba(255, 255, 255, 0.7)",disabled:"rgba(255, 255, 255, 0.5)",dividers:"rgba(255, 255, 255, 0.12)"},k={active:"rgba(0, 0, 0, 0.54)",inactive:"rgba(0, 0, 0, 0.38)"},F={active:"rgba(255, 255, 255, 1)",inactive:"rgba(255, 255, 255, 0.5)"},A="#ffffff",S="#000000";t.default={red:r,pink:a,purple:i,deepPurple:o,indigo:s,blue:c,lightBlue:l,cyan:u,teal:d,green:h,lightGreen:f,lime:p,yellow:v,amber:g,orange:b,deepOrange:x,brown:m,grey:_,blueGrey:w,darkText:C,lightText:y,darkIcons:k,lightIcons:F,white:A,black:S}},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-swatches",attrs:{role:"application","aria-label":"Swatches color picker","data-pick":e.pick}},[n("div",{staticClass:"vc-swatches-box",attrs:{role:"listbox"}},e._l(e.palette,function(t,r){return n("div",{key:r,staticClass:"vc-swatches-color-group"},e._l(t,function(t){return n("div",{key:t,class:["vc-swatches-color-it",{"vc-swatches-color--white":"#FFFFFF"===t}],style:{background:t},attrs:{role:"option","aria-label":"Color:"+t,"aria-selected":e.equal(t),"data-color":t},on:{click:function(n){e.handlerClick(t)}}},[n("div",{directives:[{name:"show",rawName:"v-show",value:e.equal(t),expression:"equal(c)"}],staticClass:"vc-swatches-pick"},[n("svg",{staticStyle:{width:"24px",height:"24px"},attrs:{viewBox:"0 0 24 24"}},[n("path",{attrs:{d:"M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"}})])])])}))}))])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(53)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(16),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(67),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Photoshop.vue",t.default=d.exports},function(e,t,n){var r=n(54);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("080365d4",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,'\n.vc-photoshop {\n  background: #DCDCDC;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15);\n  box-sizing: initial;\n  width: 513px;\n  font-family: Roboto;\n}\n.vc-photoshop__disable-fields {\n  width: 390px;\n}\n.vc-ps-head {\n  background-image: linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%);\n  border-bottom: 1px solid #B1B1B1;\n  box-shadow: inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02);\n  height: 23px;\n  line-height: 24px;\n  border-radius: 4px 4px 0 0;\n  font-size: 13px;\n  color: #4D4D4D;\n  text-align: center;\n}\n.vc-ps-body {\n  padding: 15px;\n  display: flex;\n}\n.vc-ps-saturation-wrap {\n  width: 256px;\n  height: 256px;\n  position: relative;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n  overflow: hidden;\n}\n.vc-ps-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-ps-hue-wrap {\n  position: relative;\n  height: 256px;\n  width: 19px;\n  margin-left: 10px;\n  border: 2px solid #B3B3B3;\n  border-bottom: 2px solid #F0F0F0;\n}\n.vc-ps-hue-pointer {\n  position: relative;\n}\n.vc-ps-hue-pointer--left,\n.vc-ps-hue-pointer--right {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 5px 0 5px 8px;\n  border-color: transparent transparent transparent #555;\n}\n.vc-ps-hue-pointer--left:after,\n.vc-ps-hue-pointer--right:after {\n  content: "";\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 4px 0 4px 6px;\n  border-color: transparent transparent transparent #fff;\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  transform: translate(-8px, -5px);\n}\n.vc-ps-hue-pointer--left {\n  transform: translate(-13px, -4px);\n}\n.vc-ps-hue-pointer--right {\n  transform: translate(20px, -4px) rotate(180deg);\n}\n.vc-ps-controls {\n  width: 180px;\n  margin-left: 10px;\n  display: flex;\n}\n.vc-ps-controls__disable-fields {\n  width: auto;\n}\n.vc-ps-actions {\n  margin-left: 20px;\n  flex: 1;\n}\n.vc-ps-ac-btn {\n  cursor: pointer;\n  background-image: linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%);\n  border: 1px solid #878787;\n  border-radius: 2px;\n  height: 20px;\n  box-shadow: 0 1px 0 0 #EAEAEA;\n  font-size: 14px;\n  color: #000;\n  line-height: 20px;\n  text-align: center;\n  margin-bottom: 10px;\n}\n.vc-ps-previews {\n  width: 60px;\n}\n.vc-ps-previews__swatches {\n  border: 1px solid #B3B3B3;\n  border-bottom: 1px solid #F0F0F0;\n  margin-bottom: 2px;\n  margin-top: 1px;\n}\n.vc-ps-previews__pr-color {\n  height: 34px;\n  box-shadow: inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000;\n}\n.vc-ps-previews__label {\n  font-size: 14px;\n  color: #000;\n  text-align: center;\n}\n.vc-ps-fields {\n  padding-top: 5px;\n  padding-bottom: 9px;\n  width: 80px;\n  position: relative;\n}\n.vc-ps-fields .vc-input__input {\n  margin-left: 40%;\n  width: 40%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 5px;\n  font-size: 13px;\n  padding-left: 3px;\n  margin-right: 10px;\n}\n.vc-ps-fields .vc-input__label, .vc-ps-fields .vc-input__desc {\n  top: 0;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n  position: absolute;\n}\n.vc-ps-fields .vc-input__label {\n  left: 0;\n  width: 34px;\n}\n.vc-ps-fields .vc-input__desc {\n  right: 0;\n  width: 0;\n}\n.vc-ps-fields__divider {\n  height: 5px;\n}\n.vc-ps-fields__hex .vc-input__input {\n  margin-left: 20%;\n  width: 80%;\n  height: 18px;\n  border: 1px solid #888888;\n  box-shadow: inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC;\n  margin-bottom: 6px;\n  font-size: 13px;\n  padding-left: 3px;\n}\n.vc-ps-fields__hex .vc-input__label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 14px;\n  text-transform: uppercase;\n  font-size: 13px;\n  height: 18px;\n  line-height: 22px;\n}\n',""])},function(e,t,n){var r=n(56);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("b5380e52",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-saturation,\n.vc-saturation--white,\n.vc-saturation--black {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.vc-saturation--white {\n  background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n}\n.vc-saturation--black {\n  background: linear-gradient(to top, #000, rgba(0,0,0,0));\n}\n.vc-saturation-pointer {\n  cursor: pointer;\n  position: absolute;\n}\n.vc-saturation-circle {\n  cursor: head;\n  width: 4px;\n  height: 4px;\n  box-shadow: 0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3), 0 0 1px 2px rgba(0,0,0,.4);\n  border-radius: 50%;\n  transform: translate(-2px, -2px);\n}\n",""])},function(e,t){function n(e,t,n){return t<n?e<t?t:e>n?n:e:e<n?n:e>t?t:e}e.exports=n},function(e,t,n){(function(t){function n(e,t,n){function r(t){var n=v,r=g;return v=g=void 0,k=t,x=e.apply(r,n)}function i(e){return k=e,m=setTimeout(u,t),F?r(e):x}function o(e){var n=e-_,r=e-k,a=t-n;return A?C(a,b-r):a}function l(e){var n=e-_,r=e-k;return void 0===_||n>=t||n<0||A&&r>=b}function u(){var e=y();if(l(e))return d(e);m=setTimeout(u,o(e))}function d(e){return m=void 0,S&&v?r(e):(v=g=void 0,x)}function h(){void 0!==m&&clearTimeout(m),k=0,v=_=g=m=void 0}function f(){return void 0===m?x:d(y())}function p(){var e=y(),n=l(e);if(v=arguments,g=this,_=e,n){if(void 0===m)return i(_);if(A)return m=setTimeout(u,t),r(_)}return void 0===m&&(m=setTimeout(u,t)),x}var v,g,b,x,m,_,k=0,F=!1,A=!1,S=!0;if("function"!=typeof e)throw new TypeError(c);return t=s(t)||0,a(n)&&(F=!!n.leading,A="maxWait"in n,b=A?w(s(n.maxWait)||0,t):b,S="trailing"in n?!!n.trailing:S),p.cancel=h,p.flush=f,p}function r(e,t,r){var i=!0,o=!0;if("function"!=typeof e)throw new TypeError(c);return a(r)&&(i="leading"in r?!!r.leading:i,o="trailing"in r?!!r.trailing:o),n(e,t,{leading:i,maxWait:t,trailing:o})}function a(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==typeof e}function o(e){return"symbol"==typeof e||i(e)&&_.call(e)==u}function s(e){if("number"==typeof e)return e;if(o(e))return l;if(a(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=a(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=f.test(e);return n||p.test(e)?v(e.slice(2),n?2:8):h.test(e)?l:+e}var c="Expected a function",l=NaN,u="[object Symbol]",d=/^\s+|\s+$/g,h=/^[-+]0x[0-9a-f]+$/i,f=/^0b[01]+$/i,p=/^0o[0-7]+$/i,v=parseInt,g="object"==typeof t&&t&&t.Object===Object&&t,b="object"==typeof self&&self&&self.Object===Object&&self,x=g||b||Function("return this")(),m=Object.prototype,_=m.toString,w=Math.max,C=Math.min,y=function(){return x.Date.now()};e.exports=r}).call(t,n(59))},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{ref:"container",staticClass:"vc-saturation",style:{background:e.bgColor},on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-saturation--white"}),e._v(" "),n("div",{staticClass:"vc-saturation--black"}),e._v(" "),n("div",{staticClass:"vc-saturation-pointer",style:{top:e.pointerTop,left:e.pointerLeft}},[n("div",{staticClass:"vc-saturation-circle"})])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){var r=n(62);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("4dc1b086",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-alpha {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-checkboard-wrap {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  overflow: hidden;\n}\n.vc-alpha-gradient {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n}\n.vc-alpha-container {\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n  height: 100%;\n  margin: 0 3px;\n}\n.vc-alpha-pointer {\n  z-index: 2;\n  position: absolute;\n}\n.vc-alpha-picker {\n  cursor: pointer;\n  width: 4px;\n  border-radius: 1px;\n  height: 8px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, .6);\n  background: #fff;\n  margin-top: 1px;\n  transform: translateX(-2px);\n}\n",""])},function(e,t,n){var r=n(64);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("7e15c05b",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-checkerboard {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  bottom: 0px;\n  left: 0px;\n  background-size: contain;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("div",{staticClass:"vc-checkerboard",style:e.bgStyle})},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"vc-alpha"},[n("div",{staticClass:"vc-alpha-checkboard-wrap"},[n("checkboard")],1),e._v(" "),n("div",{staticClass:"vc-alpha-gradient",style:{background:e.gradientColor}}),e._v(" "),n("div",{ref:"container",staticClass:"vc-alpha-container",on:{mousedown:e.handleMouseDown,touchmove:e.handleChange,touchstart:e.handleChange}},[n("div",{staticClass:"vc-alpha-pointer",style:{left:100*e.colors.a+"%"}},[n("div",{staticClass:"vc-alpha-picker"})])])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-photoshop",e.disableFields?"vc-photoshop__disable-fields":""],attrs:{role:"application","aria-label":"PhotoShop color picker"}},[n("div",{staticClass:"vc-ps-head",attrs:{role:"heading"}},[e._v(e._s(e.head))]),e._v(" "),n("div",{staticClass:"vc-ps-body"},[n("div",{staticClass:"vc-ps-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-ps-hue-wrap"},[n("hue",{attrs:{direction:"vertical"},on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}},[n("div",{staticClass:"vc-ps-hue-pointer"},[n("i",{staticClass:"vc-ps-hue-pointer--left"}),n("i",{staticClass:"vc-ps-hue-pointer--right"})])])],1),e._v(" "),n("div",{class:["vc-ps-controls",e.disableFields?"vc-ps-controls__disable-fields":""]},[n("div",{staticClass:"vc-ps-previews"},[n("div",{staticClass:"vc-ps-previews__label"},[e._v(e._s(e.newLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-previews__swatches"},[n("div",{staticClass:"vc-ps-previews__pr-color",style:{background:e.colors.hex},attrs:{"aria-label":"New color is "+e.colors.hex}}),e._v(" "),n("div",{staticClass:"vc-ps-previews__pr-color",style:{background:e.currentColor},attrs:{"aria-label":"Current color is "+e.currentColor},on:{click:e.clickCurrentColor}})]),e._v(" "),n("div",{staticClass:"vc-ps-previews__label"},[e._v(e._s(e.currentLabel))])]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-ps-actions"},[n("div",{staticClass:"vc-ps-ac-btn",attrs:{role:"button","aria-label":e.acceptLabel},on:{click:e.handleAccept}},[e._v(e._s(e.acceptLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-ac-btn",attrs:{role:"button","aria-label":e.cancelLabel},on:{click:e.handleCancel}},[e._v(e._s(e.cancelLabel))]),e._v(" "),n("div",{staticClass:"vc-ps-fields"},[n("ed-in",{attrs:{label:"h",desc:"°",value:e.hsv.h},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"s",desc:"%",value:e.hsv.s,max:100},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"v",desc:"%",value:e.hsv.v,max:100},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-ps-fields__divider"}),e._v(" "),n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}}),e._v(" "),n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}}),e._v(" "),n("div",{staticClass:"vc-ps-fields__divider"}),e._v(" "),n("ed-in",{staticClass:"vc-ps-fields__hex",attrs:{label:"#",value:e.hex},on:{change:e.inputChange}})],1),e._v(" "),e.hasResetButton?n("div",{staticClass:"vc-ps-ac-btn",attrs:{"aria-label":"reset"},on:{click:e.handleReset}},[e._v(e._s(e.resetLabel))]):e._e()])])])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(69)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(20),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(71),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Sketch.vue",t.default=d.exports},function(e,t,n){var r=n(70);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("612c6604",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-sketch {\n  position: relative;\n  width: 200px;\n  padding: 10px 10px 0;\n  box-sizing: initial;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, .15), 0 8px 16px rgba(0, 0, 0, .15);\n}\n.vc-sketch-saturation-wrap {\n  width: 100%;\n  padding-bottom: 75%;\n  position: relative;\n  overflow: hidden;\n}\n.vc-sketch-controls {\n  display: flex;\n}\n.vc-sketch-sliders {\n  padding: 4px 0;\n  flex: 1;\n}\n.vc-sketch-sliders .vc-hue,\n.vc-sketch-sliders .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-sketch-hue-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-sketch-alpha-wrap {\n  position: relative;\n  height: 10px;\n  margin-top: 4px;\n  overflow: hidden;\n}\n.vc-sketch-color-wrap {\n  width: 24px;\n  height: 24px;\n  position: relative;\n  margin-top: 4px;\n  margin-left: 4px;\n  border-radius: 3px;\n}\n.vc-sketch-active-color {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 2px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15), inset 0 0 4px rgba(0, 0, 0, .25);\n  z-index: 2;\n}\n.vc-sketch-color-wrap .vc-checkerboard {\n  background-size: auto;\n}\n.vc-sketch-field {\n  display: flex;\n  padding-top: 4px;\n}\n.vc-sketch-field .vc-input__input {\n  width: 90%;\n  padding: 4px 0 3px 10%;\n  border: none;\n  box-shadow: inset 0 0 0 1px #ccc;\n  font-size: 10px;\n}\n.vc-sketch-field .vc-input__label {\n  display: block;\n  text-align: center;\n  font-size: 11px;\n  color: #222;\n  padding-top: 3px;\n  padding-bottom: 4px;\n  text-transform: capitalize;\n}\n.vc-sketch-field--single {\n  flex: 1;\n  padding-left: 6px;\n}\n.vc-sketch-field--double {\n  flex: 2;\n}\n.vc-sketch-presets {\n  margin-right: -10px;\n  margin-left: -10px;\n  padding-left: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #eee;\n}\n.vc-sketch-presets-color {\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  display: inline-block;\n  margin: 0 10px 10px 0;\n  vertical-align: top;\n  cursor: pointer;\n  width: 16px;\n  height: 16px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);\n}\n.vc-sketch-presets-color .vc-checkerboard {\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, .15);\n  border-radius: 3px;\n}\n.vc-sketch__disable-alpha .vc-sketch-color-wrap {\n  height: 10px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-sketch",e.disableAlpha?"vc-sketch__disable-alpha":""],attrs:{role:"application","aria-label":"Sketch color picker"}},[n("div",{staticClass:"vc-sketch-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-controls"},[n("div",{staticClass:"vc-sketch-sliders"},[n("div",{staticClass:"vc-sketch-hue-wrap"},[n("hue",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-sketch-alpha-wrap"},[n("alpha",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1)]),e._v(" "),n("div",{staticClass:"vc-sketch-color-wrap"},[n("div",{staticClass:"vc-sketch-active-color",style:{background:e.activeColor},attrs:{"aria-label":"Current color is "+e.activeColor}}),e._v(" "),n("checkboard")],1)]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-sketch-field"},[n("div",{staticClass:"vc-sketch-field--double"},[n("ed-in",{attrs:{label:"hex",value:e.hex},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-sketch-field--single"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{staticClass:"vc-sketch-presets",attrs:{role:"group","aria-label":"A color preset, pick one to set as current color"}},[e._l(e.presetColors,function(t){return[e.isTransparent(t)?n("div",{key:t,staticClass:"vc-sketch-presets-color",attrs:{"aria-label":"Color:"+t},on:{click:function(n){e.handlePreset(t)}}},[n("checkboard")],1):n("div",{key:t,staticClass:"vc-sketch-presets-color",style:{background:t},attrs:{"aria-label":"Color:"+t},on:{click:function(n){e.handlePreset(t)}}})]})],2)])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i},function(e,t,n){"use strict";function r(e){c||n(73)}Object.defineProperty(t,"__esModule",{value:!0});var a=n(21),i=n.n(a);for(var o in a)"default"!==o&&function(e){n.d(t,e,function(){return a[e]})}(o);var s=n(75),c=!1,l=n(2),u=r,d=l(i.a,s.a,!1,u,null,null);d.options.__file="src/components/Chrome.vue",t.default=d.exports},function(e,t,n){var r=n(74);"string"==typeof r&&(r=[[e.i,r,""]]),r.locals&&(e.exports=r.locals);n(1)("1cd16048",r,!1,{})},function(e,t,n){t=e.exports=n(0)(!1),t.push([e.i,"\n.vc-chrome {\n  background: #fff;\n  border-radius: 2px;\n  box-shadow: 0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3);\n  box-sizing: initial;\n  width: 225px;\n  font-family: Menlo;\n  background-color: #fff;\n}\n.vc-chrome-controls {\n  display: flex;\n}\n.vc-chrome-color-wrap {\n  position: relative;\n  width: 36px;\n}\n.vc-chrome-active-color {\n  position: relative;\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  overflow: hidden;\n  z-index: 1;\n}\n.vc-chrome-color-wrap .vc-checkerboard {\n  width: 30px;\n  height: 30px;\n  border-radius: 15px;\n  background-size: auto;\n}\n.vc-chrome-sliders {\n  flex: 1;\n}\n.vc-chrome-fields-wrap {\n  display: flex;\n  padding-top: 16px;\n}\n.vc-chrome-fields {\n  display: flex;\n  margin-left: -6px;\n  flex: 1;\n}\n.vc-chrome-field {\n  padding-left: 6px;\n  width: 100%;\n}\n.vc-chrome-toggle-btn {\n  width: 32px;\n  text-align: right;\n  position: relative;\n}\n.vc-chrome-toggle-icon {\n  margin-right: -4px;\n  margin-top: 12px;\n  cursor: pointer;\n  position: relative;\n  z-index: 2;\n}\n.vc-chrome-toggle-icon-highlight {\n  position: absolute;\n  width: 24px;\n  height: 28px;\n  background: #eee;\n  border-radius: 4px;\n  top: 10px;\n  left: 12px;\n}\n.vc-chrome-hue-wrap {\n  position: relative;\n  height: 10px;\n  margin-bottom: 8px;\n}\n.vc-chrome-alpha-wrap {\n  position: relative;\n  height: 10px;\n}\n.vc-chrome-hue-wrap .vc-hue {\n  border-radius: 2px;\n}\n.vc-chrome-alpha-wrap .vc-alpha-gradient {\n  border-radius: 2px;\n}\n.vc-chrome-hue-wrap .vc-hue-picker, .vc-chrome-alpha-wrap .vc-alpha-picker {\n  width: 12px;\n  height: 12px;\n  border-radius: 6px;\n  transform: translate(-6px, -2px);\n  background-color: rgb(248, 248, 248);\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.vc-chrome-body {\n  padding: 16px 16px 12px;\n  background-color: #fff;\n}\n.vc-chrome-saturation-wrap {\n  width: 100%;\n  padding-bottom: 55%;\n  position: relative;\n  border-radius: 2px 2px 0 0;\n  overflow: hidden;\n}\n.vc-chrome-saturation-wrap .vc-saturation-circle {\n  width: 12px;\n  height: 12px;\n}\n.vc-chrome-fields .vc-input__input {\n  font-size: 11px;\n  color: #333;\n  width: 100%;\n  border-radius: 2px;\n  border: none;\n  box-shadow: inset 0 0 0 1px #dadada;\n  height: 21px;\n  text-align: center;\n}\n.vc-chrome-fields .vc-input__label {\n  text-transform: uppercase;\n  font-size: 11px;\n  line-height: 11px;\n  color: #969696;\n  text-align: center;\n  display: block;\n  margin-top: 12px;\n}\n.vc-chrome__disable-alpha .vc-chrome-active-color {\n  width: 18px;\n  height: 18px;\n}\n.vc-chrome__disable-alpha .vc-chrome-color-wrap {\n  width: 30px;\n}\n.vc-chrome__disable-alpha .vc-chrome-hue-wrap {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n",""])},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{class:["vc-chrome",e.disableAlpha?"vc-chrome__disable-alpha":""],attrs:{role:"application","aria-label":"Chrome color picker"}},[n("div",{staticClass:"vc-chrome-saturation-wrap"},[n("saturation",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-body"},[n("div",{staticClass:"vc-chrome-controls"},[n("div",{staticClass:"vc-chrome-color-wrap"},[n("div",{staticClass:"vc-chrome-active-color",style:{background:e.activeColor},attrs:{"aria-label":"current color is "+e.colors.hex}}),e._v(" "),e.disableAlpha?e._e():n("checkboard")],1),e._v(" "),n("div",{staticClass:"vc-chrome-sliders"},[n("div",{staticClass:"vc-chrome-hue-wrap"},[n("hue",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-alpha-wrap"},[n("alpha",{on:{change:e.childChange},model:{value:e.colors,callback:function(t){e.colors=t},expression:"colors"}})],1)])]),e._v(" "),e.disableFields?e._e():n("div",{staticClass:"vc-chrome-fields-wrap"},[n("div",{directives:[{name:"show",rawName:"v-show",value:0===e.fieldsIndex,expression:"fieldsIndex === 0"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[e.hasAlpha?e._e():n("ed-in",{attrs:{label:"hex",value:e.colors.hex},on:{change:e.inputChange}}),e._v(" "),e.hasAlpha?n("ed-in",{attrs:{label:"hex",value:e.colors.hex8},on:{change:e.inputChange}}):e._e()],1)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:1===e.fieldsIndex,expression:"fieldsIndex === 1"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"r",value:e.colors.rgba.r},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"g",value:e.colors.rgba.g},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"b",value:e.colors.rgba.b},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:2===e.fieldsIndex,expression:"fieldsIndex === 2"}],staticClass:"vc-chrome-fields"},[n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"h",value:e.hsl.h},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"s",value:e.hsl.s},on:{change:e.inputChange}})],1),e._v(" "),n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"l",value:e.hsl.l},on:{change:e.inputChange}})],1),e._v(" "),e.disableAlpha?e._e():n("div",{staticClass:"vc-chrome-field"},[n("ed-in",{attrs:{label:"a",value:e.colors.a,"arrow-offset":.01,max:1},on:{change:e.inputChange}})],1)]),e._v(" "),n("div",{staticClass:"vc-chrome-toggle-btn",attrs:{role:"button","aria-label":"Change another color definition"},on:{click:e.toggleViews}},[n("div",{staticClass:"vc-chrome-toggle-icon"},[n("svg",{staticStyle:{width:"24px",height:"24px"},attrs:{viewBox:"0 0 24 24"},on:{mouseover:e.showHighlight,mouseenter:e.showHighlight,mouseout:e.hideHighlight}},[n("path",{attrs:{fill:"#333",d:"M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"}})])]),e._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:e.highlight,expression:"highlight"}],staticClass:"vc-chrome-toggle-icon-highlight"})])])])])},a=[];r._withStripped=!0;var i={render:r,staticRenderFns:a};t.a=i}])});

/***/ }),

/***/ 761:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],attrs:{"fluid":"","grid-list-xl":"","text-xs-center":""}},[(_vm.isInstallerAccount())?_c('h1',{staticClass:"page-title display-1"},[_vm._v("\n    "+_vm._s(_vm.isNew() ? 'Crear nuevo instalador' : 'Detalles del instalador')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isCommerceAccount())?_c('h1',{staticClass:"page-title display-1"},[_vm._v("\n    "+_vm._s(_vm.isNew() ? 'Crear nuevo comercio' : 'Detalles del comercio')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isAdminAccount())?_c('h1',{staticClass:"page-title display-1"},[_vm._v("\n    "+_vm._s(_vm.isNew() ? 'Crear nuevo administrador' : 'Detalles del administrador')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isManagerAccount())?_c('h1',{staticClass:"page-title display-1"},[_vm._v("\n    "+_vm._s(_vm.isNew() ? 'Crear nuevo gerente' : 'Detalles del gerente')+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.isResponsibleAccount())?_c('h1',{staticClass:"page-title display-1"},[_vm._v("\n    "+_vm._s(_vm.isNew() ? 'Crear nuevo encargado' : 'Detalles del encargado')+"\n  ")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md5":"","lg5":"","xl5":""}},[_c('vuetify-avatar-card',{attrs:{"color":'primary',"avatar":_vm.avatar || {},"avatars":_vm.avatars || []},on:{"on-upload-error":_vm.onUploadError,"on-change-avatar":_vm.onChangeAvatar}},[_c('v-layout',{attrs:{"slot":"card-title","column":"","align-center":"","justify-center":""},slot:"card-title"},[_c('v-layout',{staticClass:"column avatar-info",attrs:{"align-center":"","justify-center":""}},[(_vm.isInstallerAccount() || _vm.isAdminAccount() || _vm.isSuperadminAccount())?_c('div',{staticClass:"headline"},[_vm._v("\n            "+_vm._s((_vm.name.value || '') + ' ' + (_vm.surname.value || ''))+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.isCommerceAccount())?_c('div',{staticClass:"headline"},[_vm._v("\n            "+_vm._s(_vm.name.value || '')+"\n          ")]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.username.value),expression:"username.value"}],staticClass:"section primary--text"},[_vm._v("@"+_vm._s(_vm.username.value))])])],1),_vm._v(" "),_c('visible-for',{attrs:{"slot":"card-text","superadmin":"","administrator":"","supervisor":"","installer":"","commerce":""},slot:"card-text"},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('v-tooltip',{attrs:{"top":""}},[(_vm.status.value < 3 && (_vm.isSuperadmin() || (_vm.isAdmin() && (!_vm.isAdminAccount() && !_vm.isSuperadminAccount()))))?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":parseInt(_vm.status.value) === 1 ? 'green' : 'gray'},nativeOn:{"click":function($event){_vm.onChangeStatus()}},slot:"activator"},[_c('v-icon',[_vm._v("account_circle")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Activar/desactivar usuario")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.status.value < 3 && _vm.isSuperadmin() && (_vm.isSuperadminAccount() || _vm.isAdminAccount()))?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":this.roles[this.rol.value - 1] === 'superadmin' ? 'orange' : 'gray'},nativeOn:{"click":function($event){_vm.onChangeRole()}},slot:"activator"},[_c('v-icon',[_vm._v("verified_user")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Asignar/desasignar rol superadmin")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.status.value < 3 && (_vm.isSuperadmin() || _vm.isAdmin()) && _vm.isCommerceAccount())?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":parseInt(_vm.calendar_visibility.value) === 1 ? 'green' : 'gray'},nativeOn:{"click":function($event){_vm.onChangeCalendarVisibility()}},slot:"activator"},[_c('v-icon',[_vm._v("calendar_today")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Mostrar/ocultar calendario de reservas")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(_vm.status.value < 3)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},nativeOn:{"click":function($event){_vm.renewPasswordDialog = true}},slot:"activator"},[_c('v-icon',[_vm._v("lock")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Cambiar contraseña")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"top":""}},[(false)?_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"red"},slot:"activator"},[_c('v-icon',[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Eliminar usuario")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[((_vm.isSuperadmin() || _vm.isAdmin()) && (_vm.isInstallerAccount() || _vm.isCommerceAccount()))?_c('div',{staticClass:"account-color",style:({ backgroundColor: _vm.formattedColor }),attrs:{"slot":"activator"},on:{"click":function($event){_vm.colorDialog = true}},slot:"activator"}):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Cambiar color")])])],1)])],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350px"},model:{value:(_vm.renewPasswordDialog),callback:function ($$v) {_vm.renewPasswordDialog=$$v},expression:"renewPasswordDialog"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Cambiar contraseña")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('vuetify-form-creator',{ref:"form_creator",attrs:{"columns":'xs12 sm12 md12 lg12',"items":_vm.password,"validate-on-changed":true},on:{"on-blur":_vm.onChange},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.renewPasswordDialog = false}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.changePassword()}}},[_vm._v("Cambiar")])],1)],1)],1),_vm._v(" "),_c('visible-for',{attrs:{"superadmin":"","administrator":"","supervisor":"","installer":""}},[(_vm.isInstallerAccount())?_c('vuetify-schedule-selector',{attrs:{"slot":"content","color":'primary',"toolbar-title":'Disponibilidad',"schedules":_vm.schedules || [],"value":_vm.schedules},on:{"update:value":function($event){_vm.schedules=$event},"on-add-schedule":_vm.addInstallerSchedule,"on-delete-schedule":_vm.deleteInstallerSchedule},slot:"content"}):_vm._e()],1),_vm._v(" "),_c('visible-for',{attrs:{"superadmin":"","administrator":"","supervisor":"","installer":""}},[(_vm.isInstallerAccount())?_c('vuetify-area-aggregator',{attrs:{"slot":"content","color":'primary',"toolbar-title":'Áreas',"list-title":'Agregar área',"add-button-hover-text":'Pulsa para agregar una nueva área',"dialog-max-width":670,"dialog-toolbar-title":'Agregar área',"dialog-confirm-headline":'Eliminar área',"dialog-confirm-text":'¿Seguro que quieres eliminar esta área?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"delete-icon-hover-text":'Pulsa para eliminar',"location-icon-hover-text":'Ver localización en Google',"areas":_vm.areas || {},"value":_vm.areas},on:{"update:value":function($event){_vm.areas=$event},"on-add-area":_vm.addInstallerArea,"on-delete-area":_vm.deleteInstallerArea},slot:"content"}):_vm._e()],1),_vm._v(" "),_c('vuetify-phone-aggregator',{attrs:{"color":'primary',"toolbar-title":'Teléfonos',"list-title":'Agregar teléfono',"add-button-hover-text":'Pulsa para agregar un nuevo teléfono',"dialog-max-width":450,"dialog-toolbar-title":'Agregar teléfono',"text-field-label":'Teléfono',"text-field-rules":_vm.phone.rules,"select-label":'Tipo',"dialog-confirm-headline":'Eliminar teléfono',"dialog-confirm-text":'¿Seguro que quieres eliminar este teléfono?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"delete-button":((_vm.isManager() || _vm.isResponsible()) ? (_vm.isHisAccount() ? true : false) : true),"navigation-menu":((_vm.isManager() || _vm.isResponsible()) ? (_vm.isHisAccount() ? true : false) : true),"delete-icon-hover-text":'Pulsa para eliminar',"phone-types":_vm.phone.types,"phones":_vm.phone.value || [],"value":_vm.phone.value},on:{"update:value":function($event){_vm.$set(_vm.phone, "value", $event)},"on-add-phone":_vm.onChangePhone,"on-delete-phone":_vm.onChangePhone}}),_vm._v(" "),_c('visible-for',{attrs:{"superadmin":"","administrator":""}},[(_vm.isResponsibleAccount())?_c('vuetify-commerce-aggregator',{attrs:{"slot":"content","color":'primary',"toolbar-title":'Comercios',"list-title":'Agregar comercio',"add-button-hover-text":'Pulsa para agregar un nuevo comercio',"dialog-max-width":400,"dialog-toolbar-title":'Agregar comercio',"dialog-confirm-headline":'Eliminar comercio',"dialog-confirm-text":'¿Seguro que quieres eliminar este comercio?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"delete-icon-hover-text":'Pulsa para eliminar',"location-icon-hover-text":'Ver localización en Google',"commerces":_vm.assignedCommerces || [],"commerces-list":_vm.commercesList,"value":_vm.assignedCommerces},on:{"update:value":function($event){_vm.assignedCommerces=$event},"on-add-commerce":_vm.changeCommerces,"on-delete-commerce":_vm.changeCommerces},slot:"content"}):_vm._e()],1),_vm._v(" "),_c('visible-for',{attrs:{"superadmin":"","administrator":"","supervisor":"","commerce":"","manager":""}},[(_vm.isCommerceAccount())?_c('vuetify-user-aggregator',{attrs:{"slot":"content","color":'primary',"toolbar-title":'Vendedores',"list-title":'Agregar vendedor',"add-button-hover-text":'Pulsa para agregar un nuevo vendedor',"dialog-max-width":450,"dialog-toolbar-title":'Agregar vendedor',"no-data-text":'Vendedor',"text-field-label":'Vendedor',"text-field-rules":[],"select-label":'Tipo',"dialog-confirm-headline":'Eliminar vendedor',"dialog-confirm-text":'¿Seguro que quieres eliminar este vendedor?',"cancel-button":'Cancelar',"delete-button":!_vm.isManager() && !_vm.isResponsible(),"navigation-menu":!_vm.isManager() && !_vm.isResponsible(),"confirm-button":'Confirmar',"delete-icon-hover-text":'Pulsa para eliminar',"users":_vm.sellers || [],"value":_vm.sellers},on:{"update:value":function($event){_vm.sellers=$event},"on-add-user":_vm.addCommerceSeller,"on-delete-user":_vm.deleteCommerceSeller},slot:"content"}):_vm._e()],1),_vm._v(" "),(!_vm.isNew() && (_vm.isSuperadmin() || _vm.isAdmin()) && parseInt(this.$store.getters['api/getUserId']) !== parseInt(_vm.userID.value))?_c('vuetify-user-observation-aggregator',{ref:"observation_aggregator",attrs:{"color":'primary',"toolbar-title":'Observaciones',"list-title":'Agregar observación',"add-button-hover-text":'Pulsa para agregar una nueva observación',"dialog-max-width":450,"dialog-toolbar-title":'Agregar ',"delete-button":(_vm.isSuperadmin() || _vm.isAdmin()),"text-field-label":'Título',"text-field-rules":_vm.observation.rules,"select-label":'Tipo',"dialog-confirm-headline":'Eliminar observación',"dialog-confirm-text":'¿Seguro que quieres eliminar esta observación?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"delete-icon-hover-text":'Pulsa para eliminar',"observations":_vm.observation.items || [],"value":_vm.observation.value},on:{"update:value":function($event){_vm.$set(_vm.observation, "value", $event)},"on-add-observation":_vm.onAddObservation,"on-delete-observation":_vm.deleteObservation}}):_vm._e(),_vm._v(" "),_c('visible-for',{attrs:{"superadmin":"","administrator":"","supervisor":""}},[_c('vuetify-user-aggregator',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCommerceAccount() && (_vm.isSuperadmin() || _vm.isAdmin())),expression:"isCommerceAccount() && (isSuperadmin() || isAdmin())"}],attrs:{"slot":"content","color":'primary',"toolbar-title":'Instaladores',"list-title":'Agregar instalador',"add-button-hover-text":'Pulsa para agregar un nuevo instalador',"dialog-max-width":450,"dialog-toolbar-title":'Agregar instalador',"text-field-label":'Instalador',"text-field-rules":[],"select-label":'Tipo',"hidden-menu-when-no-options":true,"dialog-confirm-headline":'Eliminar instalador',"no-data-text":'Vendedor',"dialog-confirm-text":'¿Seguro que quieres eliminar este instalador?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"add-on-enter":true,"return-object":true,"delete-icon-hover-text":'Pulsa para eliminar',"users":_vm.installers.items || [],"value":_vm.installers.items,"users-list":_vm.installersList},on:{"update:value":function($event){_vm.$set(_vm.installers, "items", $event)},"on-add-user":_vm.addCommerceInstaller,"on-delete-user":_vm.deleteCommerceInstaller},slot:"content"})],1),_vm._v(" "),(!_vm.isAdminAccount() && !_vm.isSuperadminAccount() && !_vm.isManagerAccount() && !_vm.isResponsibleAccount())?_c('vuetify-signature-aggregator',{attrs:{"color":'primary',"toolbar-title":'Firma',"list-title":'Agregar firma',"navigation-menu":!_vm.isManager() && !_vm.isResponsible(),"add-button-hover-text":'Pulsa para agregar una nueva firma',"dialog-max-width":670,"dialog-toolbar-title":'Agregar firma',"dialog-confirm-headline":'Eliminar firma',"dialog-confirm-text":'¿Seguro que quieres eliminar esta firma?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"upload-icon-hover-text":'Subir imagen de 400 x 200 píxeles en formato PNG',"clear-icon-hover-text":'Limpiar firma',"save-icon-hover-text":'Guardar firma',"delete-icon-hover-text":'Eliminar',"options":_vm.signature || {},"value":_vm.signature.value},on:{"update:value":function($event){_vm.$set(_vm.signature, "value", $event)},"on-upload-error":_vm.onUploadError,"on-add-signature":_vm.onChangeSignature,"on-delete-signature":_vm.onChangeSignature}}):_vm._e(),_vm._v(" "),(_vm.isInstallerAccount())?_c('vuetify-signature-aggregator',{attrs:{"color":'primary',"toolbar-title":'Sello',"list-title":'Agregar sello',"add-button-hover-text":'Pulsa para agregar un nuevo sello',"dialog-max-width":670,"dialog-toolbar-title":'Agregar sello',"dialog-confirm-headline":'Eliminar sello',"dialog-confirm-text":'¿Seguro que quieres eliminar este sello?',"cancel-button":'Cancelar',"confirm-button":'Confirmar',"upload-icon-hover-text":'Subir imagen de 400 x 200 píxeles en formato PNG',"clear-icon-hover-text":'Limpiar sello',"save-icon-hover-text":'Guardar sello',"delete-icon-hover-text":'Eliminar',"options":_vm.stamp || {},"value":_vm.stamp.value},on:{"update:value":function($event){_vm.$set(_vm.stamp, "value", $event)},"on-upload-error":_vm.onUploadError,"on-add-signature":_vm.onChangeStamp,"on-delete-signature":_vm.onChangeStamp}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md7":"","lg7":"","xl7":""}},[_c('visible-for',{attrs:{"superadmin":"","administrator":"","supervisor":"","installer":"","commerce":"","manager":""}},[_c('vuetify-editable-form-card',{ref:"account",attrs:{"slot":"content","color":'primary',"toolbar-title":'Cuenta',"items":_vm.account},on:{"on-change":_vm.onChange},slot:"content"})],1),_vm._v(" "),_c('vuetify-editable-form-card',{ref:"fields",attrs:{"color":'primary',"toolbar-title":_vm.getUserRol(_vm.rol.value) || '',"items":_vm.fields},on:{"on-change":_vm.onChange}}),_vm._v(" "),(_vm.isInstallerAccount())?_c('visible-for',{attrs:{"superadmin":"","administrator":"","supervisor":"","installer":""}},[_c('vuetify-editable-form-card',{ref:"company",attrs:{"slot":"content","color":'primary',"toolbar-title":'Empresa',"items":_vm.company},on:{"on-change":_vm.onChange},slot:"content"})],1):_vm._e(),_vm._v(" "),(_vm.isCommerceAccount() || _vm.isManagerAccount())?_c('visible-for',{attrs:{"superadmin":"","administrator":"","supervisor":"","commerce":"","manager":""}},[((_vm.isSuperadmin() || _vm.isAdmin()))?_c('vuetify-editable-form-card',{ref:"corporation",attrs:{"slot":"content","color":'primary',"toolbar-title":'Empresa',"items":_vm.corporation},on:{"on-add-item":_vm.onAddItem,"on-change":_vm.onChange},slot:"content"}):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.isAdminAccount() && !_vm.isSuperadminAccount() && !_vm.isManagerAccount() && !_vm.isResponsibleAccount())?_c('vuetify-editable-address-card',{ref:"route",attrs:{"color":'primary',"toolbar-title":'Dirección de la empresa',"dialog-toolbar-title":'Agregar dirección',"placeholder":'Escribe tu dirección',"list-title":'Agregar dirección',"navigation-menu":!_vm.isManager() && !_vm.isResponsible(),"route":_vm.route,"routeExtras":_vm.routeExtras,"postalCode":_vm.postalCode,"locality":_vm.locality,"province":_vm.province},on:{"on-change":_vm.onChange}}):_vm._e()],1),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""}},[((_vm.isSuperadmin() || _vm.isAdmin()) && parseInt(_vm.status.value) === 3)?_c('v-btn',{attrs:{"slot":"activator","dark":"","fab":"","fixed":"","bottom":"","left":"","color":"red"},on:{"click":function($event){_vm.isInstallerAccount() ? _vm.returnToInstallers() : (_vm.isCommerceAccount() ? _vm.returnToCommerce() : (_vm.isManagerAccount() ? _vm.returnToManager() : (_vm.isResponsibleAccount() ? _vm.returnToResponsible() : _vm.returnToAdmin())))}},slot:"activator"},[_c('v-icon',[_vm._v("arrow_back")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Salir sin guardar")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[(_vm.status.value > 2)?_c('v-btn',{attrs:{"slot":"activator","dark":"","fab":"","fixed":"","bottom":"","right":"","color":"green"},on:{"click":function($event){_vm.isInstallerAccount() ? _vm.validateInstaller() : (_vm.isCommerceAccount() ? _vm.validateCommerce() : (_vm.isManagerAccount() ? _vm.validateManager() : (_vm.isResponsibleAccount() ? _vm.validateResponsible() : _vm.validateAdmin())))}},slot:"activator"},[_c('v-icon',[_vm._v("check")])],1):_vm._e(),_vm._v(" "),_c('span',[_vm._v("Guardar")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":_vm.isCommerceAccount() ? '350' : '77'},model:{value:(_vm.colorDialog),callback:function ($$v) {_vm.colorDialog=$$v},expression:"colorDialog"}},[(_vm.isCommerceAccount())?_c('chrome-picker',{on:{"input":_vm.updateColor},model:{value:(_vm.colors),callback:function ($$v) {_vm.colors=$$v},expression:"colors"}}):_c('v-card',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(213, 0, 0, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(213, 0, 0, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Tomate")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(230, 124, 115, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(230, 124, 115, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Rosa chicle")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(244, 81, 30, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(244, 81, 30, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Mandarina")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(246, 191, 38, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(246, 191, 38, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Amarillo huevo")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(51, 182, 121, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(51, 182, 121, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Verde esmeralda")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(11, 128, 67, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(11, 128, 67, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Verde musgo")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(3, 155, 229, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(3, 155, 229, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Azul turquesa")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(63, 81, 181, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(63, 81, 181, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Azul arándano")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(121, 134, 203, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(121, 134, 203, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Lavanda")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(142, 36, 170, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(142, 36, 170, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Morado intenso")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{staticClass:"mx-2 color-pick",style:({ backgroundColor: 'rgba(97, 97, 97, 1)' }),attrs:{"slot":"activator","fab":"","dark":"","small":""},on:{"click":function($event){_vm.updateColor('rgba(97, 97, 97, 1)')}},slot:"activator"}),_vm._v(" "),_c('span',[_vm._v("Grafito")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.495e3cc1c1de039a9aa2.js